// /!\ THIS FILE IS AUTOMATICALLY GENERATED, DO NOT EDIT /!\
/* tslint:disable */
import { executeQuery } from 'common-front/src/components/graphql/graphql';
import {
    IUseMutationOptions,
    IUseMutationReturns,
    IUseQueryReturns
} from 'common/src/util/graphql/types';
import { useMutation, useQuery } from 'common/src/util/dependencies/dependencies';

import AccreditationCreate from '../accreditations/create/accreditationCreate.graphql';
import {
    AccreditationCreateMutation,
    AccreditationCreateMutationVariables
} from 'common/src/generated/types';
import AccreditationEventInfos from '../accreditations/create/accreditationEventInfos.graphql';
import {
    AccreditationEventInfosQuery,
    AccreditationEventInfosQueryVariables
} from 'common/src/generated/types';
import AccreditationToEdit from '../accreditations/create/accreditationToEdit.graphql';
import {
    AccreditationToEditQuery,
    AccreditationToEditQueryVariables
} from 'common/src/generated/types';
import AccreditationUpdate from '../accreditations/create/accreditationUpdate.graphql';
import {
    AccreditationUpdateMutation,
    AccreditationUpdateMutationVariables
} from 'common/src/generated/types';
import Accreditations from '../accreditations/list/accreditations.graphql';
import { AccreditationsQuery, AccreditationsQueryVariables } from 'common/src/generated/types';
import AccreditationsAccreditation from '../accreditations/list/accreditationsAccreditation.graphql';
import {
    AccreditationsAccreditationQuery,
    AccreditationsAccreditationQueryVariables
} from 'common/src/generated/types';
import AccreditationsCategories from '../accreditations/list/accreditationsCategories.graphql';
import {
    AccreditationsCategoriesQuery,
    AccreditationsCategoriesQueryVariables
} from 'common/src/generated/types';
import AccreditationsMassDelete from '../accreditations/list/accreditationsMassDelete.graphql';
import {
    AccreditationsMassDeleteMutation,
    AccreditationsMassDeleteMutationVariables
} from 'common/src/generated/types';
import AccreditationsSegments from '../accreditations/list/accreditationsSegments.graphql';
import {
    AccreditationsSegmentsQuery,
    AccreditationsSegmentsQueryVariables
} from 'common/src/generated/types';
import AccreditationMap from '../accreditations/map/accreditationMap.graphql';
import { AccreditationMapQuery, AccreditationMapQueryVariables } from 'common/src/generated/types';
import Accreditation from '../accreditations/show/accreditation.graphql';
import { AccreditationQuery, AccreditationQueryVariables } from 'common/src/generated/types';
import AccreditationChart from '../accreditations/show/cards/accreditationChartCard/accreditationChart.graphql';
import {
    AccreditationChartQuery,
    AccreditationChartQueryVariables
} from 'common/src/generated/types';
import AccreditationSlotDelete from '../accreditations/show/cards/accreditationSlotsCard/accreditationSlotDelete.graphql';
import {
    AccreditationSlotDeleteMutation,
    AccreditationSlotDeleteMutationVariables
} from 'common/src/generated/types';
import AccreditationSlots from '../accreditations/show/cards/accreditationSlotsCard/accreditationSlots.graphql';
import {
    AccreditationSlotsQuery,
    AccreditationSlotsQueryVariables
} from 'common/src/generated/types';
import AccreditationDashboard from '../accreditations/show/dashboard/accreditationDashboard.graphql';
import {
    AccreditationDashboardQuery,
    AccreditationDashboardQueryVariables
} from 'common/src/generated/types';
import AccreditInfos from '../accreditationsAssignments/accredit/accreditInfos.graphql';
import { AccreditInfosQuery, AccreditInfosQueryVariables } from 'common/src/generated/types';
import AccreditSlots from '../accreditationsAssignments/accredit/accreditSlots.graphql';
import { AccreditSlotsQuery, AccreditSlotsQueryVariables } from 'common/src/generated/types';
import AccreditationsAssignmentsEmails from '../accreditationsAssignments/list/accreditationsAssignmentsEmails.graphql';
import {
    AccreditationsAssignmentsEmailsQuery,
    AccreditationsAssignmentsEmailsQueryVariables
} from 'common/src/generated/types';
import AccreditationsAssignmentsKpis from '../accreditationsAssignments/list/accreditationsAssignmentsKpis.graphql';
import {
    AccreditationsAssignmentsKpisQuery,
    AccreditationsAssignmentsKpisQueryVariables
} from 'common/src/generated/types';
import AccreditationsEmailsEstimate from '../accreditationsAssignments/list/accreditationsEmailsEstimate.graphql';
import {
    AccreditationsEmailsEstimateMutation,
    AccreditationsEmailsEstimateMutationVariables
} from 'common/src/generated/types';
import SendAccreditationsEmails from '../accreditationsAssignments/list/sendAccreditationsEmails.graphql';
import {
    SendAccreditationsEmailsMutation,
    SendAccreditationsEmailsMutationVariables
} from 'common/src/generated/types';
import AccreditationCategoryCreate from '../accreditationsCategories/create/accreditationCategoryCreate.graphql';
import {
    AccreditationCategoryCreateMutation,
    AccreditationCategoryCreateMutationVariables
} from 'common/src/generated/types';
import AccreditationCategoryUpdate from '../accreditationsCategories/create/accreditationCategoryUpdate.graphql';
import {
    AccreditationCategoryUpdateMutation,
    AccreditationCategoryUpdateMutationVariables
} from 'common/src/generated/types';
import AccreditationCategoryDelete from '../accreditationsCategories/delete/accreditationCategoryDelete.graphql';
import {
    AccreditationCategoryDeleteMutation,
    AccreditationCategoryDeleteMutationVariables
} from 'common/src/generated/types';
import AccreditationCategoryDuplicate from '../accreditationsCategories/show/accreditationCategoryDuplicate.graphql';
import {
    AccreditationCategoryDuplicateMutation,
    AccreditationCategoryDuplicateMutationVariables
} from 'common/src/generated/types';
import AccreditationsCategory from '../accreditationsCategories/show/accreditationsCategory.graphql';
import {
    AccreditationsCategoryQuery,
    AccreditationsCategoryQueryVariables
} from 'common/src/generated/types';
import AccreditationsCategoryAccreditations from '../accreditationsCategories/show/cards/accreditationsCategoryAccreditationsCard/accreditationsCategoryAccreditations.graphql';
import {
    AccreditationsCategoryAccreditationsQuery,
    AccreditationsCategoryAccreditationsQueryVariables
} from 'common/src/generated/types';
import AccreditationsCategoryChart from '../accreditationsCategories/show/cards/accreditationsCategoryChartCard/accreditationsCategoryChart.graphql';
import {
    AccreditationsCategoryChartQuery,
    AccreditationsCategoryChartQueryVariables
} from 'common/src/generated/types';
import AccreditationSlotUpdate from '../accreditationsSlots/accreditationSlotUpdate.graphql';
import {
    AccreditationSlotUpdateMutation,
    AccreditationSlotUpdateMutationVariables
} from 'common/src/generated/types';
import AccreditationsAccreditationSlot from '../accreditationsSlots/list/accreditationsAccreditationSlot.graphql';
import {
    AccreditationsAccreditationSlotQuery,
    AccreditationsAccreditationSlotQueryVariables
} from 'common/src/generated/types';
import AccreditationsSlotsList from '../accreditationsSlots/list/accreditationsSlotsList.graphql';
import {
    AccreditationsSlotsListQuery,
    AccreditationsSlotsListQueryVariables
} from 'common/src/generated/types';
import AccreditationsSlot from '../accreditationsSlots/show/accreditationsSlot.graphql';
import {
    AccreditationsSlotQuery,
    AccreditationsSlotQueryVariables
} from 'common/src/generated/types';
import AccreditationsSlotMembers from '../accreditationsSlots/show/cards/accreditationsSlotMembersCard/accreditationsSlotMembers.graphql';
import {
    AccreditationsSlotMembersQuery,
    AccreditationsSlotMembersQueryVariables
} from 'common/src/generated/types';
import AssignmentInfos from '../assignments/assign/assignmentInfos.graphql';
import { AssignmentInfosQuery, AssignmentInfosQueryVariables } from 'common/src/generated/types';
import AssignmentSlots from '../assignments/assign/assignmentSlots.graphql';
import { AssignmentSlotsQuery, AssignmentSlotsQueryVariables } from 'common/src/generated/types';
import VolunteerRegistrationAssignmentRefuse from '../assignments/assign/volunteerRegistrationAssignmentRefuse.graphql';
import {
    VolunteerRegistrationAssignmentRefuseMutation,
    VolunteerRegistrationAssignmentRefuseMutationVariables
} from 'common/src/generated/types';
import AssignmentsEmails from '../assignments/list/assignmentsEmails.graphql';
import {
    AssignmentsEmailsQuery,
    AssignmentsEmailsQueryVariables
} from 'common/src/generated/types';
import AssignmentsEmailsEstimate from '../assignments/list/assignmentsEmailsEstimate.graphql';
import {
    AssignmentsEmailsEstimateMutation,
    AssignmentsEmailsEstimateMutationVariables
} from 'common/src/generated/types';
import AssignmentsKpis from '../assignments/list/assignmentsKpis.graphql';
import { AssignmentsKpisQuery, AssignmentsKpisQueryVariables } from 'common/src/generated/types';
import PreAssignmentsKpis from '../assignments/list/preAssignmentsKpis.graphql';
import {
    PreAssignmentsKpisQuery,
    PreAssignmentsKpisQueryVariables
} from 'common/src/generated/types';
import SendAssignmentsEmails from '../assignments/list/sendAssignmentsEmails.graphql';
import {
    SendAssignmentsEmailsMutation,
    SendAssignmentsEmailsMutationVariables
} from 'common/src/generated/types';
import SendEmailInfos from '../assignments/list/sendEmailInfos.graphql';
import { SendEmailInfosQuery, SendEmailInfosQueryVariables } from 'common/src/generated/types';
import TeamAssign from '../assignments/teamAssignment/teamAssign.graphql';
import { TeamAssignMutation, TeamAssignMutationVariables } from 'common/src/generated/types';
import TeamAssignmentInfos from '../assignments/teamAssignment/teamAssignmentInfos.graphql';
import {
    TeamAssignmentInfosQuery,
    TeamAssignmentInfosQueryVariables
} from 'common/src/generated/types';
import TeamAssignmentRefuse from '../assignments/teamAssignment/teamAssignmentRefuse.graphql';
import {
    TeamAssignmentRefuseMutation,
    TeamAssignmentRefuseMutationVariables
} from 'common/src/generated/types';
import TeamAssignmentWaitingTeams from '../assignments/teamAssignment/teamAssignmentWaitingTeams.graphql';
import {
    TeamAssignmentWaitingTeamsQuery,
    TeamAssignmentWaitingTeamsQueryVariables
} from 'common/src/generated/types';
import Tokens from '../auth/tokens.graphql';
import { TokensQuery, TokensQueryVariables } from 'common/src/generated/types';
import BackofficeInvoiceMarkAsPaid from '../backoffice/invoices/backofficeInvoiceMarkAsPaid.graphql';
import {
    BackofficeInvoiceMarkAsPaidMutation,
    BackofficeInvoiceMarkAsPaidMutationVariables
} from 'common/src/generated/types';
import BackofficeInvoices from '../backoffice/invoices/backofficeInvoices.graphql';
import {
    BackofficeInvoicesQuery,
    BackofficeInvoicesQueryVariables
} from 'common/src/generated/types';
import QontoTransactions from '../backoffice/invoices/qontoTransactions.graphql';
import {
    QontoTransactionsQuery,
    QontoTransactionsQueryVariables
} from 'common/src/generated/types';
import BackofficeOrganizationUserAdd from '../backoffice/organizations/list/backofficeOrganizationUserAdd.graphql';
import {
    BackofficeOrganizationUserAddMutation,
    BackofficeOrganizationUserAddMutationVariables
} from 'common/src/generated/types';
import BackofficeOrganizationUserRemove from '../backoffice/organizations/list/backofficeOrganizationUserRemove.graphql';
import {
    BackofficeOrganizationUserRemoveMutation,
    BackofficeOrganizationUserRemoveMutationVariables
} from 'common/src/generated/types';
import BackofficeOrganizations from '../backoffice/organizations/list/backofficeOrganizations.graphql';
import {
    BackofficeOrganizationsQuery,
    BackofficeOrganizationsQueryVariables
} from 'common/src/generated/types';
import BackofficeEventUnarchive from '../backoffice/organizations/update/backofficeEventUnarchive.graphql';
import {
    BackofficeEventUnarchiveMutation,
    BackofficeEventUnarchiveMutationVariables
} from 'common/src/generated/types';
import BackofficeEvent from '../backoffice/organizations/update/backofficeEvents.graphql';
import { BackofficeEventQuery, BackofficeEventQueryVariables } from 'common/src/generated/types';
import BackofficeOrganization from '../backoffice/organizations/update/backofficeOrganization.graphql';
import {
    BackofficeOrganizationQuery,
    BackofficeOrganizationQueryVariables
} from 'common/src/generated/types';
import BackofficeOrganizationUpdate from '../backoffice/organizations/update/backofficeOrganizationUpdate.graphql';
import {
    BackofficeOrganizationUpdateMutation,
    BackofficeOrganizationUpdateMutationVariables
} from 'common/src/generated/types';
import CampaignEventAccreditationsRecipients from '../campaigns/create/recipients/campaignEventAccreditationsRecipients.graphql';
import {
    CampaignEventAccreditationsRecipientsQuery,
    CampaignEventAccreditationsRecipientsQueryVariables
} from 'common/src/generated/types';
import CampaignEventPositionsRecipients from '../campaigns/create/recipients/campaignEventPositionsRecipients.graphql';
import {
    CampaignEventPositionsRecipientsQuery,
    CampaignEventPositionsRecipientsQueryVariables
} from 'common/src/generated/types';
import CampaignEventSegmentsRecipients from '../campaigns/create/recipients/campaignEventSegmentsRecipients.graphql';
import {
    CampaignEventSegmentsRecipientsQuery,
    CampaignEventSegmentsRecipientsQueryVariables
} from 'common/src/generated/types';
import CampaignOrganizationSegmentsRecipients from '../campaigns/create/recipients/campaignOrganizationSegmentsRecipients.graphql';
import {
    CampaignOrganizationSegmentsRecipientsQuery,
    CampaignOrganizationSegmentsRecipientsQueryVariables
} from 'common/src/generated/types';
import CampaignDelete from '../campaigns/list/campaignDelete.graphql';
import {
    CampaignDeleteMutation,
    CampaignDeleteMutationVariables
} from 'common/src/generated/types';
import CampaignDuplicate from '../campaigns/list/campaignDuplicate.graphql';
import {
    CampaignDuplicateMutation,
    CampaignDuplicateMutationVariables
} from 'common/src/generated/types';
import CampaignSend from '../campaigns/list/campaignSend.graphql';
import { CampaignSendMutation, CampaignSendMutationVariables } from 'common/src/generated/types';
import Campaigns from '../campaigns/list/campaigns.graphql';
import { CampaignsQuery, CampaignsQueryVariables } from 'common/src/generated/types';
import Campaign from '../campaigns/show/campaign.graphql';
import { CampaignQuery, CampaignQueryVariables } from 'common/src/generated/types';
import CampaignEmails from '../campaigns/show/campaignEmails.graphql';
import { CampaignEmailsQuery, CampaignEmailsQueryVariables } from 'common/src/generated/types';
import CampaignPreview from '../campaigns/show/campaignPreview.graphql';
import { CampaignPreviewQuery, CampaignPreviewQueryVariables } from 'common/src/generated/types';
import CampaignTextMessages from '../campaigns/show/campaignTextMessages.graphql';
import {
    CampaignTextMessagesQuery,
    CampaignTextMessagesQueryVariables
} from 'common/src/generated/types';
import TextMessageReplies from '../campaigns/show/textMessageReplies/textMessageReplies.graphql';
import {
    TextMessageRepliesQuery,
    TextMessageRepliesQueryVariables
} from 'common/src/generated/types';
import TextMessageSend from '../campaigns/show/textMessageReplies/textMessageSend.graphql';
import {
    TextMessageSendMutation,
    TextMessageSendMutationVariables
} from 'common/src/generated/types';
import TextMessageRepliesRead from '../campaigns/show/textMessageRepliesRead.graphql';
import {
    TextMessageRepliesReadMutation,
    TextMessageRepliesReadMutationVariables
} from 'common/src/generated/types';
import CampaignsSegments from '../community/campaigns/list/campaignsSegments.graphql';
import {
    CampaignsSegmentsQuery,
    CampaignsSegmentsQueryVariables
} from 'common/src/generated/types';
import CommunityCampaigns from '../community/campaigns/list/communityCampaigns.graphql';
import {
    CommunityCampaignsQuery,
    CommunityCampaignsQueryVariables
} from 'common/src/generated/types';
import CommunityDashboard from '../community/dashboard/communityDashboard.graphql';
import {
    CommunityDashboardQuery,
    CommunityDashboardQueryVariables
} from 'common/src/generated/types';
import CommunityDelegationsSegments from '../community/delegations/list/communityDelegationsSegments.graphql';
import {
    CommunityDelegationsSegmentsQuery,
    CommunityDelegationsSegmentsQueryVariables
} from 'common/src/generated/types';
import UsersInfosMassAddEvent from '../community/users/massAddEvent/usersInfosMassAddEvent.graphql';
import {
    UsersInfosMassAddEventMutation,
    UsersInfosMassAddEventMutationVariables
} from 'common/src/generated/types';
import MergeMembers from '../community/users/mergeMembers/mergeMembers.graphql';
import { MergeMembersQuery, MergeMembersQueryVariables } from 'common/src/generated/types';
import UsersInfosMerge from '../community/users/mergeMembers/usersInfosMerge.graphql';
import {
    UsersInfosMergeMutation,
    UsersInfosMergeMutationVariables
} from 'common/src/generated/types';
import UsersActions from '../community/users/usersActions.graphql';
import { UsersActionsQuery, UsersActionsQueryVariables } from 'common/src/generated/types';
import UsersInfosMassDelete from '../community/users/usersInfosMassDelete.graphql';
import {
    UsersInfosMassDeleteMutation,
    UsersInfosMassDeleteMutationVariables
} from 'common/src/generated/types';
import PossibleDuplicates from '../community/usersDuplicates/possibleDuplicates.graphql';
import {
    PossibleDuplicatesQuery,
    PossibleDuplicatesQueryVariables
} from 'common/src/generated/types';
import CustomFieldCategoryCreate from '../customFields/create/customFieldCategoryCreate.graphql';
import {
    CustomFieldCategoryCreateMutation,
    CustomFieldCategoryCreateMutationVariables
} from 'common/src/generated/types';
import CustomFieldCreate from '../customFields/create/customFieldCreate.graphql';
import {
    CustomFieldCreateMutation,
    CustomFieldCreateMutationVariables
} from 'common/src/generated/types';
import CustomFieldToEdit from '../customFields/create/customFieldToEdit.graphql';
import {
    CustomFieldToEditQuery,
    CustomFieldToEditQueryVariables
} from 'common/src/generated/types';
import CustomFieldUpdate from '../customFields/create/customFieldUpdate.graphql';
import {
    CustomFieldUpdateMutation,
    CustomFieldUpdateMutationVariables
} from 'common/src/generated/types';
import OrganizationInfos from '../customFields/create/organizationInfos.graphql';
import {
    OrganizationInfosQuery,
    OrganizationInfosQueryVariables
} from 'common/src/generated/types';
import CustomField from '../customFields/list/customField.graphql';
import { CustomFieldQuery, CustomFieldQueryVariables } from 'common/src/generated/types';
import CustomFieldCategoryDelete from '../customFields/list/customFieldCategoryDelete.graphql';
import {
    CustomFieldCategoryDeleteMutation,
    CustomFieldCategoryDeleteMutationVariables
} from 'common/src/generated/types';
import CustomFieldDuplicate from '../customFields/list/customFieldDuplicate.graphql';
import {
    CustomFieldDuplicateMutation,
    CustomFieldDuplicateMutationVariables
} from 'common/src/generated/types';
import CustomFieldUsage from '../customFields/list/customFieldUsage/customFieldUsage.graphql';
import { CustomFieldUsageQuery, CustomFieldUsageQueryVariables } from 'common/src/generated/types';
import CustomFields from '../customFields/list/customFields.graphql';
import { CustomFieldsQuery, CustomFieldsQueryVariables } from 'common/src/generated/types';
import CustomFieldsMassDelete from '../customFields/list/customFieldsMassDelete.graphql';
import {
    CustomFieldsMassDeleteMutation,
    CustomFieldsMassDeleteMutationVariables
} from 'common/src/generated/types';
import CustomFieldsSegments from '../customFields/list/customFieldsSegments.graphql';
import {
    CustomFieldsSegmentsQuery,
    CustomFieldsSegmentsQueryVariables
} from 'common/src/generated/types';
import CustomFieldCategoryUpdate from '../customFieldsCategories/create/customFieldCategoryUpdate.graphql';
import {
    CustomFieldCategoryUpdateMutation,
    CustomFieldCategoryUpdateMutationVariables
} from 'common/src/generated/types';
import Dashboard from '../dashboard/dashboard.graphql';
import { DashboardQuery, DashboardQueryVariables } from 'common/src/generated/types';
import DashboardMobile from '../dashboard/mobile/dashboardMobile.graphql';
import { DashboardMobileQuery, DashboardMobileQueryVariables } from 'common/src/generated/types';
import DelegationCreate from '../delegations/create/delegationCreate.graphql';
import {
    DelegationCreateMutation,
    DelegationCreateMutationVariables
} from 'common/src/generated/types';
import DelegationEventInfos from '../delegations/create/delegationEventInfos.graphql';
import {
    DelegationEventInfosQuery,
    DelegationEventInfosQueryVariables
} from 'common/src/generated/types';
import DelegationEventToEdit from '../delegations/create/delegationEventToEdit.graphql';
import {
    DelegationEventToEditQuery,
    DelegationEventToEditQueryVariables
} from 'common/src/generated/types';
import DelegationOrganizationInfos from '../delegations/create/delegationOrganizationInfos.graphql';
import {
    DelegationOrganizationInfosQuery,
    DelegationOrganizationInfosQueryVariables
} from 'common/src/generated/types';
import DelegationOrganizationToEdit from '../delegations/create/delegationOrganizationToEdit.graphql';
import {
    DelegationOrganizationToEditQuery,
    DelegationOrganizationToEditQueryVariables
} from 'common/src/generated/types';
import DelegationUpdate from '../delegations/create/delegationUpdate.graphql';
import {
    DelegationUpdateMutation,
    DelegationUpdateMutationVariables
} from 'common/src/generated/types';
import EventUsersInfos from '../delegations/create/eventUsersInfos.graphql';
import { EventUsersInfosQuery, EventUsersInfosQueryVariables } from 'common/src/generated/types';
import DelegationsImport from '../delegations/import/delegationsImport.graphql';
import {
    DelegationsImportMutation,
    DelegationsImportMutationVariables
} from 'common/src/generated/types';
import DelegationDuplicate from '../delegations/list/delegationDuplicate.graphql';
import {
    DelegationDuplicateMutation,
    DelegationDuplicateMutationVariables
} from 'common/src/generated/types';
import Delegations from '../delegations/list/delegations.graphql';
import { DelegationsQuery, DelegationsQueryVariables } from 'common/src/generated/types';
import DelegationsCategories from '../delegations/list/delegationsCategories.graphql';
import {
    DelegationsCategoriesQuery,
    DelegationsCategoriesQueryVariables
} from 'common/src/generated/types';
import DelegationsDelegation from '../delegations/list/delegationsDelegation.graphql';
import {
    DelegationsDelegationQuery,
    DelegationsDelegationQueryVariables
} from 'common/src/generated/types';
import DelegationsExport from '../delegations/list/delegationsExport.graphql';
import {
    DelegationsExportMutation,
    DelegationsExportMutationVariables
} from 'common/src/generated/types';
import DelegationsMassDelete from '../delegations/list/delegationsMassDelete.graphql';
import {
    DelegationsMassDeleteMutation,
    DelegationsMassDeleteMutationVariables
} from 'common/src/generated/types';
import DelegationsSegments from '../delegations/list/delegationsSegments.graphql';
import {
    DelegationsSegmentsQuery,
    DelegationsSegmentsQueryVariables
} from 'common/src/generated/types';
import ParentDelegations from '../delegations/list/parentDelegations.graphql';
import {
    ParentDelegationsQuery,
    ParentDelegationsQueryVariables
} from 'common/src/generated/types';
import DelegationsMassMove from '../delegations/massMove/delegationsMassMove.graphql';
import {
    DelegationsMassMoveMutation,
    DelegationsMassMoveMutationVariables
} from 'common/src/generated/types';
import DelegationsMassMoveInfos from '../delegations/massMove/delegationsMassMoveInfos.graphql';
import {
    DelegationsMassMoveInfosQuery,
    DelegationsMassMoveInfosQueryVariables
} from 'common/src/generated/types';
import DelegationDashboard from '../delegations/show/dashboard/delegationDashboard.graphql';
import {
    DelegationDashboardQuery,
    DelegationDashboardQueryVariables
} from 'common/src/generated/types';
import Delegation from '../delegations/show/delegation.graphql';
import { DelegationQuery, DelegationQueryVariables } from 'common/src/generated/types';
import DelegationReporting from '../delegations/show/reporting/delegationReporting.graphql';
import {
    DelegationReportingQuery,
    DelegationReportingQueryVariables
} from 'common/src/generated/types';
import DelegationCategoryCreate from '../delegationsCategories/create/delegationCategoryCreate.graphql';
import {
    DelegationCategoryCreateMutation,
    DelegationCategoryCreateMutationVariables
} from 'common/src/generated/types';
import DelegationCategoryUpdate from '../delegationsCategories/create/delegationCategoryUpdate.graphql';
import {
    DelegationCategoryUpdateMutation,
    DelegationCategoryUpdateMutationVariables
} from 'common/src/generated/types';
import DelegationCategoryDelete from '../delegationsCategories/delete/delegationCategoryDelete.graphql';
import {
    DelegationCategoryDeleteMutation,
    DelegationCategoryDeleteMutationVariables
} from 'common/src/generated/types';
import DelegationCategoryDelegations from '../delegationsCategories/show/dashboard/delegationCategoryDelegations.graphql';
import {
    DelegationCategoryDelegationsQuery,
    DelegationCategoryDelegationsQueryVariables
} from 'common/src/generated/types';
import DelegationCategory from '../delegationsCategories/show/delegationCategory.graphql';
import {
    DelegationCategoryQuery,
    DelegationCategoryQueryVariables
} from 'common/src/generated/types';
import DelegationCategoryDuplicate from '../delegationsCategories/show/delegationCategoryDuplicate.graphql';
import {
    DelegationCategoryDuplicateMutation,
    DelegationCategoryDuplicateMutationVariables
} from 'common/src/generated/types';
import DelegationCategoryMembersInfos from '../delegationsCategories/show/members/delegationCategoryMembersInfos.graphql';
import {
    DelegationCategoryMembersInfosQuery,
    DelegationCategoryMembersInfosQueryVariables
} from 'common/src/generated/types';
import CustomDocument from '../documentBuilder/customDocument.graphql';
import { CustomDocumentQuery, CustomDocumentQueryVariables } from 'common/src/generated/types';
import CustomDocumentConditions from '../documentBuilder/customDocumentConditions.graphql';
import {
    CustomDocumentConditionsQuery,
    CustomDocumentConditionsQueryVariables
} from 'common/src/generated/types';
import CustomDocumentUpdate from '../documentBuilder/customDocumentUpdate.graphql';
import {
    CustomDocumentUpdateMutation,
    CustomDocumentUpdateMutationVariables
} from 'common/src/generated/types';
import CustomDocumentCreate from '../documents/create/customDocumentCreate.graphql';
import {
    CustomDocumentCreateMutation,
    CustomDocumentCreateMutationVariables
} from 'common/src/generated/types';
import CustomDocumentDelete from '../documents/list/customDocuments/customDocumentDelete.graphql';
import {
    CustomDocumentDeleteMutation,
    CustomDocumentDeleteMutationVariables
} from 'common/src/generated/types';
import CustomDocumentDuplicate from '../documents/list/customDocuments/customDocumentDuplicate.graphql';
import {
    CustomDocumentDuplicateMutation,
    CustomDocumentDuplicateMutationVariables
} from 'common/src/generated/types';
import Documents from '../documents/list/documents.graphql';
import { DocumentsQuery, DocumentsQueryVariables } from 'common/src/generated/types';
import EventDocumentUpdate from '../documents/show/eventDocumentUpdate.graphql';
import {
    EventDocumentUpdateMutation,
    EventDocumentUpdateMutationVariables
} from 'common/src/generated/types';
import PositionPlanningDocument from '../documents/show/positionPlanningDocument.graphql';
import {
    PositionPlanningDocumentQuery,
    PositionPlanningDocumentQueryVariables
} from 'common/src/generated/types';
import PositionSheetDocument from '../documents/show/positionSheetDocument.graphql';
import {
    PositionSheetDocumentQuery,
    PositionSheetDocumentQueryVariables
} from 'common/src/generated/types';
import PlanningDocument from '../documents/show/positionsPlanningDocument.graphql';
import { PlanningDocumentQuery, PlanningDocumentQueryVariables } from 'common/src/generated/types';
import PositionsVolunteersPlanningDocument from '../documents/show/positionsVolunteersPlanningDocument.graphql';
import {
    PositionsVolunteersPlanningDocumentQuery,
    PositionsVolunteersPlanningDocumentQueryVariables
} from 'common/src/generated/types';
import UserAssignmentsDocument from '../documents/show/userAssignmentsDocument.graphql';
import {
    UserAssignmentsDocumentQuery,
    UserAssignmentsDocumentQueryVariables
} from 'common/src/generated/types';
import UserBadgeDocument from '../documents/show/userBadgeDocument.graphql';
import {
    UserBadgeDocumentQuery,
    UserBadgeDocumentQueryVariables
} from 'common/src/generated/types';
import UserCertificateDocument from '../documents/show/userCertificateDocument.graphql';
import {
    UserCertificateDocumentQuery,
    UserCertificateDocumentQueryVariables
} from 'common/src/generated/types';
import UserCustomBadgeDocument from '../documents/show/userCustomBadgeDocument.graphql';
import {
    UserCustomBadgeDocumentQuery,
    UserCustomBadgeDocumentQueryVariables
} from 'common/src/generated/types';
import UserCustomDocumentExport from '../documents/show/userCustomDocumentExport.graphql';
import {
    UserCustomDocumentExportQuery,
    UserCustomDocumentExportQueryVariables
} from 'common/src/generated/types';
import UserHoursDocument from '../documents/show/userHoursDocument.graphql';
import {
    UserHoursDocumentQuery,
    UserHoursDocumentQueryVariables
} from 'common/src/generated/types';
import UserPlanningDaysDocument from '../documents/show/userPlanningDaysDocument.graphql';
import {
    UserPlanningDaysDocumentQuery,
    UserPlanningDaysDocumentQueryVariables
} from 'common/src/generated/types';
import UserPlanningDocument from '../documents/show/userPlanningDocument.graphql';
import {
    UserPlanningDocumentQuery,
    UserPlanningDocumentQueryVariables
} from 'common/src/generated/types';
import UserPlanningListDocument from '../documents/show/userPlanningListDocument.graphql';
import {
    UserPlanningListDocumentQuery,
    UserPlanningListDocumentQueryVariables
} from 'common/src/generated/types';
import UsersListingDocument from '../documents/show/usersListingDocument.graphql';
import {
    UsersListingDocumentQuery,
    UsersListingDocumentQueryVariables
} from 'common/src/generated/types';
import EmailTemplate from '../emails/templates/emailTemplate.graphql';
import { EmailTemplateQuery, EmailTemplateQueryVariables } from 'common/src/generated/types';
import EmailTemplateUpdate from '../emails/templates/emailTemplateUpdate.graphql';
import {
    EmailTemplateUpdateMutation,
    EmailTemplateUpdateMutationVariables
} from 'common/src/generated/types';
import EmailsTemplates from '../emails/templates/emailsTemplates.graphql';
import { EmailsTemplatesQuery, EmailsTemplatesQueryVariables } from 'common/src/generated/types';
import AllEvents from '../events/allEvents.graphql';
import { AllEventsQuery, AllEventsQueryVariables } from 'common/src/generated/types';
import CreateEvent from '../events/create/createEvent.graphql';
import { CreateEventMutation, CreateEventMutationVariables } from 'common/src/generated/types';
import EventCreateInfos from '../events/create/eventCreateInfos.graphql';
import { EventCreateInfosQuery, EventCreateInfosQueryVariables } from 'common/src/generated/types';
import EventOrganizationCreate from '../events/create/eventOrganizationCreate.graphql';
import {
    EventOrganizationCreateMutation,
    EventOrganizationCreateMutationVariables
} from 'common/src/generated/types';
import EventUpdate from '../events/create/eventUpdate.graphql';
import { EventUpdateMutation, EventUpdateMutationVariables } from 'common/src/generated/types';
import EventUpdateInfos from '../events/create/eventUpdateInfos.graphql';
import { EventUpdateInfosQuery, EventUpdateInfosQueryVariables } from 'common/src/generated/types';
import EventDuplicate from '../events/list/eventDuplicate.graphql';
import {
    EventDuplicateMutation,
    EventDuplicateMutationVariables
} from 'common/src/generated/types';
import Events from '../events/list/events.graphql';
import { EventsQuery, EventsQueryVariables } from 'common/src/generated/types';
import EventsMassArchive from '../events/list/eventsMassArchive.graphql';
import {
    EventsMassArchiveMutation,
    EventsMassArchiveMutationVariables
} from 'common/src/generated/types';
import EventsSegments from '../events/list/eventsSegments.graphql';
import { EventsSegmentsQuery, EventsSegmentsQueryVariables } from 'common/src/generated/types';
import EventsEvent from '../events/list/list/eventsEvent.graphql';
import { EventsEventQuery, EventsEventQueryVariables } from 'common/src/generated/types';
import EventsMobile from '../events/mobile/eventsMobile.graphql';
import { EventsMobileQuery, EventsMobileQueryVariables } from 'common/src/generated/types';
import Event from '../events/show/event.graphql';
import { EventQuery, EventQueryVariables } from 'common/src/generated/types';
import FilesImport from '../files/import/filesImport.graphql';
import { FilesImportMutation, FilesImportMutationVariables } from 'common/src/generated/types';
import FilesImportCustomFields from '../files/import/filesImportCustomFields.graphql';
import {
    FilesImportCustomFieldsQuery,
    FilesImportCustomFieldsQueryVariables
} from 'common/src/generated/types';
import FormCreate from '../forms/create/formCreate.graphql';
import { FormCreateMutation, FormCreateMutationVariables } from 'common/src/generated/types';
import FormDelete from '../forms/list/formDelete.graphql';
import { FormDeleteMutation, FormDeleteMutationVariables } from 'common/src/generated/types';
import FormDuplicate from '../forms/list/formDuplicate.graphql';
import { FormDuplicateMutation, FormDuplicateMutationVariables } from 'common/src/generated/types';
import Forms from '../forms/list/forms.graphql';
import { FormsQuery, FormsQueryVariables } from 'common/src/generated/types';
import Form from '../forms/show/form.graphql';
import { FormQuery, FormQueryVariables } from 'common/src/generated/types';
import FormElements from '../forms/update/elements/formElements.graphql';
import { FormElementsQuery, FormElementsQueryVariables } from 'common/src/generated/types';
import FormElementsUpdate from '../forms/update/elements/formElementsUpdate.graphql';
import {
    FormElementsUpdateMutation,
    FormElementsUpdateMutationVariables
} from 'common/src/generated/types';
import FormParametersAccreditations from '../forms/update/parameters/accreditations/formParametersAccreditations.graphql';
import {
    FormParametersAccreditationsQuery,
    FormParametersAccreditationsQueryVariables
} from 'common/src/generated/types';
import FormParametersAccreditationsUpdate from '../forms/update/parameters/accreditations/formParametersAccreditationsUpdate.graphql';
import {
    FormParametersAccreditationsUpdateMutation,
    FormParametersAccreditationsUpdateMutationVariables
} from 'common/src/generated/types';
import FormParametersAccreditationsHiddenDisplayed from '../forms/update/parameters/accreditations/hiddenDisplayed/formParametersAccreditationsHiddenDisplayed.graphql';
import {
    FormParametersAccreditationsHiddenDisplayedQuery,
    FormParametersAccreditationsHiddenDisplayedQueryVariables
} from 'common/src/generated/types';
import FormParametersAvailabilities from '../forms/update/parameters/availabilities/formParametersAvailabilities.graphql';
import {
    FormParametersAvailabilitiesQuery,
    FormParametersAvailabilitiesQueryVariables
} from 'common/src/generated/types';
import FormParametersAvailabilitiesUpdate from '../forms/update/parameters/availabilities/formParametersAvailabilitiesUpdate.graphql';
import {
    FormParametersAvailabilitiesUpdateMutation,
    FormParametersAvailabilitiesUpdateMutationVariables
} from 'common/src/generated/types';
import FormParametersBroadcastEvent from '../forms/update/parameters/broadcast/formParametersBroadcastEvent.graphql';
import {
    FormParametersBroadcastEventQuery,
    FormParametersBroadcastEventQueryVariables
} from 'common/src/generated/types';
import FormParametersBroadcastOrganization from '../forms/update/parameters/broadcast/formParametersBroadcastOrganization.graphql';
import {
    FormParametersBroadcastOrganizationQuery,
    FormParametersBroadcastOrganizationQueryVariables
} from 'common/src/generated/types';
import FormParametersBroadcastUpdate from '../forms/update/parameters/broadcast/formParametersBroadcastUpdate.graphql';
import {
    FormParametersBroadcastUpdateMutation,
    FormParametersBroadcastUpdateMutationVariables
} from 'common/src/generated/types';
import FormParametersDesign from '../forms/update/parameters/design/formParametersDesign.graphql';
import {
    FormParametersDesignQuery,
    FormParametersDesignQueryVariables
} from 'common/src/generated/types';
import FormParametersDesignUpdate from '../forms/update/parameters/design/formParametersDesignUpdate.graphql';
import {
    FormParametersDesignUpdateMutation,
    FormParametersDesignUpdateMutationVariables
} from 'common/src/generated/types';
import FormParametersGeneral from '../forms/update/parameters/general/formParametersGeneral.graphql';
import {
    FormParametersGeneralQuery,
    FormParametersGeneralQueryVariables
} from 'common/src/generated/types';
import FormParametersGeneralUpdate from '../forms/update/parameters/general/formParametersGeneralUpdate.graphql';
import {
    FormParametersGeneralUpdateMutation,
    FormParametersGeneralUpdateMutationVariables
} from 'common/src/generated/types';
import FormParametersMissions from '../forms/update/parameters/missions/formParametersMissions.graphql';
import {
    FormParametersMissionsQuery,
    FormParametersMissionsQueryVariables
} from 'common/src/generated/types';
import FormParametersMissionsUpdate from '../forms/update/parameters/missions/formParametersMissionsUpdate.graphql';
import {
    FormParametersMissionsUpdateMutation,
    FormParametersMissionsUpdateMutationVariables
} from 'common/src/generated/types';
import FormParametersMissionsHiddenDisplayed from '../forms/update/parameters/missions/hiddenDisplayed/formParametersMissionsHiddenDisplayed.graphql';
import {
    FormParametersMissionsHiddenDisplayedQuery,
    FormParametersMissionsHiddenDisplayedQueryVariables
} from 'common/src/generated/types';
import FormParametersState from '../forms/update/parameters/state/formParametersState.graphql';
import {
    FormParametersStateQuery,
    FormParametersStateQueryVariables
} from 'common/src/generated/types';
import FormParametersStateUpdate from '../forms/update/parameters/state/formParametersStateUpdate.graphql';
import {
    FormParametersStateUpdateMutation,
    FormParametersStateUpdateMutationVariables
} from 'common/src/generated/types';
import HomeOrganizations from '../home/homeOrganizations.graphql';
import {
    HomeOrganizationsQuery,
    HomeOrganizationsQueryVariables
} from 'common/src/generated/types';
import CollaboratorsVolunteers from '../leaders/assign/collaboratorsVolunteers.graphql';
import {
    CollaboratorsVolunteersQuery,
    CollaboratorsVolunteersQueryVariables
} from 'common/src/generated/types';
import DelegationsImportResult from '../notifications/delegationsImportResult.graphql';
import {
    DelegationsImportResultMutation,
    DelegationsImportResultMutationVariables
} from 'common/src/generated/types';
import EventDocumentsExportResult from '../notifications/eventDocumentsExportResult.graphql';
import {
    EventDocumentsExportResultMutation,
    EventDocumentsExportResultMutationVariables
} from 'common/src/generated/types';
import ExportResult from '../notifications/exportResult.graphql';
import { ExportResultMutation, ExportResultMutationVariables } from 'common/src/generated/types';
import FilesImportResult from '../notifications/filesImportResult.graphql';
import {
    FilesImportResultMutation,
    FilesImportResultMutationVariables
} from 'common/src/generated/types';
import PositionsImportResult from '../notifications/positionsImportResult.graphql';
import {
    PositionsImportResultMutation,
    PositionsImportResultMutationVariables
} from 'common/src/generated/types';
import EventKey from '../options/api/eventKey.graphql';
import { EventKeyQuery, EventKeyQueryVariables } from 'common/src/generated/types';
import WeezeventRules from '../options/integration/weezevent/weezeventRules.graphql';
import { WeezeventRulesQuery, WeezeventRulesQueryVariables } from 'common/src/generated/types';
import EventWeezeventUpdate from '../options/weezeventV2/eventWeezeventUpdate.graphql';
import {
    EventWeezeventUpdateMutation,
    EventWeezeventUpdateMutationVariables
} from 'common/src/generated/types';
import WeezeventV2Infos from '../options/weezeventV2/weezeventV2Infos.graphql';
import { WeezeventV2InfosQuery, WeezeventV2InfosQueryVariables } from 'common/src/generated/types';
import OrganizationCreate from '../organization/create/organizationCreate.graphql';
import {
    OrganizationCreateMutation,
    OrganizationCreateMutationVariables
} from 'common/src/generated/types';
import Organizations from '../organization/menu/organizations.graphql';
import { OrganizationsQuery, OrganizationsQueryVariables } from 'common/src/generated/types';
import Organization from '../organization/organization.graphql';
import { OrganizationQuery, OrganizationQueryVariables } from 'common/src/generated/types';
import UserInfo from '../organization/terms/userInfo.graphql';
import { UserInfoQuery, UserInfoQueryVariables } from 'common/src/generated/types';
import UserInfoAndTermsUpdate from '../organization/terms/userInfoAndTermsUpdate.graphql';
import {
    UserInfoAndTermsUpdateMutation,
    UserInfoAndTermsUpdateMutationVariables
} from 'common/src/generated/types';
import Activities from '../organizationParameters/activities/activities.graphql';
import { ActivitiesQuery, ActivitiesQueryVariables } from 'common/src/generated/types';
import OrganizationCategoriesAccreditations from '../organizationParameters/categories/organizationCategoriesAccreditations.graphql';
import {
    OrganizationCategoriesAccreditationsQuery,
    OrganizationCategoriesAccreditationsQueryVariables
} from 'common/src/generated/types';
import OrganizationCategoriesCustomFields from '../organizationParameters/categories/organizationCategoriesCustomFields.graphql';
import {
    OrganizationCategoriesCustomFieldsQuery,
    OrganizationCategoriesCustomFieldsQueryVariables
} from 'common/src/generated/types';
import OrganizationCategoriesDelegations from '../organizationParameters/categories/organizationCategoriesDelegations.graphql';
import {
    OrganizationCategoriesDelegationsQuery,
    OrganizationCategoriesDelegationsQueryVariables
} from 'common/src/generated/types';
import OrganizationCategoriesPositions from '../organizationParameters/categories/organizationCategoriesPositions.graphql';
import {
    OrganizationCategoriesPositionsQuery,
    OrganizationCategoriesPositionsQueryVariables
} from 'common/src/generated/types';
import OrganizationDelegationSpaceSettings from '../organizationParameters/delegationsSpace/organizationDelegationSpaceSettings.graphql';
import {
    OrganizationDelegationSpaceSettingsQuery,
    OrganizationDelegationSpaceSettingsQueryVariables
} from 'common/src/generated/types';
import OrganizationDelegationSpaceSettingsUpdate from '../organizationParameters/delegationsSpace/organizationDelegationSpaceSettingsUpdate.graphql';
import {
    OrganizationDelegationSpaceSettingsUpdateMutation,
    OrganizationDelegationSpaceSettingsUpdateMutationVariables
} from 'common/src/generated/types';
import OrganizationDelegationsSpaceDesign from '../organizationParameters/delegationsSpace/organizationDelegationsSpaceDesign.graphql';
import {
    OrganizationDelegationsSpaceDesignQuery,
    OrganizationDelegationsSpaceDesignQueryVariables
} from 'common/src/generated/types';
import OrganizationDelegationsSpaceDesignUpdate from '../organizationParameters/delegationsSpace/organizationDelegationsSpaceDesignUpdate.graphql';
import {
    OrganizationDelegationsSpaceDesignUpdateMutation,
    OrganizationDelegationsSpaceDesignUpdateMutationVariables
} from 'common/src/generated/types';
import DomainDkimVerificationRetry from '../organizationParameters/emails/dns/domainDkimVerificationRetry.graphql';
import {
    DomainDkimVerificationRetryMutation,
    DomainDkimVerificationRetryMutationVariables
} from 'common/src/generated/types';
import OrganizationDomains from '../organizationParameters/emails/dns/organizationDomains.graphql';
import {
    OrganizationDomainsQuery,
    OrganizationDomainsQueryVariables
} from 'common/src/generated/types';
import EmailSenderCreate from '../organizationParameters/emails/senders/create/emailSenderCreate.graphql';
import {
    EmailSenderCreateMutation,
    EmailSenderCreateMutationVariables
} from 'common/src/generated/types';
import EmailSenderToEdit from '../organizationParameters/emails/senders/create/emailSenderToEdit.graphql';
import {
    EmailSenderToEditQuery,
    EmailSenderToEditQueryVariables
} from 'common/src/generated/types';
import EmailSenderUpdate from '../organizationParameters/emails/senders/create/emailSenderUpdate.graphql';
import {
    EmailSenderUpdateMutation,
    EmailSenderUpdateMutationVariables
} from 'common/src/generated/types';
import EmailSenderDelete from '../organizationParameters/emails/senders/list/emailSenderDelete.graphql';
import {
    EmailSenderDeleteMutation,
    EmailSenderDeleteMutationVariables
} from 'common/src/generated/types';
import EmailSenderDuplicate from '../organizationParameters/emails/senders/list/emailSenderDuplicate.graphql';
import {
    EmailSenderDuplicateMutation,
    EmailSenderDuplicateMutationVariables
} from 'common/src/generated/types';
import EmailSenderVerificationResend from '../organizationParameters/emails/senders/list/emailSenderVerificationResend.graphql';
import {
    EmailSenderVerificationResendMutation,
    EmailSenderVerificationResendMutationVariables
} from 'common/src/generated/types';
import EmailsSenders from '../organizationParameters/emails/senders/list/emailsSenders.graphql';
import { EmailsSendersQuery, EmailsSendersQueryVariables } from 'common/src/generated/types';
import EmailSenderPreview from '../organizationParameters/emails/senders/preview/emailSenderPreview.graphql';
import {
    EmailSenderPreviewQuery,
    EmailSenderPreviewQueryVariables
} from 'common/src/generated/types';
import OrganizationParametersInfos from '../organizationParameters/infos/organizationInfos.graphql';
import {
    OrganizationParametersInfosQuery,
    OrganizationParametersInfosQueryVariables
} from 'common/src/generated/types';
import OrganizationUpdateInfos from '../organizationParameters/infos/organizationUpdateInfos.graphql';
import {
    OrganizationUpdateInfosMutation,
    OrganizationUpdateInfosMutationVariables
} from 'common/src/generated/types';
import Invoices from '../organizationParameters/invoices/invoices.graphql';
import { InvoicesQuery, InvoicesQueryVariables } from 'common/src/generated/types';
import OrganizationMembersSpaceDesign from '../organizationParameters/membersSpace/organizationMembersSpaceDesign.graphql';
import {
    OrganizationMembersSpaceDesignQuery,
    OrganizationMembersSpaceDesignQueryVariables
} from 'common/src/generated/types';
import OrganizationMembersSpaceDesignUpdate from '../organizationParameters/membersSpace/organizationMembersSpaceDesignUpdate.graphql';
import {
    OrganizationMembersSpaceDesignUpdateMutation,
    OrganizationMembersSpaceDesignUpdateMutationVariables
} from 'common/src/generated/types';
import OrganizationMembersSpaceSettings from '../organizationParameters/membersSpace/organizationMembersSpaceSettings.graphql';
import {
    OrganizationMembersSpaceSettingsQuery,
    OrganizationMembersSpaceSettingsQueryVariables
} from 'common/src/generated/types';
import OrganizationMembersSpaceSettingsUpdate from '../organizationParameters/membersSpace/organizationMembersSpaceSettingsUpdate.graphql';
import {
    OrganizationMembersSpaceSettingsUpdateMutation,
    OrganizationMembersSpaceSettingsUpdateMutationVariables
} from 'common/src/generated/types';
import UserDelete from '../organizationParameters/profile/userDelete.graphql';
import { UserDeleteMutation, UserDeleteMutationVariables } from 'common/src/generated/types';
import Role from '../organizationParameters/roles/form/role.graphql';
import { RoleQuery, RoleQueryVariables } from 'common/src/generated/types';
import RoleCreate from '../organizationParameters/roles/form/roleCreate.graphql';
import { RoleCreateMutation, RoleCreateMutationVariables } from 'common/src/generated/types';
import RoleUpdate from '../organizationParameters/roles/form/roleUpdate.graphql';
import { RoleUpdateMutation, RoleUpdateMutationVariables } from 'common/src/generated/types';
import RoleDelete from '../organizationParameters/roles/list/dropdown/roleDelete.graphql';
import { RoleDeleteMutation, RoleDeleteMutationVariables } from 'common/src/generated/types';
import RoleUses from '../organizationParameters/roles/list/dropdown/roleUses.graphql';
import { RoleUsesQuery, RoleUsesQueryVariables } from 'common/src/generated/types';
import Roles from '../organizationParameters/roles/list/roles.graphql';
import { RolesQuery, RolesQueryVariables } from 'common/src/generated/types';
import SkidataConnectionInfoSeaonEventAdd from '../organizationParameters/skidata/skidataConnectionInfoSeaonEventAdd.graphql';
import {
    SkidataConnectionInfoSeaonEventAddMutation,
    SkidataConnectionInfoSeaonEventAddMutationVariables
} from 'common/src/generated/types';
import SkidataConnectionInfoSeaonEventDelete from '../organizationParameters/skidata/skidataConnectionInfoSeaonEventDelete.graphql';
import {
    SkidataConnectionInfoSeaonEventDeleteMutation,
    SkidataConnectionInfoSeaonEventDeleteMutationVariables
} from 'common/src/generated/types';
import SkidataConnectionInfoSynchronizedEventAdd from '../organizationParameters/skidata/skidataConnectionInfoSynchronizedEventAdd.graphql';
import {
    SkidataConnectionInfoSynchronizedEventAddMutation,
    SkidataConnectionInfoSynchronizedEventAddMutationVariables
} from 'common/src/generated/types';
import SkidataConnectionInfoSynchronizedEventDelete from '../organizationParameters/skidata/skidataConnectionInfoSynchronizedEventDelete.graphql';
import {
    SkidataConnectionInfoSynchronizedEventDeleteMutation,
    SkidataConnectionInfoSynchronizedEventDeleteMutationVariables
} from 'common/src/generated/types';
import SkidataConnectionInfos from '../organizationParameters/skidata/skidataConnectionInfos.graphql';
import {
    SkidataConnectionInfosQuery,
    SkidataConnectionInfosQueryVariables
} from 'common/src/generated/types';
import SkidataConnectionInfosDelete from '../organizationParameters/skidata/skidataConnectionInfosDelete.graphql';
import {
    SkidataConnectionInfosDeleteMutation,
    SkidataConnectionInfosDeleteMutationVariables
} from 'common/src/generated/types';
import SkidataConnectionInfosUpsert from '../organizationParameters/skidata/skidataConnectionInfosUpsert.graphql';
import {
    SkidataConnectionInfosUpsertMutation,
    SkidataConnectionInfosUpsertMutationVariables
} from 'common/src/generated/types';
import SkidataSynchronize from '../organizationParameters/skidata/skidataSynchronize.graphql';
import {
    SkidataSynchronizeMutation,
    SkidataSynchronizeMutationVariables
} from 'common/src/generated/types';
import OrganizationTags from '../organizationParameters/tags/organizationTags.graphql';
import { OrganizationTagsQuery, OrganizationTagsQueryVariables } from 'common/src/generated/types';
import TagCreate from '../organizationParameters/tags/tagCreate.graphql';
import { TagCreateMutation, TagCreateMutationVariables } from 'common/src/generated/types';
import TagDelete from '../organizationParameters/tags/tagDelete.graphql';
import { TagDeleteMutation, TagDeleteMutationVariables } from 'common/src/generated/types';
import TagUpdateName from '../organizationParameters/tags/tagUpdateName.graphql';
import { TagUpdateNameMutation, TagUpdateNameMutationVariables } from 'common/src/generated/types';
import EventAdminsLeaders from '../organizationParameters/team/eventAdminsLeaders.graphql';
import {
    EventAdminsLeadersQuery,
    EventAdminsLeadersQueryVariables
} from 'common/src/generated/types';
import EventInvite from '../organizationParameters/team/eventInvite.graphql';
import { EventInviteMutation, EventInviteMutationVariables } from 'common/src/generated/types';
import OrganizationInvite from '../organizationParameters/team/organizationInvite.graphql';
import {
    OrganizationInviteMutation,
    OrganizationInviteMutationVariables
} from 'common/src/generated/types';
import Team from '../organizationParameters/team/team.graphql';
import { TeamQuery, TeamQueryVariables } from 'common/src/generated/types';
import UserEventDelete from '../organizationParameters/team/userEventDelete.graphql';
import {
    UserEventDeleteMutation,
    UserEventDeleteMutationVariables
} from 'common/src/generated/types';
import UserEventUpdate from '../organizationParameters/team/userEventUpdate.graphql';
import {
    UserEventUpdateMutation,
    UserEventUpdateMutationVariables
} from 'common/src/generated/types';
import UserLeaderDelete from '../organizationParameters/team/userLeaderDelete.graphql';
import {
    UserLeaderDeleteMutation,
    UserLeaderDeleteMutationVariables
} from 'common/src/generated/types';
import UserOrganizationDelete from '../organizationParameters/team/userOrganizationDelete.graphql';
import {
    UserOrganizationDeleteMutation,
    UserOrganizationDeleteMutationVariables
} from 'common/src/generated/types';
import UserOrganizationUpdate from '../organizationParameters/team/userOrganizationUpdate.graphql';
import {
    UserOrganizationUpdateMutation,
    UserOrganizationUpdateMutationVariables
} from 'common/src/generated/types';
import UserPositionCategoryUpdate from '../organizationParameters/team/userPositionCategoryUpdate.graphql';
import {
    UserPositionCategoryUpdateMutation,
    UserPositionCategoryUpdateMutationVariables
} from 'common/src/generated/types';
import UserPositionUpdate from '../organizationParameters/team/userPositionUpdate.graphql';
import {
    UserPositionUpdateMutation,
    UserPositionUpdateMutationVariables
} from 'common/src/generated/types';
import OrganizationTranslations from '../organizationParameters/translations/organizationTranslations.graphql';
import {
    OrganizationTranslationsQuery,
    OrganizationTranslationsQueryVariables
} from 'common/src/generated/types';
import OrganizationTranslationsStats from '../organizationParameters/translations/organizationTranslationsStats.graphql';
import {
    OrganizationTranslationsStatsQuery,
    OrganizationTranslationsStatsQueryVariables
} from 'common/src/generated/types';
import TranslationUpdate from '../organizationParameters/translations/translationUpdate.graphql';
import {
    TranslationUpdateMutation,
    TranslationUpdateMutationVariables
} from 'common/src/generated/types';
import PositionCreate from '../positions/create/positionCreate.graphql';
import {
    PositionCreateMutation,
    PositionCreateMutationVariables
} from 'common/src/generated/types';
import PositionEventInfos from '../positions/create/positionEventInfos.graphql';
import {
    PositionEventInfosQuery,
    PositionEventInfosQueryVariables
} from 'common/src/generated/types';
import PositionToEdit from '../positions/create/positionToEdit.graphql';
import { PositionToEditQuery, PositionToEditQueryVariables } from 'common/src/generated/types';
import PositionUpdate from '../positions/create/positionUpdate.graphql';
import {
    PositionUpdateMutation,
    PositionUpdateMutationVariables
} from 'common/src/generated/types';
import PositionsImport from '../positions/import/csv/positionsImport.graphql';
import {
    PositionsImportMutation,
    PositionsImportMutationVariables
} from 'common/src/generated/types';
import KmlEventInfos from '../positions/import/kml/kmlEventInfos.graphql';
import { KmlEventInfosQuery, KmlEventInfosQueryVariables } from 'common/src/generated/types';
import PositionsCreate from '../positions/import/kml/positionsCreate.graphql';
import {
    PositionsCreateMutation,
    PositionsCreateMutationVariables
} from 'common/src/generated/types';
import PositionsCategories from '../positions/list/list/positionsCategories.graphql';
import {
    PositionsCategoriesQuery,
    PositionsCategoriesQueryVariables
} from 'common/src/generated/types';
import PositionsMassDelete from '../positions/list/list/positionsMassDelete.graphql';
import {
    PositionsMassDeleteMutation,
    PositionsMassDeleteMutationVariables
} from 'common/src/generated/types';
import PositionsPosition from '../positions/list/list/positionsPosition.graphql';
import {
    PositionsPositionQuery,
    PositionsPositionQueryVariables
} from 'common/src/generated/types';
import EventLayerUpdate from '../positions/list/map/eventLayerUpdate.graphql';
import {
    EventLayerUpdateMutation,
    EventLayerUpdateMutationVariables
} from 'common/src/generated/types';
import TraceCreate from '../positions/list/map/traceCreate.graphql';
import { TraceCreateMutation, TraceCreateMutationVariables } from 'common/src/generated/types';
import TraceDelete from '../positions/list/map/traceDelete.graphql';
import { TraceDeleteMutation, TraceDeleteMutationVariables } from 'common/src/generated/types';
import TraceUpdate from '../positions/list/map/traceUpdate.graphql';
import { TraceUpdateMutation, TraceUpdateMutationVariables } from 'common/src/generated/types';
import Traces from '../positions/list/map/traces.graphql';
import { TracesQuery, TracesQueryVariables } from 'common/src/generated/types';
import PositionSlotCreate from '../positions/list/planning/positionSlotCreate.graphql';
import {
    PositionSlotCreateMutation,
    PositionSlotCreateMutationVariables
} from 'common/src/generated/types';
import PositionsPlanning from '../positions/list/planning/positionsPlanning.graphql';
import {
    PositionsPlanningQuery,
    PositionsPlanningQueryVariables
} from 'common/src/generated/types';
import PositionsPlanningPosition from '../positions/list/planning/positionsPlanningPosition.graphql';
import {
    PositionsPlanningPositionQuery,
    PositionsPlanningPositionQueryVariables
} from 'common/src/generated/types';
import PositionCategoryLeaderDelete from '../positions/list/positionCategoryLeaderDelete.graphql';
import {
    PositionCategoryLeaderDeleteMutation,
    PositionCategoryLeaderDeleteMutationVariables
} from 'common/src/generated/types';
import Positions from '../positions/list/positions.graphql';
import { PositionsQuery, PositionsQueryVariables } from 'common/src/generated/types';
import PositionsHeader from '../positions/list/positionsHeader.graphql';
import { PositionsHeaderQuery, PositionsHeaderQueryVariables } from 'common/src/generated/types';
import PositionsSegments from '../positions/list/positionsSegments.graphql';
import {
    PositionsSegmentsQuery,
    PositionsSegmentsQueryVariables
} from 'common/src/generated/types';
import PositionMap from '../positions/map/positionMap.graphql';
import { PositionMapQuery, PositionMapQueryVariables } from 'common/src/generated/types';
import MassConditionsCustomFields from '../positions/massConditions/massConditionsCustomFields.graphql';
import {
    MassConditionsCustomFieldsQuery,
    MassConditionsCustomFieldsQueryVariables
} from 'common/src/generated/types';
import PositionsMassConditions from '../positions/massConditions/positionsMassConditions.graphql';
import {
    PositionsMassConditionsMutation,
    PositionsMassConditionsMutationVariables
} from 'common/src/generated/types';
import PositionsMobile from '../positions/mobile/list/positionsMobile.graphql';
import { PositionsMobileQuery, PositionsMobileQueryVariables } from 'common/src/generated/types';
import PositionsSegmentsMobile from '../positions/mobile/list/positionsSegmentsMobile.graphql';
import {
    PositionsSegmentsMobileQuery,
    PositionsSegmentsMobileQueryVariables
} from 'common/src/generated/types';
import RecentPositionsSearchesMobile from '../positions/mobile/search/recentPositionsSearchesMobile.graphql';
import {
    RecentPositionsSearchesMobileQuery,
    RecentPositionsSearchesMobileQueryVariables
} from 'common/src/generated/types';
import PositionSlotMembersMobile from '../positions/mobile/show/positionSlotMembers/positionSlotMembersMobile.graphql';
import {
    PositionSlotMembersMobileQuery,
    PositionSlotMembersMobileQueryVariables
} from 'common/src/generated/types';
import PositionSlotsMobile from '../positions/mobile/show/positionSlots/positionSlotsMobile.graphql';
import {
    PositionSlotsMobileQuery,
    PositionSlotsMobileQueryVariables
} from 'common/src/generated/types';
import PositionDashboard from '../positions/show/dashboard/positionDashboard.graphql';
import {
    PositionDashboardQuery,
    PositionDashboardQueryVariables
} from 'common/src/generated/types';
import Position from '../positions/show/position.graphql';
import { PositionQuery, PositionQueryVariables } from 'common/src/generated/types';
import PositionLeaderDelete from '../positions/show/positionLeaderDelete.graphql';
import {
    PositionLeaderDeleteMutation,
    PositionLeaderDeleteMutationVariables
} from 'common/src/generated/types';
import PositionLeadersAsign from '../positions/show/positionLeadersAssign.graphql';
import {
    PositionLeadersAsignMutation,
    PositionLeadersAsignMutationVariables
} from 'common/src/generated/types';
import PositionSlotDelete from '../positions/show/positionSlots/positionSlotDelete.graphql';
import {
    PositionSlotDeleteMutation,
    PositionSlotDeleteMutationVariables
} from 'common/src/generated/types';
import PositionSlotUpdate from '../positions/show/positionSlots/positionSlotUpdate.graphql';
import {
    PositionSlotUpdateMutation,
    PositionSlotUpdateMutationVariables
} from 'common/src/generated/types';
import PositionSlotVolunteers from '../positions/show/positionSlots/positionSlotVolunteers.graphql';
import {
    PositionSlotVolunteersQuery,
    PositionSlotVolunteersQueryVariables
} from 'common/src/generated/types';
import PositionSlots from '../positions/show/positionSlots/positionSlots.graphql';
import { PositionSlotsQuery, PositionSlotsQueryVariables } from 'common/src/generated/types';
import PositionCategoryCreate from '../positionsCategories/create/positionCategoryCreate.graphql';
import {
    PositionCategoryCreateMutation,
    PositionCategoryCreateMutationVariables
} from 'common/src/generated/types';
import PositionCategoryUpdate from '../positionsCategories/create/positionCategoryUpdate.graphql';
import {
    PositionCategoryUpdateMutation,
    PositionCategoryUpdateMutationVariables
} from 'common/src/generated/types';
import PositionCategoryDelete from '../positionsCategories/delete/positionCategoryDelete.graphql';
import {
    PositionCategoryDeleteMutation,
    PositionCategoryDeleteMutationVariables
} from 'common/src/generated/types';
import PositionCategory from '../positionsCategories/show/positionCategory.graphql';
import { PositionCategoryQuery, PositionCategoryQueryVariables } from 'common/src/generated/types';
import PositionCategoryDescriptionUpdate from '../positionsCategories/show/positionCategoryDescriptionUpdate.graphql';
import {
    PositionCategoryDescriptionUpdateMutation,
    PositionCategoryDescriptionUpdateMutationVariables
} from 'common/src/generated/types';
import PositionCategoryDuplicate from '../positionsCategories/show/positionCategoryDuplicate.graphql';
import {
    PositionCategoryDuplicateMutation,
    PositionCategoryDuplicateMutationVariables
} from 'common/src/generated/types';
import PositionCategoryPositions from '../positionsCategories/show/positions/positionCategoryPositions.graphql';
import {
    PositionCategoryPositionsQuery,
    PositionCategoryPositionsQueryVariables
} from 'common/src/generated/types';
import PositionsCategoryLeadersAssign from '../positionsCategories/show/positionsCategoryLeadersAssign.graphql';
import {
    PositionsCategoryLeadersAssignMutation,
    PositionsCategoryLeadersAssignMutationVariables
} from 'common/src/generated/types';
import AvailableVolunteersRegistrations from '../positionsSlots/assignVolunteers/availableVolunteersRegistrations.graphql';
import {
    AvailableVolunteersRegistrationsQuery,
    AvailableVolunteersRegistrationsQueryVariables
} from 'common/src/generated/types';
import PositionsPositionSlot from '../positionsSlots/list/positionsPositionSlot.graphql';
import {
    PositionsPositionSlotQuery,
    PositionsPositionSlotQueryVariables
} from 'common/src/generated/types';
import PositionsSlots from '../positionsSlots/list/positionsSlots.graphql';
import { PositionsSlotsQuery, PositionsSlotsQueryVariables } from 'common/src/generated/types';
import UserFieldUpdate from '../userFieldUpdate.graphql';
import { UserFieldUpdateQuery, UserFieldUpdateQueryVariables } from 'common/src/generated/types';
import UserInfoMobile from '../users/mobile/show/userInfoMobile.graphql';
import { UserInfoMobileQuery, UserInfoMobileQueryVariables } from 'common/src/generated/types';
import UserProfileAccreditations from '../users/overlay/accreditations/userProfileAccreditations.graphql';
import {
    UserProfileAccreditationsQuery,
    UserProfileAccreditationsQueryVariables
} from 'common/src/generated/types';
import UserInfoAdminDelete from '../users/overlay/actions/userInfoAdminDelete.graphql';
import {
    UserInfoAdminDeleteMutation,
    UserInfoAdminDeleteMutationVariables
} from 'common/src/generated/types';
import UserOverlayActionsEvent from '../users/overlay/actions/userOverlayActionsEvent.graphql';
import {
    UserOverlayActionsEventQuery,
    UserOverlayActionsEventQueryVariables
} from 'common/src/generated/types';
import UserOverlayActionsOrganization from '../users/overlay/actions/userOverlayActionsOrganization.graphql';
import {
    UserOverlayActionsOrganizationQuery,
    UserOverlayActionsOrganizationQueryVariables
} from 'common/src/generated/types';
import UserHistoryCampaigns from '../users/overlay/history/userHistoryCampaigns.graphql';
import {
    UserHistoryCampaignsQuery,
    UserHistoryCampaignsQueryVariables
} from 'common/src/generated/types';
import UserHistoryEvents from '../users/overlay/history/userHistoryEvents.graphql';
import {
    UserHistoryEventsQuery,
    UserHistoryEventsQueryVariables
} from 'common/src/generated/types';
import UserHistoryForms from '../users/overlay/history/userHistoryForms.graphql';
import { UserHistoryFormsQuery, UserHistoryFormsQueryVariables } from 'common/src/generated/types';
import EventProfilePrivateFieldsUpdate from '../users/overlay/informations/eventProfilePrivateFieldsUpdate.graphql';
import {
    EventProfilePrivateFieldsUpdateMutation,
    EventProfilePrivateFieldsUpdateMutationVariables
} from 'common/src/generated/types';
import OrganizationProfilePrivateFieldsUpdate from '../users/overlay/informations/organizationProfilePrivateFieldsUpdate.graphql';
import {
    OrganizationProfilePrivateFieldsUpdateMutation,
    OrganizationProfilePrivateFieldsUpdateMutationVariables
} from 'common/src/generated/types';
import UserInformationsEvent from '../users/overlay/informations/userInformationsEvent.graphql';
import {
    UserInformationsEventQuery,
    UserInformationsEventQueryVariables
} from 'common/src/generated/types';
import UserInformationsOrganization from '../users/overlay/informations/userInformationsOrganization.graphql';
import {
    UserInformationsOrganizationQuery,
    UserInformationsOrganizationQueryVariables
} from 'common/src/generated/types';
import VolunteerRegistrationTicketIdRegenerate from '../users/overlay/informations/volunteerRegistrationTicketIdRegenerate.graphql';
import {
    VolunteerRegistrationTicketIdRegenerateMutation,
    VolunteerRegistrationTicketIdRegenerateMutationVariables
} from 'common/src/generated/types';
import UserPositionsAvailablePositionsSlots from '../users/overlay/positions/userPositionsAvailablePositionsSlots.graphql';
import {
    UserPositionsAvailablePositionsSlotsQuery,
    UserPositionsAvailablePositionsSlotsQueryVariables
} from 'common/src/generated/types';
import UserOverlay from '../users/overlay/userOverlay.graphql';
import { UserOverlayQuery, UserOverlayQueryVariables } from 'common/src/generated/types';
import CommentCreate from '../users/show/comments/commentCreate.graphql';
import { CommentCreateMutation, CommentCreateMutationVariables } from 'common/src/generated/types';
import CommentDelete from '../users/show/comments/commentDelete.graphql';
import { CommentDeleteMutation, CommentDeleteMutationVariables } from 'common/src/generated/types';
import Comments from '../users/show/comments/comments.graphql';
import { CommentsQuery, CommentsQueryVariables } from 'common/src/generated/types';
import UpdateUserInfosEvent from '../users/update/updateUserInfosEvent.graphql';
import {
    UpdateUserInfosEventQuery,
    UpdateUserInfosEventQueryVariables
} from 'common/src/generated/types';
import UpdateUserInfosOrganization from '../users/update/updateUserInfosOrganization.graphql';
import {
    UpdateUserInfosOrganizationQuery,
    UpdateUserInfosOrganizationQueryVariables
} from 'common/src/generated/types';
import OrganizationUsersInfos from '../volunteers/create/organizationUsersInfos.graphql';
import {
    OrganizationUsersInfosQuery,
    OrganizationUsersInfosQueryVariables
} from 'common/src/generated/types';
import UserInfoAdminCreate from '../volunteers/create/userInfoAdminCreate.graphql';
import {
    UserInfoAdminCreateMutation,
    UserInfoAdminCreateMutationVariables
} from 'common/src/generated/types';
import VolunteersRegistrationsAdminAdd from '../volunteers/create/volunteersRegistrationsAdminAdd.graphql';
import {
    VolunteersRegistrationsAdminAddMutation,
    VolunteersRegistrationsAdminAddMutationVariables
} from 'common/src/generated/types';
import UsersInfosExport from '../volunteers/export/usersInfosExport.graphql';
import {
    UsersInfosExportMutation,
    UsersInfosExportMutationVariables
} from 'common/src/generated/types';
import VolunteersExport from '../volunteers/export/volunteersExport.graphql';
import {
    VolunteersExportMutation,
    VolunteersExportMutationVariables
} from 'common/src/generated/types';
import EventVolunteersImportInfos from '../volunteers/import/eventVolunteersImportInfos.graphql';
import {
    EventVolunteersImportInfosQuery,
    EventVolunteersImportInfosQueryVariables
} from 'common/src/generated/types';
import OrganizationImportInfos from '../volunteers/import/organizationImportInfos.graphql';
import {
    OrganizationImportInfosQuery,
    OrganizationImportInfosQueryVariables
} from 'common/src/generated/types';
import VolunteersAccreditationsMatrix from '../volunteers/list/accreditationsMatrix/volunteersAccreditationsMatrix.graphql';
import {
    VolunteersAccreditationsMatrixQuery,
    VolunteersAccreditationsMatrixQueryVariables
} from 'common/src/generated/types';
import VolunteersPlanning from '../volunteers/list/planning/volunteersPlanning.graphql';
import {
    VolunteersPlanningQuery,
    VolunteersPlanningQueryVariables
} from 'common/src/generated/types';
import VolunteerActions from '../volunteers/list/volunteerActions.graphql';
import { VolunteerActionsQuery, VolunteerActionsQueryVariables } from 'common/src/generated/types';
import VolunteersHeader from '../volunteers/list/volunteersHeader.graphql';
import { VolunteersHeaderQuery, VolunteersHeaderQueryVariables } from 'common/src/generated/types';
import MassAssignSlots from '../volunteers/massAssign/massAssignSlots.graphql';
import { MassAssignSlotsQuery, MassAssignSlotsQueryVariables } from 'common/src/generated/types';
import VolunteersRegistrationsMassPreAssign from '../volunteers/massAssign/volunteersRegistrationsMassPreAssign.graphql';
import {
    VolunteersRegistrationsMassPreAssignMutation,
    VolunteersRegistrationsMassPreAssignMutationVariables
} from 'common/src/generated/types';
import MassDelegationAddOrganizationDelegations from '../volunteers/massDelegationAdd/massDelegationAddOrganizationDelegations.graphql';
import {
    MassDelegationAddOrganizationDelegationsQuery,
    MassDelegationAddOrganizationDelegationsQueryVariables
} from 'common/src/generated/types';
import UsersInfosMassDelegationAdd from '../volunteers/massDelegationAdd/usersInfosMassDelegationAdd.graphql';
import {
    UsersInfosMassDelegationAddMutation,
    UsersInfosMassDelegationAddMutationVariables
} from 'common/src/generated/types';
import UsersInfosMassFormAdd from '../volunteers/massFormAdd/usersInfosMassFormAdd.graphql';
import {
    UsersInfosMassFormAddMutation,
    UsersInfosMassFormAddMutationVariables
} from 'common/src/generated/types';
import VolunteersRegistrationsMassFormAdd from '../volunteers/massFormAdd/volunteersRegistrationsMassFormAdd.graphql';
import {
    VolunteersRegistrationsMassFormAddMutation,
    VolunteersRegistrationsMassFormAddMutationVariables
} from 'common/src/generated/types';
import UsersInfosMassFormRemove from '../volunteers/massFormRemove/usersInfosMassFormRemove.graphql';
import {
    UsersInfosMassFormRemoveMutation,
    UsersInfosMassFormRemoveMutationVariables
} from 'common/src/generated/types';
import VolunteersRegistrationsMassFormRemove from '../volunteers/massFormRemove/volunteersRegistrationsMassFormRemove.graphql';
import {
    VolunteersRegistrationsMassFormRemoveMutation,
    VolunteersRegistrationsMassFormRemoveMutationVariables
} from 'common/src/generated/types';
import MassPreAssignCategories from '../volunteers/massPreAssign/massPreAssignCategories.graphql';
import {
    MassPreAssignCategoriesQuery,
    MassPreAssignCategoriesQueryVariables
} from 'common/src/generated/types';
import MassPreAssignPositions from '../volunteers/massPreAssign/massPreAssignPositions.graphql';
import {
    MassPreAssignPositionsQuery,
    MassPreAssignPositionsQueryVariables
} from 'common/src/generated/types';
import VolunteersMobile from '../volunteers/mobile/list/volunteersMobile.graphql';
import { VolunteersMobileQuery, VolunteersMobileQueryVariables } from 'common/src/generated/types';
import VolunteersSegmentsMobile from '../volunteers/mobile/list/volunteersSegmentsMobile.graphql';
import {
    VolunteersSegmentsMobileQuery,
    VolunteersSegmentsMobileQueryVariables
} from 'common/src/generated/types';
import RecentVolunteersSearchesMobile from '../volunteers/mobile/search/recentVolunteersSearchesMobile.graphql';
import {
    RecentVolunteersSearchesMobileQuery,
    RecentVolunteersSearchesMobileQueryVariables
} from 'common/src/generated/types';
import WorkflowAccreditations from '../workflows/create/steps/workflowAccreditations.graphql';
import {
    WorkflowAccreditationsQuery,
    WorkflowAccreditationsQueryVariables
} from 'common/src/generated/types';
import WorkflowCampaigns from '../workflows/create/steps/workflowCampaigns.graphql';
import {
    WorkflowCampaignsQuery,
    WorkflowCampaignsQueryVariables
} from 'common/src/generated/types';
import WorkflowCustomFields from '../workflows/create/steps/workflowCustomFields.graphql';
import {
    WorkflowCustomFieldsQuery,
    WorkflowCustomFieldsQueryVariables
} from 'common/src/generated/types';
import WorkflowPositions from '../workflows/create/steps/workflowPositions.graphql';
import {
    WorkflowPositionsQuery,
    WorkflowPositionsQueryVariables
} from 'common/src/generated/types';
import WorkflowVolunteersSegments from '../workflows/create/steps/workflowVolunteersSegments.graphql';
import {
    WorkflowVolunteersSegmentsQuery,
    WorkflowVolunteersSegmentsQueryVariables
} from 'common/src/generated/types';
import Workflow from '../workflows/create/workflow.graphql';
import { WorkflowQuery, WorkflowQueryVariables } from 'common/src/generated/types';
import WorkflowCreate from '../workflows/create/workflowCreate.graphql';
import {
    WorkflowCreateMutation,
    WorkflowCreateMutationVariables
} from 'common/src/generated/types';
import WorkflowUpdate from '../workflows/create/workflowUpdate.graphql';
import {
    WorkflowUpdateMutation,
    WorkflowUpdateMutationVariables
} from 'common/src/generated/types';
import WorkflowssMassDelete from '../workflows/delete/workflowssMassDelete.graphql';
import {
    WorkflowssMassDeleteMutation,
    WorkflowssMassDeleteMutationVariables
} from 'common/src/generated/types';
import WorkflowDuplicate from '../workflows/list/workflowDuplicate.graphql';
import {
    WorkflowDuplicateMutation,
    WorkflowDuplicateMutationVariables
} from 'common/src/generated/types';
import WorkflowExecute from '../workflows/list/workflowExecute.graphql';
import {
    WorkflowExecuteMutation,
    WorkflowExecuteMutationVariables
} from 'common/src/generated/types';
import Workflows from '../workflows/list/workflows.graphql';
import { WorkflowsQuery, WorkflowsQueryVariables } from 'common/src/generated/types';
import WorkflowsWorkflow from '../workflows/list/workflowsWorkflow.graphql';
import {
    WorkflowsWorkflowQuery,
    WorkflowsWorkflowQueryVariables
} from 'common/src/generated/types';

import { Fragments } from 'common/src/generated/fragments';
import { IFragment } from 'common/src/generated/fragments';

export interface IQueryFragments {
    query: string;
    fragments: IFragment[];
}

export const Queries = {
    AccreditationEventInfos,
    AccreditationToEdit,
    Accreditations,
    AccreditationsAccreditation,
    AccreditationsCategories,
    AccreditationsSegments,
    AccreditationMap,
    Accreditation,
    AccreditationChart,
    AccreditationSlots,
    AccreditationDashboard,
    AccreditInfos,
    AccreditSlots,
    AccreditationsAssignmentsEmails,
    AccreditationsAssignmentsKpis,
    AccreditationsCategory,
    AccreditationsCategoryAccreditations,
    AccreditationsCategoryChart,
    AccreditationsAccreditationSlot,
    AccreditationsSlotsList,
    AccreditationsSlot,
    AccreditationsSlotMembers,
    AssignmentInfos,
    AssignmentSlots,
    AssignmentsEmails,
    AssignmentsKpis,
    PreAssignmentsKpis,
    SendEmailInfos,
    TeamAssignmentInfos,
    TeamAssignmentWaitingTeams,
    Tokens,
    BackofficeInvoices,
    QontoTransactions,
    BackofficeOrganizations,
    BackofficeEvent,
    BackofficeOrganization,
    CampaignEventAccreditationsRecipients,
    CampaignEventPositionsRecipients,
    CampaignEventSegmentsRecipients,
    CampaignOrganizationSegmentsRecipients,
    Campaigns,
    Campaign,
    CampaignEmails,
    CampaignPreview,
    CampaignTextMessages,
    TextMessageReplies,
    CampaignsSegments,
    CommunityCampaigns,
    CommunityDashboard,
    CommunityDelegationsSegments,
    MergeMembers,
    UsersActions,
    PossibleDuplicates,
    CustomFieldToEdit,
    OrganizationInfos,
    CustomField,
    CustomFieldUsage,
    CustomFields,
    CustomFieldsSegments,
    Dashboard,
    DashboardMobile,
    DelegationEventInfos,
    DelegationEventToEdit,
    DelegationOrganizationInfos,
    DelegationOrganizationToEdit,
    EventUsersInfos,
    Delegations,
    DelegationsCategories,
    DelegationsDelegation,
    DelegationsSegments,
    ParentDelegations,
    DelegationsMassMoveInfos,
    DelegationDashboard,
    Delegation,
    DelegationReporting,
    DelegationCategoryDelegations,
    DelegationCategory,
    DelegationCategoryMembersInfos,
    CustomDocument,
    CustomDocumentConditions,
    Documents,
    PositionPlanningDocument,
    PositionSheetDocument,
    PlanningDocument,
    PositionsVolunteersPlanningDocument,
    UserAssignmentsDocument,
    UserBadgeDocument,
    UserCertificateDocument,
    UserCustomBadgeDocument,
    UserCustomDocumentExport,
    UserHoursDocument,
    UserPlanningDaysDocument,
    UserPlanningDocument,
    UserPlanningListDocument,
    UsersListingDocument,
    EmailTemplate,
    EmailsTemplates,
    AllEvents,
    EventCreateInfos,
    EventUpdateInfos,
    Events,
    EventsSegments,
    EventsEvent,
    EventsMobile,
    Event,
    FilesImportCustomFields,
    Forms,
    Form,
    FormElements,
    FormParametersAccreditations,
    FormParametersAccreditationsHiddenDisplayed,
    FormParametersAvailabilities,
    FormParametersBroadcastEvent,
    FormParametersBroadcastOrganization,
    FormParametersDesign,
    FormParametersGeneral,
    FormParametersMissions,
    FormParametersMissionsHiddenDisplayed,
    FormParametersState,
    HomeOrganizations,
    CollaboratorsVolunteers,
    EventKey,
    WeezeventRules,
    WeezeventV2Infos,
    Organizations,
    Organization,
    UserInfo,
    Activities,
    OrganizationCategoriesAccreditations,
    OrganizationCategoriesCustomFields,
    OrganizationCategoriesDelegations,
    OrganizationCategoriesPositions,
    OrganizationDelegationSpaceSettings,
    OrganizationDelegationsSpaceDesign,
    OrganizationDomains,
    EmailSenderToEdit,
    EmailsSenders,
    EmailSenderPreview,
    OrganizationParametersInfos,
    Invoices,
    OrganizationMembersSpaceDesign,
    OrganizationMembersSpaceSettings,
    Role,
    RoleUses,
    Roles,
    SkidataConnectionInfos,
    OrganizationTags,
    EventAdminsLeaders,
    Team,
    OrganizationTranslations,
    OrganizationTranslationsStats,
    PositionEventInfos,
    PositionToEdit,
    KmlEventInfos,
    PositionsCategories,
    PositionsPosition,
    Traces,
    PositionsPlanning,
    PositionsPlanningPosition,
    Positions,
    PositionsHeader,
    PositionsSegments,
    PositionMap,
    MassConditionsCustomFields,
    PositionsMobile,
    PositionsSegmentsMobile,
    RecentPositionsSearchesMobile,
    PositionSlotMembersMobile,
    PositionSlotsMobile,
    PositionDashboard,
    Position,
    PositionSlotVolunteers,
    PositionSlots,
    PositionCategory,
    PositionCategoryPositions,
    AvailableVolunteersRegistrations,
    PositionsPositionSlot,
    PositionsSlots,
    UserFieldUpdate,
    UserInfoMobile,
    UserProfileAccreditations,
    UserOverlayActionsEvent,
    UserOverlayActionsOrganization,
    UserHistoryCampaigns,
    UserHistoryEvents,
    UserHistoryForms,
    UserInformationsEvent,
    UserInformationsOrganization,
    UserPositionsAvailablePositionsSlots,
    UserOverlay,
    Comments,
    UpdateUserInfosEvent,
    UpdateUserInfosOrganization,
    OrganizationUsersInfos,
    EventVolunteersImportInfos,
    OrganizationImportInfos,
    VolunteersAccreditationsMatrix,
    VolunteersPlanning,
    VolunteerActions,
    VolunteersHeader,
    MassAssignSlots,
    MassDelegationAddOrganizationDelegations,
    MassPreAssignCategories,
    MassPreAssignPositions,
    VolunteersMobile,
    VolunteersSegmentsMobile,
    RecentVolunteersSearchesMobile,
    WorkflowAccreditations,
    WorkflowCampaigns,
    WorkflowCustomFields,
    WorkflowPositions,
    WorkflowVolunteersSegments,
    Workflow,
    Workflows,
    WorkflowsWorkflow
};

export const Mutations = {
    AccreditationCreate,
    AccreditationUpdate,
    AccreditationsMassDelete,
    AccreditationSlotDelete,
    AccreditationsEmailsEstimate,
    SendAccreditationsEmails,
    AccreditationCategoryCreate,
    AccreditationCategoryUpdate,
    AccreditationCategoryDelete,
    AccreditationCategoryDuplicate,
    AccreditationSlotUpdate,
    VolunteerRegistrationAssignmentRefuse,
    AssignmentsEmailsEstimate,
    SendAssignmentsEmails,
    TeamAssign,
    TeamAssignmentRefuse,
    BackofficeInvoiceMarkAsPaid,
    BackofficeOrganizationUserAdd,
    BackofficeOrganizationUserRemove,
    BackofficeEventUnarchive,
    BackofficeOrganizationUpdate,
    CampaignDelete,
    CampaignDuplicate,
    CampaignSend,
    TextMessageSend,
    TextMessageRepliesRead,
    UsersInfosMassAddEvent,
    UsersInfosMerge,
    UsersInfosMassDelete,
    CustomFieldCategoryCreate,
    CustomFieldCreate,
    CustomFieldUpdate,
    CustomFieldCategoryDelete,
    CustomFieldDuplicate,
    CustomFieldsMassDelete,
    CustomFieldCategoryUpdate,
    DelegationCreate,
    DelegationUpdate,
    DelegationsImport,
    DelegationDuplicate,
    DelegationsExport,
    DelegationsMassDelete,
    DelegationsMassMove,
    DelegationCategoryCreate,
    DelegationCategoryUpdate,
    DelegationCategoryDelete,
    DelegationCategoryDuplicate,
    CustomDocumentUpdate,
    CustomDocumentCreate,
    CustomDocumentDelete,
    CustomDocumentDuplicate,
    EventDocumentUpdate,
    EmailTemplateUpdate,
    CreateEvent,
    EventOrganizationCreate,
    EventUpdate,
    EventDuplicate,
    EventsMassArchive,
    FilesImport,
    FormCreate,
    FormDelete,
    FormDuplicate,
    FormElementsUpdate,
    FormParametersAccreditationsUpdate,
    FormParametersAvailabilitiesUpdate,
    FormParametersBroadcastUpdate,
    FormParametersDesignUpdate,
    FormParametersGeneralUpdate,
    FormParametersMissionsUpdate,
    FormParametersStateUpdate,
    DelegationsImportResult,
    EventDocumentsExportResult,
    ExportResult,
    FilesImportResult,
    PositionsImportResult,
    EventWeezeventUpdate,
    OrganizationCreate,
    UserInfoAndTermsUpdate,
    OrganizationDelegationSpaceSettingsUpdate,
    OrganizationDelegationsSpaceDesignUpdate,
    DomainDkimVerificationRetry,
    EmailSenderCreate,
    EmailSenderUpdate,
    EmailSenderDelete,
    EmailSenderDuplicate,
    EmailSenderVerificationResend,
    OrganizationUpdateInfos,
    OrganizationMembersSpaceDesignUpdate,
    OrganizationMembersSpaceSettingsUpdate,
    UserDelete,
    RoleCreate,
    RoleUpdate,
    RoleDelete,
    SkidataConnectionInfoSeaonEventAdd,
    SkidataConnectionInfoSeaonEventDelete,
    SkidataConnectionInfoSynchronizedEventAdd,
    SkidataConnectionInfoSynchronizedEventDelete,
    SkidataConnectionInfosDelete,
    SkidataConnectionInfosUpsert,
    SkidataSynchronize,
    TagCreate,
    TagDelete,
    TagUpdateName,
    EventInvite,
    OrganizationInvite,
    UserEventDelete,
    UserEventUpdate,
    UserLeaderDelete,
    UserOrganizationDelete,
    UserOrganizationUpdate,
    UserPositionCategoryUpdate,
    UserPositionUpdate,
    TranslationUpdate,
    PositionCreate,
    PositionUpdate,
    PositionsImport,
    PositionsCreate,
    PositionsMassDelete,
    EventLayerUpdate,
    TraceCreate,
    TraceDelete,
    TraceUpdate,
    PositionSlotCreate,
    PositionCategoryLeaderDelete,
    PositionsMassConditions,
    PositionLeaderDelete,
    PositionLeadersAsign,
    PositionSlotDelete,
    PositionSlotUpdate,
    PositionCategoryCreate,
    PositionCategoryUpdate,
    PositionCategoryDelete,
    PositionCategoryDescriptionUpdate,
    PositionCategoryDuplicate,
    PositionsCategoryLeadersAssign,
    UserInfoAdminDelete,
    EventProfilePrivateFieldsUpdate,
    OrganizationProfilePrivateFieldsUpdate,
    VolunteerRegistrationTicketIdRegenerate,
    CommentCreate,
    CommentDelete,
    UserInfoAdminCreate,
    VolunteersRegistrationsAdminAdd,
    UsersInfosExport,
    VolunteersExport,
    VolunteersRegistrationsMassPreAssign,
    UsersInfosMassDelegationAdd,
    UsersInfosMassFormAdd,
    VolunteersRegistrationsMassFormAdd,
    UsersInfosMassFormRemove,
    VolunteersRegistrationsMassFormRemove,
    WorkflowCreate,
    WorkflowUpdate,
    WorkflowssMassDelete,
    WorkflowDuplicate,
    WorkflowExecute
};

export function useAccreditationCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<AccreditationCreateMutation, AccreditationCreateMutationVariables> {
    return useMutation(Mutations.AccreditationCreate, args);
}

export function useAccreditationEventInfosQuery(
    args: AccreditationEventInfosQueryVariables
): IUseQueryReturns<AccreditationEventInfosQuery> {
    return useQuery(Queries.AccreditationEventInfos, args, [
        Fragments.ConditionsCustomFieldsFragment,
        Fragments.FormCustomFieldsFragment,
        Fragments.CreatePositionTagsFragment,
        Fragments.AttachCustomFieldFragment,
        Fragments.CreateAccreditationEventFragment
    ]);
}

export function executeAccreditationEventInfosQuery(
    args: AccreditationEventInfosQueryVariables,
    token: string | null | undefined
): Promise<AccreditationEventInfosQuery> {
    return executeQuery<AccreditationEventInfosQuery>(Queries.AccreditationEventInfos, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.ConditionsCustomFieldsFragment,
            Fragments.FormCustomFieldsFragment,
            Fragments.CreatePositionTagsFragment,
            Fragments.AttachCustomFieldFragment,
            Fragments.CreateAccreditationEventFragment
        ]
    });
}

export function useAccreditationToEditQuery(
    args: AccreditationToEditQueryVariables
): IUseQueryReturns<AccreditationToEditQuery> {
    return useQuery(Queries.AccreditationToEdit, args, [
        Fragments.ConditionsCustomFieldsFragment,
        Fragments.FormCustomFieldsFragment,
        Fragments.CreatePositionTagsFragment,
        Fragments.AttachCustomFieldFragment,
        Fragments.CreateAccreditationEventFragment
    ]);
}

export function executeAccreditationToEditQuery(
    args: AccreditationToEditQueryVariables,
    token: string | null | undefined
): Promise<AccreditationToEditQuery> {
    return executeQuery<AccreditationToEditQuery>(Queries.AccreditationToEdit, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.ConditionsCustomFieldsFragment,
            Fragments.FormCustomFieldsFragment,
            Fragments.CreatePositionTagsFragment,
            Fragments.AttachCustomFieldFragment,
            Fragments.CreateAccreditationEventFragment
        ]
    });
}

export function useAccreditationUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<AccreditationUpdateMutation, AccreditationUpdateMutationVariables> {
    return useMutation(Mutations.AccreditationUpdate, args);
}

export function useAccreditationsQuery(
    args: AccreditationsQueryVariables
): IUseQueryReturns<AccreditationsQuery> {
    return useQuery(Queries.Accreditations, args, [Fragments.AccreditationsAccreditationFragment]);
}

export function executeAccreditationsQuery(
    args: AccreditationsQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsQuery> {
    return executeQuery<AccreditationsQuery>(Queries.Accreditations, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.AccreditationsAccreditationFragment]
    });
}

export function useAccreditationsAccreditationQuery(
    args: AccreditationsAccreditationQueryVariables
): IUseQueryReturns<AccreditationsAccreditationQuery> {
    return useQuery(Queries.AccreditationsAccreditation, args, [
        Fragments.AccreditationsAccreditationFragment
    ]);
}

export function executeAccreditationsAccreditationQuery(
    args: AccreditationsAccreditationQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsAccreditationQuery> {
    return executeQuery<AccreditationsAccreditationQuery>(Queries.AccreditationsAccreditation, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.AccreditationsAccreditationFragment]
    });
}

export function useAccreditationsCategoriesQuery(
    args: AccreditationsCategoriesQueryVariables
): IUseQueryReturns<AccreditationsCategoriesQuery> {
    return useQuery(Queries.AccreditationsCategories, args, []);
}

export function executeAccreditationsCategoriesQuery(
    args: AccreditationsCategoriesQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsCategoriesQuery> {
    return executeQuery<AccreditationsCategoriesQuery>(Queries.AccreditationsCategories, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useAccreditationsMassDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    AccreditationsMassDeleteMutation,
    AccreditationsMassDeleteMutationVariables
> {
    return useMutation(Mutations.AccreditationsMassDelete, args);
}

export function useAccreditationsSegmentsQuery(
    args: AccreditationsSegmentsQueryVariables
): IUseQueryReturns<AccreditationsSegmentsQuery> {
    return useQuery(Queries.AccreditationsSegments, args, [
        Fragments.SegmentCustomFieldFragment,
        Fragments.SegmentsFoldersSegmentsFragment
    ]);
}

export function executeAccreditationsSegmentsQuery(
    args: AccreditationsSegmentsQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsSegmentsQuery> {
    return executeQuery<AccreditationsSegmentsQuery>(Queries.AccreditationsSegments, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.SegmentCustomFieldFragment, Fragments.SegmentsFoldersSegmentsFragment]
    });
}

export function useAccreditationMapQuery(
    args: AccreditationMapQueryVariables
): IUseQueryReturns<AccreditationMapQuery> {
    return useQuery(Queries.AccreditationMap, args, []);
}

export function executeAccreditationMapQuery(
    args: AccreditationMapQueryVariables,
    token: string | null | undefined
): Promise<AccreditationMapQuery> {
    return executeQuery<AccreditationMapQuery>(Queries.AccreditationMap, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useAccreditationQuery(
    args: AccreditationQueryVariables
): IUseQueryReturns<AccreditationQuery> {
    return useQuery(Queries.Accreditation, args, []);
}

export function executeAccreditationQuery(
    args: AccreditationQueryVariables,
    token: string | null | undefined
): Promise<AccreditationQuery> {
    return executeQuery<AccreditationQuery>(Queries.Accreditation, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useAccreditationChartQuery(
    args: AccreditationChartQueryVariables
): IUseQueryReturns<AccreditationChartQuery> {
    return useQuery(Queries.AccreditationChart, args, [Fragments.AccreditationChartFragment]);
}

export function executeAccreditationChartQuery(
    args: AccreditationChartQueryVariables,
    token: string | null | undefined
): Promise<AccreditationChartQuery> {
    return executeQuery<AccreditationChartQuery>(Queries.AccreditationChart, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.AccreditationChartFragment]
    });
}

export function useAccreditationSlotDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<AccreditationSlotDeleteMutation, AccreditationSlotDeleteMutationVariables> {
    return useMutation(Mutations.AccreditationSlotDelete, args);
}

export function useAccreditationSlotsQuery(
    args: AccreditationSlotsQueryVariables
): IUseQueryReturns<AccreditationSlotsQuery> {
    return useQuery(Queries.AccreditationSlots, args, []);
}

export function executeAccreditationSlotsQuery(
    args: AccreditationSlotsQueryVariables,
    token: string | null | undefined
): Promise<AccreditationSlotsQuery> {
    return executeQuery<AccreditationSlotsQuery>(Queries.AccreditationSlots, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useAccreditationDashboardQuery(
    args: AccreditationDashboardQueryVariables
): IUseQueryReturns<AccreditationDashboardQuery> {
    return useQuery(Queries.AccreditationDashboard, args, [
        Fragments.CustomFieldWithConditionFragment
    ]);
}

export function executeAccreditationDashboardQuery(
    args: AccreditationDashboardQueryVariables,
    token: string | null | undefined
): Promise<AccreditationDashboardQuery> {
    return executeQuery<AccreditationDashboardQuery>(Queries.AccreditationDashboard, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CustomFieldWithConditionFragment]
    });
}

export function useAccreditInfosQuery(
    args: AccreditInfosQueryVariables
): IUseQueryReturns<AccreditInfosQuery> {
    return useQuery(Queries.AccreditInfos, args, [
        Fragments.FormsUsersInfosWishedFragment,
        Fragments.CustomFieldWithConditionFragment,
        Fragments.DelegationAccreditationsSlotsFragment
    ]);
}

export function executeAccreditInfosQuery(
    args: AccreditInfosQueryVariables,
    token: string | null | undefined
): Promise<AccreditInfosQuery> {
    return executeQuery<AccreditInfosQuery>(Queries.AccreditInfos, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.FormsUsersInfosWishedFragment,
            Fragments.CustomFieldWithConditionFragment,
            Fragments.DelegationAccreditationsSlotsFragment
        ]
    });
}

export function useAccreditSlotsQuery(
    args: AccreditSlotsQueryVariables
): IUseQueryReturns<AccreditSlotsQuery> {
    return useQuery(Queries.AccreditSlots, args, [Fragments.AccreditationsSlotFragment]);
}

export function executeAccreditSlotsQuery(
    args: AccreditSlotsQueryVariables,
    token: string | null | undefined
): Promise<AccreditSlotsQuery> {
    return executeQuery<AccreditSlotsQuery>(Queries.AccreditSlots, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.AccreditationsSlotFragment]
    });
}

export function useAccreditationsAssignmentsEmailsQuery(
    args: AccreditationsAssignmentsEmailsQueryVariables
): IUseQueryReturns<AccreditationsAssignmentsEmailsQuery> {
    return useQuery(Queries.AccreditationsAssignmentsEmails, args, [
        Fragments.EmailRecipientFragment
    ]);
}

export function executeAccreditationsAssignmentsEmailsQuery(
    args: AccreditationsAssignmentsEmailsQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsAssignmentsEmailsQuery> {
    return executeQuery<AccreditationsAssignmentsEmailsQuery>(
        Queries.AccreditationsAssignmentsEmails,
        {
            variables: args,
            token: token || undefined,
            fragments: [Fragments.EmailRecipientFragment]
        }
    );
}

export function useAccreditationsAssignmentsKpisQuery(
    args: AccreditationsAssignmentsKpisQueryVariables
): IUseQueryReturns<AccreditationsAssignmentsKpisQuery> {
    return useQuery(Queries.AccreditationsAssignmentsKpis, args, []);
}

export function executeAccreditationsAssignmentsKpisQuery(
    args: AccreditationsAssignmentsKpisQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsAssignmentsKpisQuery> {
    return executeQuery<AccreditationsAssignmentsKpisQuery>(Queries.AccreditationsAssignmentsKpis, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useAccreditationsEmailsEstimateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    AccreditationsEmailsEstimateMutation,
    AccreditationsEmailsEstimateMutationVariables
> {
    return useMutation(Mutations.AccreditationsEmailsEstimate, args);
}

export function useSendAccreditationsEmailsMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    SendAccreditationsEmailsMutation,
    SendAccreditationsEmailsMutationVariables
> {
    return useMutation(Mutations.SendAccreditationsEmails, args);
}

export function useAccreditationCategoryCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    AccreditationCategoryCreateMutation,
    AccreditationCategoryCreateMutationVariables
> {
    return useMutation(Mutations.AccreditationCategoryCreate, args);
}

export function useAccreditationCategoryUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    AccreditationCategoryUpdateMutation,
    AccreditationCategoryUpdateMutationVariables
> {
    return useMutation(Mutations.AccreditationCategoryUpdate, args);
}

export function useAccreditationCategoryDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    AccreditationCategoryDeleteMutation,
    AccreditationCategoryDeleteMutationVariables
> {
    return useMutation(Mutations.AccreditationCategoryDelete, args);
}

export function useAccreditationCategoryDuplicateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    AccreditationCategoryDuplicateMutation,
    AccreditationCategoryDuplicateMutationVariables
> {
    return useMutation(Mutations.AccreditationCategoryDuplicate, args);
}

export function useAccreditationsCategoryQuery(
    args: AccreditationsCategoryQueryVariables
): IUseQueryReturns<AccreditationsCategoryQuery> {
    return useQuery(Queries.AccreditationsCategory, args, []);
}

export function executeAccreditationsCategoryQuery(
    args: AccreditationsCategoryQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsCategoryQuery> {
    return executeQuery<AccreditationsCategoryQuery>(Queries.AccreditationsCategory, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useAccreditationsCategoryAccreditationsQuery(
    args: AccreditationsCategoryAccreditationsQueryVariables
): IUseQueryReturns<AccreditationsCategoryAccreditationsQuery> {
    return useQuery(Queries.AccreditationsCategoryAccreditations, args, []);
}

export function executeAccreditationsCategoryAccreditationsQuery(
    args: AccreditationsCategoryAccreditationsQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsCategoryAccreditationsQuery> {
    return executeQuery<AccreditationsCategoryAccreditationsQuery>(
        Queries.AccreditationsCategoryAccreditations,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useAccreditationsCategoryChartQuery(
    args: AccreditationsCategoryChartQueryVariables
): IUseQueryReturns<AccreditationsCategoryChartQuery> {
    return useQuery(Queries.AccreditationsCategoryChart, args, [
        Fragments.AccreditationChartFragment
    ]);
}

export function executeAccreditationsCategoryChartQuery(
    args: AccreditationsCategoryChartQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsCategoryChartQuery> {
    return executeQuery<AccreditationsCategoryChartQuery>(Queries.AccreditationsCategoryChart, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.AccreditationChartFragment]
    });
}

export function useAccreditationSlotUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<AccreditationSlotUpdateMutation, AccreditationSlotUpdateMutationVariables> {
    return useMutation(Mutations.AccreditationSlotUpdate, args);
}

export function useAccreditationsAccreditationSlotQuery(
    args: AccreditationsAccreditationSlotQueryVariables
): IUseQueryReturns<AccreditationsAccreditationSlotQuery> {
    return useQuery(Queries.AccreditationsAccreditationSlot, args, [
        Fragments.AccreditationsAccreditationSlotFragment
    ]);
}

export function executeAccreditationsAccreditationSlotQuery(
    args: AccreditationsAccreditationSlotQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsAccreditationSlotQuery> {
    return executeQuery<AccreditationsAccreditationSlotQuery>(
        Queries.AccreditationsAccreditationSlot,
        {
            variables: args,
            token: token || undefined,
            fragments: [Fragments.AccreditationsAccreditationSlotFragment]
        }
    );
}

export function useAccreditationsSlotsListQuery(
    args: AccreditationsSlotsListQueryVariables
): IUseQueryReturns<AccreditationsSlotsListQuery> {
    return useQuery(Queries.AccreditationsSlotsList, args, [
        Fragments.AccreditationsAccreditationSlotFragment
    ]);
}

export function executeAccreditationsSlotsListQuery(
    args: AccreditationsSlotsListQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsSlotsListQuery> {
    return executeQuery<AccreditationsSlotsListQuery>(Queries.AccreditationsSlotsList, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.AccreditationsAccreditationSlotFragment]
    });
}

export function useAccreditationsSlotQuery(
    args: AccreditationsSlotQueryVariables
): IUseQueryReturns<AccreditationsSlotQuery> {
    return useQuery(Queries.AccreditationsSlot, args, [Fragments.CustomFieldWithConditionFragment]);
}

export function executeAccreditationsSlotQuery(
    args: AccreditationsSlotQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsSlotQuery> {
    return executeQuery<AccreditationsSlotQuery>(Queries.AccreditationsSlot, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CustomFieldWithConditionFragment]
    });
}

export function useAccreditationsSlotMembersQuery(
    args: AccreditationsSlotMembersQueryVariables
): IUseQueryReturns<AccreditationsSlotMembersQuery> {
    return useQuery(Queries.AccreditationsSlotMembers, args, [Fragments.VolunteerInfosFragment]);
}

export function executeAccreditationsSlotMembersQuery(
    args: AccreditationsSlotMembersQueryVariables,
    token: string | null | undefined
): Promise<AccreditationsSlotMembersQuery> {
    return executeQuery<AccreditationsSlotMembersQuery>(Queries.AccreditationsSlotMembers, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.VolunteerInfosFragment]
    });
}

export function useAssignmentInfosQuery(
    args: AssignmentInfosQueryVariables
): IUseQueryReturns<AssignmentInfosQuery> {
    return useQuery(Queries.AssignmentInfos, args, [
        Fragments.FormsUsersInfosWishedFragment,
        Fragments.CustomFieldWithConditionFragment,
        Fragments.UserInfoTeamMemberFragment
    ]);
}

export function executeAssignmentInfosQuery(
    args: AssignmentInfosQueryVariables,
    token: string | null | undefined
): Promise<AssignmentInfosQuery> {
    return executeQuery<AssignmentInfosQuery>(Queries.AssignmentInfos, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.FormsUsersInfosWishedFragment,
            Fragments.CustomFieldWithConditionFragment,
            Fragments.UserInfoTeamMemberFragment
        ]
    });
}

export function useAssignmentSlotsQuery(
    args: AssignmentSlotsQueryVariables
): IUseQueryReturns<AssignmentSlotsQuery> {
    return useQuery(Queries.AssignmentSlots, args, [
        Fragments.PositionPositionsCustomFieldsFragment
    ]);
}

export function executeAssignmentSlotsQuery(
    args: AssignmentSlotsQueryVariables,
    token: string | null | undefined
): Promise<AssignmentSlotsQuery> {
    return executeQuery<AssignmentSlotsQuery>(Queries.AssignmentSlots, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.PositionPositionsCustomFieldsFragment]
    });
}

export function useVolunteerRegistrationAssignmentRefuseMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    VolunteerRegistrationAssignmentRefuseMutation,
    VolunteerRegistrationAssignmentRefuseMutationVariables
> {
    return useMutation(Mutations.VolunteerRegistrationAssignmentRefuse, args);
}

export function useAssignmentsEmailsQuery(
    args: AssignmentsEmailsQueryVariables
): IUseQueryReturns<AssignmentsEmailsQuery> {
    return useQuery(Queries.AssignmentsEmails, args, [Fragments.EmailRecipientFragment]);
}

export function executeAssignmentsEmailsQuery(
    args: AssignmentsEmailsQueryVariables,
    token: string | null | undefined
): Promise<AssignmentsEmailsQuery> {
    return executeQuery<AssignmentsEmailsQuery>(Queries.AssignmentsEmails, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.EmailRecipientFragment]
    });
}

export function useAssignmentsEmailsEstimateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    AssignmentsEmailsEstimateMutation,
    AssignmentsEmailsEstimateMutationVariables
> {
    return useMutation(Mutations.AssignmentsEmailsEstimate, args);
}

export function useAssignmentsKpisQuery(
    args: AssignmentsKpisQueryVariables
): IUseQueryReturns<AssignmentsKpisQuery> {
    return useQuery(Queries.AssignmentsKpis, args, []);
}

export function executeAssignmentsKpisQuery(
    args: AssignmentsKpisQueryVariables,
    token: string | null | undefined
): Promise<AssignmentsKpisQuery> {
    return executeQuery<AssignmentsKpisQuery>(Queries.AssignmentsKpis, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function usePreAssignmentsKpisQuery(
    args: PreAssignmentsKpisQueryVariables
): IUseQueryReturns<PreAssignmentsKpisQuery> {
    return useQuery(Queries.PreAssignmentsKpis, args, []);
}

export function executePreAssignmentsKpisQuery(
    args: PreAssignmentsKpisQueryVariables,
    token: string | null | undefined
): Promise<PreAssignmentsKpisQuery> {
    return executeQuery<PreAssignmentsKpisQuery>(Queries.PreAssignmentsKpis, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useSendAssignmentsEmailsMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<SendAssignmentsEmailsMutation, SendAssignmentsEmailsMutationVariables> {
    return useMutation(Mutations.SendAssignmentsEmails, args);
}

export function useSendEmailInfosQuery(
    args: SendEmailInfosQueryVariables
): IUseQueryReturns<SendEmailInfosQuery> {
    return useQuery(Queries.SendEmailInfos, args, []);
}

export function executeSendEmailInfosQuery(
    args: SendEmailInfosQueryVariables,
    token: string | null | undefined
): Promise<SendEmailInfosQuery> {
    return executeQuery<SendEmailInfosQuery>(Queries.SendEmailInfos, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useTeamAssignMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<TeamAssignMutation, TeamAssignMutationVariables> {
    return useMutation(Mutations.TeamAssign, args);
}

export function useTeamAssignmentInfosQuery(
    args: TeamAssignmentInfosQueryVariables
): IUseQueryReturns<TeamAssignmentInfosQuery> {
    return useQuery(Queries.TeamAssignmentInfos, args, [
        Fragments.CustomFieldWithConditionFragment,
        Fragments.FormsUsersInfosWishedFragment
    ]);
}

export function executeTeamAssignmentInfosQuery(
    args: TeamAssignmentInfosQueryVariables,
    token: string | null | undefined
): Promise<TeamAssignmentInfosQuery> {
    return executeQuery<TeamAssignmentInfosQuery>(Queries.TeamAssignmentInfos, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.CustomFieldWithConditionFragment,
            Fragments.FormsUsersInfosWishedFragment
        ]
    });
}

export function useTeamAssignmentRefuseMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<TeamAssignmentRefuseMutation, TeamAssignmentRefuseMutationVariables> {
    return useMutation(Mutations.TeamAssignmentRefuse, args);
}

export function useTeamAssignmentWaitingTeamsQuery(
    args: TeamAssignmentWaitingTeamsQueryVariables
): IUseQueryReturns<TeamAssignmentWaitingTeamsQuery> {
    return useQuery(Queries.TeamAssignmentWaitingTeams, args, [
        Fragments.VolunteerRegistrationWaitingAssignmentFragment
    ]);
}

export function executeTeamAssignmentWaitingTeamsQuery(
    args: TeamAssignmentWaitingTeamsQueryVariables,
    token: string | null | undefined
): Promise<TeamAssignmentWaitingTeamsQuery> {
    return executeQuery<TeamAssignmentWaitingTeamsQuery>(Queries.TeamAssignmentWaitingTeams, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.VolunteerRegistrationWaitingAssignmentFragment]
    });
}

export function useTokensQuery(args: TokensQueryVariables): IUseQueryReturns<TokensQuery> {
    return useQuery(Queries.Tokens, args, []);
}

export function executeTokensQuery(
    args: TokensQueryVariables,
    token: string | null | undefined
): Promise<TokensQuery> {
    return executeQuery<TokensQuery>(Queries.Tokens, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useBackofficeInvoiceMarkAsPaidMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    BackofficeInvoiceMarkAsPaidMutation,
    BackofficeInvoiceMarkAsPaidMutationVariables
> {
    return useMutation(Mutations.BackofficeInvoiceMarkAsPaid, args);
}

export function useBackofficeInvoicesQuery(
    args: BackofficeInvoicesQueryVariables
): IUseQueryReturns<BackofficeInvoicesQuery> {
    return useQuery(Queries.BackofficeInvoices, args, []);
}

export function executeBackofficeInvoicesQuery(
    args: BackofficeInvoicesQueryVariables,
    token: string | null | undefined
): Promise<BackofficeInvoicesQuery> {
    return executeQuery<BackofficeInvoicesQuery>(Queries.BackofficeInvoices, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useQontoTransactionsQuery(
    args: QontoTransactionsQueryVariables
): IUseQueryReturns<QontoTransactionsQuery> {
    return useQuery(Queries.QontoTransactions, args, []);
}

export function executeQontoTransactionsQuery(
    args: QontoTransactionsQueryVariables,
    token: string | null | undefined
): Promise<QontoTransactionsQuery> {
    return executeQuery<QontoTransactionsQuery>(Queries.QontoTransactions, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useBackofficeOrganizationUserAddMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    BackofficeOrganizationUserAddMutation,
    BackofficeOrganizationUserAddMutationVariables
> {
    return useMutation(Mutations.BackofficeOrganizationUserAdd, args);
}

export function useBackofficeOrganizationUserRemoveMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    BackofficeOrganizationUserRemoveMutation,
    BackofficeOrganizationUserRemoveMutationVariables
> {
    return useMutation(Mutations.BackofficeOrganizationUserRemove, args);
}

export function useBackofficeOrganizationsQuery(
    args: BackofficeOrganizationsQueryVariables
): IUseQueryReturns<BackofficeOrganizationsQuery> {
    return useQuery(Queries.BackofficeOrganizations, args, []);
}

export function executeBackofficeOrganizationsQuery(
    args: BackofficeOrganizationsQueryVariables,
    token: string | null | undefined
): Promise<BackofficeOrganizationsQuery> {
    return executeQuery<BackofficeOrganizationsQuery>(Queries.BackofficeOrganizations, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useBackofficeEventUnarchiveMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    BackofficeEventUnarchiveMutation,
    BackofficeEventUnarchiveMutationVariables
> {
    return useMutation(Mutations.BackofficeEventUnarchive, args);
}

export function useBackofficeEventQuery(
    args: BackofficeEventQueryVariables
): IUseQueryReturns<BackofficeEventQuery> {
    return useQuery(Queries.BackofficeEvent, args, []);
}

export function executeBackofficeEventQuery(
    args: BackofficeEventQueryVariables,
    token: string | null | undefined
): Promise<BackofficeEventQuery> {
    return executeQuery<BackofficeEventQuery>(Queries.BackofficeEvent, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useBackofficeOrganizationQuery(
    args: BackofficeOrganizationQueryVariables
): IUseQueryReturns<BackofficeOrganizationQuery> {
    return useQuery(Queries.BackofficeOrganization, args, []);
}

export function executeBackofficeOrganizationQuery(
    args: BackofficeOrganizationQueryVariables,
    token: string | null | undefined
): Promise<BackofficeOrganizationQuery> {
    return executeQuery<BackofficeOrganizationQuery>(Queries.BackofficeOrganization, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useBackofficeOrganizationUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    BackofficeOrganizationUpdateMutation,
    BackofficeOrganizationUpdateMutationVariables
> {
    return useMutation(Mutations.BackofficeOrganizationUpdate, args);
}

export function useCampaignEventAccreditationsRecipientsQuery(
    args: CampaignEventAccreditationsRecipientsQueryVariables
): IUseQueryReturns<CampaignEventAccreditationsRecipientsQuery> {
    return useQuery(Queries.CampaignEventAccreditationsRecipients, args, []);
}

export function executeCampaignEventAccreditationsRecipientsQuery(
    args: CampaignEventAccreditationsRecipientsQueryVariables,
    token: string | null | undefined
): Promise<CampaignEventAccreditationsRecipientsQuery> {
    return executeQuery<CampaignEventAccreditationsRecipientsQuery>(
        Queries.CampaignEventAccreditationsRecipients,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useCampaignEventPositionsRecipientsQuery(
    args: CampaignEventPositionsRecipientsQueryVariables
): IUseQueryReturns<CampaignEventPositionsRecipientsQuery> {
    return useQuery(Queries.CampaignEventPositionsRecipients, args, []);
}

export function executeCampaignEventPositionsRecipientsQuery(
    args: CampaignEventPositionsRecipientsQueryVariables,
    token: string | null | undefined
): Promise<CampaignEventPositionsRecipientsQuery> {
    return executeQuery<CampaignEventPositionsRecipientsQuery>(
        Queries.CampaignEventPositionsRecipients,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useCampaignEventSegmentsRecipientsQuery(
    args: CampaignEventSegmentsRecipientsQueryVariables
): IUseQueryReturns<CampaignEventSegmentsRecipientsQuery> {
    return useQuery(Queries.CampaignEventSegmentsRecipients, args, []);
}

export function executeCampaignEventSegmentsRecipientsQuery(
    args: CampaignEventSegmentsRecipientsQueryVariables,
    token: string | null | undefined
): Promise<CampaignEventSegmentsRecipientsQuery> {
    return executeQuery<CampaignEventSegmentsRecipientsQuery>(
        Queries.CampaignEventSegmentsRecipients,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useCampaignOrganizationSegmentsRecipientsQuery(
    args: CampaignOrganizationSegmentsRecipientsQueryVariables
): IUseQueryReturns<CampaignOrganizationSegmentsRecipientsQuery> {
    return useQuery(Queries.CampaignOrganizationSegmentsRecipients, args, []);
}

export function executeCampaignOrganizationSegmentsRecipientsQuery(
    args: CampaignOrganizationSegmentsRecipientsQueryVariables,
    token: string | null | undefined
): Promise<CampaignOrganizationSegmentsRecipientsQuery> {
    return executeQuery<CampaignOrganizationSegmentsRecipientsQuery>(
        Queries.CampaignOrganizationSegmentsRecipients,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useCampaignDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CampaignDeleteMutation, CampaignDeleteMutationVariables> {
    return useMutation(Mutations.CampaignDelete, args);
}

export function useCampaignDuplicateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CampaignDuplicateMutation, CampaignDuplicateMutationVariables> {
    return useMutation(Mutations.CampaignDuplicate, args);
}

export function useCampaignSendMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CampaignSendMutation, CampaignSendMutationVariables> {
    return useMutation(Mutations.CampaignSend, args);
}

export function useCampaignsQuery(args: CampaignsQueryVariables): IUseQueryReturns<CampaignsQuery> {
    return useQuery(Queries.Campaigns, args, [Fragments.CampaignListFragment]);
}

export function executeCampaignsQuery(
    args: CampaignsQueryVariables,
    token: string | null | undefined
): Promise<CampaignsQuery> {
    return executeQuery<CampaignsQuery>(Queries.Campaigns, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CampaignListFragment]
    });
}

export function useCampaignQuery(args: CampaignQueryVariables): IUseQueryReturns<CampaignQuery> {
    return useQuery(Queries.Campaign, args, []);
}

export function executeCampaignQuery(
    args: CampaignQueryVariables,
    token: string | null | undefined
): Promise<CampaignQuery> {
    return executeQuery<CampaignQuery>(Queries.Campaign, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useCampaignEmailsQuery(
    args: CampaignEmailsQueryVariables
): IUseQueryReturns<CampaignEmailsQuery> {
    return useQuery(Queries.CampaignEmails, args, [Fragments.EmailRecipientFragment]);
}

export function executeCampaignEmailsQuery(
    args: CampaignEmailsQueryVariables,
    token: string | null | undefined
): Promise<CampaignEmailsQuery> {
    return executeQuery<CampaignEmailsQuery>(Queries.CampaignEmails, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.EmailRecipientFragment]
    });
}

export function useCampaignPreviewQuery(
    args: CampaignPreviewQueryVariables
): IUseQueryReturns<CampaignPreviewQuery> {
    return useQuery(Queries.CampaignPreview, args, [Fragments.DocumentEmailPreviewFragment]);
}

export function executeCampaignPreviewQuery(
    args: CampaignPreviewQueryVariables,
    token: string | null | undefined
): Promise<CampaignPreviewQuery> {
    return executeQuery<CampaignPreviewQuery>(Queries.CampaignPreview, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.DocumentEmailPreviewFragment]
    });
}

export function useCampaignTextMessagesQuery(
    args: CampaignTextMessagesQueryVariables
): IUseQueryReturns<CampaignTextMessagesQuery> {
    return useQuery(Queries.CampaignTextMessages, args, [
        Fragments.CreatedByFragment,
        Fragments.CampaignUserInfoFragment
    ]);
}

export function executeCampaignTextMessagesQuery(
    args: CampaignTextMessagesQueryVariables,
    token: string | null | undefined
): Promise<CampaignTextMessagesQuery> {
    return executeQuery<CampaignTextMessagesQuery>(Queries.CampaignTextMessages, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CreatedByFragment, Fragments.CampaignUserInfoFragment]
    });
}

export function useTextMessageRepliesQuery(
    args: TextMessageRepliesQueryVariables
): IUseQueryReturns<TextMessageRepliesQuery> {
    return useQuery(Queries.TextMessageReplies, args, [Fragments.CreatedByFragment]);
}

export function executeTextMessageRepliesQuery(
    args: TextMessageRepliesQueryVariables,
    token: string | null | undefined
): Promise<TextMessageRepliesQuery> {
    return executeQuery<TextMessageRepliesQuery>(Queries.TextMessageReplies, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CreatedByFragment]
    });
}

export function useTextMessageSendMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<TextMessageSendMutation, TextMessageSendMutationVariables> {
    return useMutation(Mutations.TextMessageSend, args);
}

export function useTextMessageRepliesReadMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<TextMessageRepliesReadMutation, TextMessageRepliesReadMutationVariables> {
    return useMutation(Mutations.TextMessageRepliesRead, args);
}

export function useCampaignsSegmentsQuery(
    args: CampaignsSegmentsQueryVariables
): IUseQueryReturns<CampaignsSegmentsQuery> {
    return useQuery(Queries.CampaignsSegments, args, [Fragments.SegmentsFoldersSegmentsFragment]);
}

export function executeCampaignsSegmentsQuery(
    args: CampaignsSegmentsQueryVariables,
    token: string | null | undefined
): Promise<CampaignsSegmentsQuery> {
    return executeQuery<CampaignsSegmentsQuery>(Queries.CampaignsSegments, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.SegmentsFoldersSegmentsFragment]
    });
}

export function useCommunityCampaignsQuery(
    args: CommunityCampaignsQueryVariables
): IUseQueryReturns<CommunityCampaignsQuery> {
    return useQuery(Queries.CommunityCampaigns, args, [Fragments.CampaignListFragment]);
}

export function executeCommunityCampaignsQuery(
    args: CommunityCampaignsQueryVariables,
    token: string | null | undefined
): Promise<CommunityCampaignsQuery> {
    return executeQuery<CommunityCampaignsQuery>(Queries.CommunityCampaigns, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CampaignListFragment]
    });
}

export function useCommunityDashboardQuery(
    args: CommunityDashboardQueryVariables
): IUseQueryReturns<CommunityDashboardQuery> {
    return useQuery(Queries.CommunityDashboard, args, []);
}

export function executeCommunityDashboardQuery(
    args: CommunityDashboardQueryVariables,
    token: string | null | undefined
): Promise<CommunityDashboardQuery> {
    return executeQuery<CommunityDashboardQuery>(Queries.CommunityDashboard, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useCommunityDelegationsSegmentsQuery(
    args: CommunityDelegationsSegmentsQueryVariables
): IUseQueryReturns<CommunityDelegationsSegmentsQuery> {
    return useQuery(Queries.CommunityDelegationsSegments, args, [
        Fragments.SegmentCustomFieldFragment,
        Fragments.SegmentsFoldersSegmentsFragment
    ]);
}

export function executeCommunityDelegationsSegmentsQuery(
    args: CommunityDelegationsSegmentsQueryVariables,
    token: string | null | undefined
): Promise<CommunityDelegationsSegmentsQuery> {
    return executeQuery<CommunityDelegationsSegmentsQuery>(Queries.CommunityDelegationsSegments, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.SegmentCustomFieldFragment, Fragments.SegmentsFoldersSegmentsFragment]
    });
}

export function useUsersInfosMassAddEventMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UsersInfosMassAddEventMutation, UsersInfosMassAddEventMutationVariables> {
    return useMutation(Mutations.UsersInfosMassAddEvent, args);
}

export function useMergeMembersQuery(
    args: MergeMembersQueryVariables
): IUseQueryReturns<MergeMembersQuery> {
    return useQuery(Queries.MergeMembers, args, []);
}

export function executeMergeMembersQuery(
    args: MergeMembersQueryVariables,
    token: string | null | undefined
): Promise<MergeMembersQuery> {
    return executeQuery<MergeMembersQuery>(Queries.MergeMembers, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useUsersInfosMergeMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UsersInfosMergeMutation, UsersInfosMergeMutationVariables> {
    return useMutation(Mutations.UsersInfosMerge, args);
}

export function useUsersActionsQuery(
    args: UsersActionsQueryVariables
): IUseQueryReturns<UsersActionsQuery> {
    return useQuery(Queries.UsersActions, args, []);
}

export function executeUsersActionsQuery(
    args: UsersActionsQueryVariables,
    token: string | null | undefined
): Promise<UsersActionsQuery> {
    return executeQuery<UsersActionsQuery>(Queries.UsersActions, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useUsersInfosMassDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UsersInfosMassDeleteMutation, UsersInfosMassDeleteMutationVariables> {
    return useMutation(Mutations.UsersInfosMassDelete, args);
}

export function usePossibleDuplicatesQuery(
    args: PossibleDuplicatesQueryVariables
): IUseQueryReturns<PossibleDuplicatesQuery> {
    return useQuery(Queries.PossibleDuplicates, args, [Fragments.CustomFieldWithConditionFragment]);
}

export function executePossibleDuplicatesQuery(
    args: PossibleDuplicatesQueryVariables,
    token: string | null | undefined
): Promise<PossibleDuplicatesQuery> {
    return executeQuery<PossibleDuplicatesQuery>(Queries.PossibleDuplicates, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CustomFieldWithConditionFragment]
    });
}

export function useCustomFieldCategoryCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    CustomFieldCategoryCreateMutation,
    CustomFieldCategoryCreateMutationVariables
> {
    return useMutation(Mutations.CustomFieldCategoryCreate, args);
}

export function useCustomFieldCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CustomFieldCreateMutation, CustomFieldCreateMutationVariables> {
    return useMutation(Mutations.CustomFieldCreate, args);
}

export function useCustomFieldToEditQuery(
    args: CustomFieldToEditQueryVariables
): IUseQueryReturns<CustomFieldToEditQuery> {
    return useQuery(Queries.CustomFieldToEdit, args, [Fragments.CreateCustomFieldInfosFragment]);
}

export function executeCustomFieldToEditQuery(
    args: CustomFieldToEditQueryVariables,
    token: string | null | undefined
): Promise<CustomFieldToEditQuery> {
    return executeQuery<CustomFieldToEditQuery>(Queries.CustomFieldToEdit, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CreateCustomFieldInfosFragment]
    });
}

export function useCustomFieldUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CustomFieldUpdateMutation, CustomFieldUpdateMutationVariables> {
    return useMutation(Mutations.CustomFieldUpdate, args);
}

export function useOrganizationInfosQuery(
    args: OrganizationInfosQueryVariables
): IUseQueryReturns<OrganizationInfosQuery> {
    return useQuery(Queries.OrganizationInfos, args, [Fragments.CreateCustomFieldInfosFragment]);
}

export function executeOrganizationInfosQuery(
    args: OrganizationInfosQueryVariables,
    token: string | null | undefined
): Promise<OrganizationInfosQuery> {
    return executeQuery<OrganizationInfosQuery>(Queries.OrganizationInfos, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CreateCustomFieldInfosFragment]
    });
}

export function useCustomFieldQuery(
    args: CustomFieldQueryVariables
): IUseQueryReturns<CustomFieldQuery> {
    return useQuery(Queries.CustomField, args, [Fragments.CustomFieldFragment]);
}

export function executeCustomFieldQuery(
    args: CustomFieldQueryVariables,
    token: string | null | undefined
): Promise<CustomFieldQuery> {
    return executeQuery<CustomFieldQuery>(Queries.CustomField, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CustomFieldFragment]
    });
}

export function useCustomFieldCategoryDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    CustomFieldCategoryDeleteMutation,
    CustomFieldCategoryDeleteMutationVariables
> {
    return useMutation(Mutations.CustomFieldCategoryDelete, args);
}

export function useCustomFieldDuplicateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CustomFieldDuplicateMutation, CustomFieldDuplicateMutationVariables> {
    return useMutation(Mutations.CustomFieldDuplicate, args);
}

export function useCustomFieldUsageQuery(
    args: CustomFieldUsageQueryVariables
): IUseQueryReturns<CustomFieldUsageQuery> {
    return useQuery(Queries.CustomFieldUsage, args, []);
}

export function executeCustomFieldUsageQuery(
    args: CustomFieldUsageQueryVariables,
    token: string | null | undefined
): Promise<CustomFieldUsageQuery> {
    return executeQuery<CustomFieldUsageQuery>(Queries.CustomFieldUsage, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useCustomFieldsQuery(
    args: CustomFieldsQueryVariables
): IUseQueryReturns<CustomFieldsQuery> {
    return useQuery(Queries.CustomFields, args, [Fragments.CustomFieldFragment]);
}

export function executeCustomFieldsQuery(
    args: CustomFieldsQueryVariables,
    token: string | null | undefined
): Promise<CustomFieldsQuery> {
    return executeQuery<CustomFieldsQuery>(Queries.CustomFields, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CustomFieldFragment]
    });
}

export function useCustomFieldsMassDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CustomFieldsMassDeleteMutation, CustomFieldsMassDeleteMutationVariables> {
    return useMutation(Mutations.CustomFieldsMassDelete, args);
}

export function useCustomFieldsSegmentsQuery(
    args: CustomFieldsSegmentsQueryVariables
): IUseQueryReturns<CustomFieldsSegmentsQuery> {
    return useQuery(Queries.CustomFieldsSegments, args, [
        Fragments.SegmentsFoldersSegmentsFragment
    ]);
}

export function executeCustomFieldsSegmentsQuery(
    args: CustomFieldsSegmentsQueryVariables,
    token: string | null | undefined
): Promise<CustomFieldsSegmentsQuery> {
    return executeQuery<CustomFieldsSegmentsQuery>(Queries.CustomFieldsSegments, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.SegmentsFoldersSegmentsFragment]
    });
}

export function useCustomFieldCategoryUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    CustomFieldCategoryUpdateMutation,
    CustomFieldCategoryUpdateMutationVariables
> {
    return useMutation(Mutations.CustomFieldCategoryUpdate, args);
}

export function useDashboardQuery(args: DashboardQueryVariables): IUseQueryReturns<DashboardQuery> {
    return useQuery(Queries.Dashboard, args, []);
}

export function executeDashboardQuery(
    args: DashboardQueryVariables,
    token: string | null | undefined
): Promise<DashboardQuery> {
    return executeQuery<DashboardQuery>(Queries.Dashboard, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useDashboardMobileQuery(
    args: DashboardMobileQueryVariables
): IUseQueryReturns<DashboardMobileQuery> {
    return useQuery(Queries.DashboardMobile, args, []);
}

export function executeDashboardMobileQuery(
    args: DashboardMobileQueryVariables,
    token: string | null | undefined
): Promise<DashboardMobileQuery> {
    return executeQuery<DashboardMobileQuery>(Queries.DashboardMobile, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useDelegationCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<DelegationCreateMutation, DelegationCreateMutationVariables> {
    return useMutation(Mutations.DelegationCreate, args);
}

export function useDelegationEventInfosQuery(
    args: DelegationEventInfosQueryVariables
): IUseQueryReturns<DelegationEventInfosQuery> {
    return useQuery(Queries.DelegationEventInfos, args, [
        Fragments.CreatePositionTagsFragment,
        Fragments.OrganizationCustomFieldsFragment,
        Fragments.AttachCustomFieldFragment,
        Fragments.CreateDelegationEventFragment
    ]);
}

export function executeDelegationEventInfosQuery(
    args: DelegationEventInfosQueryVariables,
    token: string | null | undefined
): Promise<DelegationEventInfosQuery> {
    return executeQuery<DelegationEventInfosQuery>(Queries.DelegationEventInfos, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.CreatePositionTagsFragment,
            Fragments.OrganizationCustomFieldsFragment,
            Fragments.AttachCustomFieldFragment,
            Fragments.CreateDelegationEventFragment
        ]
    });
}

export function useDelegationEventToEditQuery(
    args: DelegationEventToEditQueryVariables
): IUseQueryReturns<DelegationEventToEditQuery> {
    return useQuery(Queries.DelegationEventToEdit, args, [
        Fragments.CreatePositionTagsFragment,
        Fragments.OrganizationCustomFieldsFragment,
        Fragments.AttachCustomFieldFragment,
        Fragments.CreateDelegationEventFragment
    ]);
}

export function executeDelegationEventToEditQuery(
    args: DelegationEventToEditQueryVariables,
    token: string | null | undefined
): Promise<DelegationEventToEditQuery> {
    return executeQuery<DelegationEventToEditQuery>(Queries.DelegationEventToEdit, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.CreatePositionTagsFragment,
            Fragments.OrganizationCustomFieldsFragment,
            Fragments.AttachCustomFieldFragment,
            Fragments.CreateDelegationEventFragment
        ]
    });
}

export function useDelegationOrganizationInfosQuery(
    args: DelegationOrganizationInfosQueryVariables
): IUseQueryReturns<DelegationOrganizationInfosQuery> {
    return useQuery(Queries.DelegationOrganizationInfos, args, [
        Fragments.CreatePositionTagsFragment,
        Fragments.OrganizationCustomFieldsFragment,
        Fragments.AttachCustomFieldFragment,
        Fragments.CreateDelegationFormFragment
    ]);
}

export function executeDelegationOrganizationInfosQuery(
    args: DelegationOrganizationInfosQueryVariables,
    token: string | null | undefined
): Promise<DelegationOrganizationInfosQuery> {
    return executeQuery<DelegationOrganizationInfosQuery>(Queries.DelegationOrganizationInfos, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.CreatePositionTagsFragment,
            Fragments.OrganizationCustomFieldsFragment,
            Fragments.AttachCustomFieldFragment,
            Fragments.CreateDelegationFormFragment
        ]
    });
}

export function useDelegationOrganizationToEditQuery(
    args: DelegationOrganizationToEditQueryVariables
): IUseQueryReturns<DelegationOrganizationToEditQuery> {
    return useQuery(Queries.DelegationOrganizationToEdit, args, [
        Fragments.CreatePositionTagsFragment,
        Fragments.OrganizationCustomFieldsFragment,
        Fragments.AttachCustomFieldFragment,
        Fragments.CreateDelegationFormFragment
    ]);
}

export function executeDelegationOrganizationToEditQuery(
    args: DelegationOrganizationToEditQueryVariables,
    token: string | null | undefined
): Promise<DelegationOrganizationToEditQuery> {
    return executeQuery<DelegationOrganizationToEditQuery>(Queries.DelegationOrganizationToEdit, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.CreatePositionTagsFragment,
            Fragments.OrganizationCustomFieldsFragment,
            Fragments.AttachCustomFieldFragment,
            Fragments.CreateDelegationFormFragment
        ]
    });
}

export function useDelegationUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<DelegationUpdateMutation, DelegationUpdateMutationVariables> {
    return useMutation(Mutations.DelegationUpdate, args);
}

export function useEventUsersInfosQuery(
    args: EventUsersInfosQueryVariables
): IUseQueryReturns<EventUsersInfosQuery> {
    return useQuery(Queries.EventUsersInfos, args, [Fragments.ExistingVolunteerFragment]);
}

export function executeEventUsersInfosQuery(
    args: EventUsersInfosQueryVariables,
    token: string | null | undefined
): Promise<EventUsersInfosQuery> {
    return executeQuery<EventUsersInfosQuery>(Queries.EventUsersInfos, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.ExistingVolunteerFragment]
    });
}

export function useDelegationsImportMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<DelegationsImportMutation, DelegationsImportMutationVariables> {
    return useMutation(Mutations.DelegationsImport, args);
}

export function useDelegationDuplicateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<DelegationDuplicateMutation, DelegationDuplicateMutationVariables> {
    return useMutation(Mutations.DelegationDuplicate, args);
}

export function useDelegationsQuery(
    args: DelegationsQueryVariables
): IUseQueryReturns<DelegationsQuery> {
    return useQuery(Queries.Delegations, args, [Fragments.DelegationsDelegationFragment]);
}

export function executeDelegationsQuery(
    args: DelegationsQueryVariables,
    token: string | null | undefined
): Promise<DelegationsQuery> {
    return executeQuery<DelegationsQuery>(Queries.Delegations, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.DelegationsDelegationFragment]
    });
}

export function useDelegationsCategoriesQuery(
    args: DelegationsCategoriesQueryVariables
): IUseQueryReturns<DelegationsCategoriesQuery> {
    return useQuery(Queries.DelegationsCategories, args, []);
}

export function executeDelegationsCategoriesQuery(
    args: DelegationsCategoriesQueryVariables,
    token: string | null | undefined
): Promise<DelegationsCategoriesQuery> {
    return executeQuery<DelegationsCategoriesQuery>(Queries.DelegationsCategories, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useDelegationsDelegationQuery(
    args: DelegationsDelegationQueryVariables
): IUseQueryReturns<DelegationsDelegationQuery> {
    return useQuery(Queries.DelegationsDelegation, args, [Fragments.DelegationsDelegationFragment]);
}

export function executeDelegationsDelegationQuery(
    args: DelegationsDelegationQueryVariables,
    token: string | null | undefined
): Promise<DelegationsDelegationQuery> {
    return executeQuery<DelegationsDelegationQuery>(Queries.DelegationsDelegation, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.DelegationsDelegationFragment]
    });
}

export function useDelegationsExportMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<DelegationsExportMutation, DelegationsExportMutationVariables> {
    return useMutation(Mutations.DelegationsExport, args);
}

export function useDelegationsMassDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<DelegationsMassDeleteMutation, DelegationsMassDeleteMutationVariables> {
    return useMutation(Mutations.DelegationsMassDelete, args);
}

export function useDelegationsSegmentsQuery(
    args: DelegationsSegmentsQueryVariables
): IUseQueryReturns<DelegationsSegmentsQuery> {
    return useQuery(Queries.DelegationsSegments, args, [
        Fragments.SegmentCustomFieldFragment,
        Fragments.SegmentsFoldersSegmentsFragment
    ]);
}

export function executeDelegationsSegmentsQuery(
    args: DelegationsSegmentsQueryVariables,
    token: string | null | undefined
): Promise<DelegationsSegmentsQuery> {
    return executeQuery<DelegationsSegmentsQuery>(Queries.DelegationsSegments, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.SegmentCustomFieldFragment, Fragments.SegmentsFoldersSegmentsFragment]
    });
}

export function useParentDelegationsQuery(
    args: ParentDelegationsQueryVariables
): IUseQueryReturns<ParentDelegationsQuery> {
    return useQuery(Queries.ParentDelegations, args, []);
}

export function executeParentDelegationsQuery(
    args: ParentDelegationsQueryVariables,
    token: string | null | undefined
): Promise<ParentDelegationsQuery> {
    return executeQuery<ParentDelegationsQuery>(Queries.ParentDelegations, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useDelegationsMassMoveMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<DelegationsMassMoveMutation, DelegationsMassMoveMutationVariables> {
    return useMutation(Mutations.DelegationsMassMove, args);
}

export function useDelegationsMassMoveInfosQuery(
    args: DelegationsMassMoveInfosQueryVariables
): IUseQueryReturns<DelegationsMassMoveInfosQuery> {
    return useQuery(Queries.DelegationsMassMoveInfos, args, []);
}

export function executeDelegationsMassMoveInfosQuery(
    args: DelegationsMassMoveInfosQueryVariables,
    token: string | null | undefined
): Promise<DelegationsMassMoveInfosQuery> {
    return executeQuery<DelegationsMassMoveInfosQuery>(Queries.DelegationsMassMoveInfos, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useDelegationDashboardQuery(
    args: DelegationDashboardQueryVariables
): IUseQueryReturns<DelegationDashboardQuery> {
    return useQuery(Queries.DelegationDashboard, args, [
        Fragments.CustomFieldWithConditionFragment
    ]);
}

export function executeDelegationDashboardQuery(
    args: DelegationDashboardQueryVariables,
    token: string | null | undefined
): Promise<DelegationDashboardQuery> {
    return executeQuery<DelegationDashboardQuery>(Queries.DelegationDashboard, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CustomFieldWithConditionFragment]
    });
}

export function useDelegationQuery(
    args: DelegationQueryVariables
): IUseQueryReturns<DelegationQuery> {
    return useQuery(Queries.Delegation, args, [Fragments.OrganizationCustomFieldsFragment]);
}

export function executeDelegationQuery(
    args: DelegationQueryVariables,
    token: string | null | undefined
): Promise<DelegationQuery> {
    return executeQuery<DelegationQuery>(Queries.Delegation, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.OrganizationCustomFieldsFragment]
    });
}

export function useDelegationReportingQuery(
    args: DelegationReportingQueryVariables
): IUseQueryReturns<DelegationReportingQuery> {
    return useQuery(Queries.DelegationReporting, args, []);
}

export function executeDelegationReportingQuery(
    args: DelegationReportingQueryVariables,
    token: string | null | undefined
): Promise<DelegationReportingQuery> {
    return executeQuery<DelegationReportingQuery>(Queries.DelegationReporting, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useDelegationCategoryCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    DelegationCategoryCreateMutation,
    DelegationCategoryCreateMutationVariables
> {
    return useMutation(Mutations.DelegationCategoryCreate, args);
}

export function useDelegationCategoryUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    DelegationCategoryUpdateMutation,
    DelegationCategoryUpdateMutationVariables
> {
    return useMutation(Mutations.DelegationCategoryUpdate, args);
}

export function useDelegationCategoryDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    DelegationCategoryDeleteMutation,
    DelegationCategoryDeleteMutationVariables
> {
    return useMutation(Mutations.DelegationCategoryDelete, args);
}

export function useDelegationCategoryDelegationsQuery(
    args: DelegationCategoryDelegationsQueryVariables
): IUseQueryReturns<DelegationCategoryDelegationsQuery> {
    return useQuery(Queries.DelegationCategoryDelegations, args, []);
}

export function executeDelegationCategoryDelegationsQuery(
    args: DelegationCategoryDelegationsQueryVariables,
    token: string | null | undefined
): Promise<DelegationCategoryDelegationsQuery> {
    return executeQuery<DelegationCategoryDelegationsQuery>(Queries.DelegationCategoryDelegations, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useDelegationCategoryQuery(
    args: DelegationCategoryQueryVariables
): IUseQueryReturns<DelegationCategoryQuery> {
    return useQuery(Queries.DelegationCategory, args, []);
}

export function executeDelegationCategoryQuery(
    args: DelegationCategoryQueryVariables,
    token: string | null | undefined
): Promise<DelegationCategoryQuery> {
    return executeQuery<DelegationCategoryQuery>(Queries.DelegationCategory, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useDelegationCategoryDuplicateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    DelegationCategoryDuplicateMutation,
    DelegationCategoryDuplicateMutationVariables
> {
    return useMutation(Mutations.DelegationCategoryDuplicate, args);
}

export function useDelegationCategoryMembersInfosQuery(
    args: DelegationCategoryMembersInfosQueryVariables
): IUseQueryReturns<DelegationCategoryMembersInfosQuery> {
    return useQuery(Queries.DelegationCategoryMembersInfos, args, [
        Fragments.SegmentCustomFieldFragment
    ]);
}

export function executeDelegationCategoryMembersInfosQuery(
    args: DelegationCategoryMembersInfosQueryVariables,
    token: string | null | undefined
): Promise<DelegationCategoryMembersInfosQuery> {
    return executeQuery<DelegationCategoryMembersInfosQuery>(
        Queries.DelegationCategoryMembersInfos,
        {
            variables: args,
            token: token || undefined,
            fragments: [Fragments.SegmentCustomFieldFragment]
        }
    );
}

export function useCustomDocumentQuery(
    args: CustomDocumentQueryVariables
): IUseQueryReturns<CustomDocumentQuery> {
    return useQuery(Queries.CustomDocument, args, [Fragments.ConditionCustomFieldFragment]);
}

export function executeCustomDocumentQuery(
    args: CustomDocumentQueryVariables,
    token: string | null | undefined
): Promise<CustomDocumentQuery> {
    return executeQuery<CustomDocumentQuery>(Queries.CustomDocument, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.ConditionCustomFieldFragment]
    });
}

export function useCustomDocumentConditionsQuery(
    args: CustomDocumentConditionsQueryVariables
): IUseQueryReturns<CustomDocumentConditionsQuery> {
    return useQuery(Queries.CustomDocumentConditions, args, []);
}

export function executeCustomDocumentConditionsQuery(
    args: CustomDocumentConditionsQueryVariables,
    token: string | null | undefined
): Promise<CustomDocumentConditionsQuery> {
    return executeQuery<CustomDocumentConditionsQuery>(Queries.CustomDocumentConditions, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useCustomDocumentUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CustomDocumentUpdateMutation, CustomDocumentUpdateMutationVariables> {
    return useMutation(Mutations.CustomDocumentUpdate, args);
}

export function useCustomDocumentCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CustomDocumentCreateMutation, CustomDocumentCreateMutationVariables> {
    return useMutation(Mutations.CustomDocumentCreate, args);
}

export function useCustomDocumentDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CustomDocumentDeleteMutation, CustomDocumentDeleteMutationVariables> {
    return useMutation(Mutations.CustomDocumentDelete, args);
}

export function useCustomDocumentDuplicateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CustomDocumentDuplicateMutation, CustomDocumentDuplicateMutationVariables> {
    return useMutation(Mutations.CustomDocumentDuplicate, args);
}

export function useDocumentsQuery(args: DocumentsQueryVariables): IUseQueryReturns<DocumentsQuery> {
    return useQuery(Queries.Documents, args, []);
}

export function executeDocumentsQuery(
    args: DocumentsQueryVariables,
    token: string | null | undefined
): Promise<DocumentsQuery> {
    return executeQuery<DocumentsQuery>(Queries.Documents, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useEventDocumentUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EventDocumentUpdateMutation, EventDocumentUpdateMutationVariables> {
    return useMutation(Mutations.EventDocumentUpdate, args);
}

export function usePositionPlanningDocumentQuery(
    args: PositionPlanningDocumentQueryVariables
): IUseQueryReturns<PositionPlanningDocumentQuery> {
    return useQuery(Queries.PositionPlanningDocument, args, [
        Fragments.DocumentPositionPlanningFragment,
        Fragments.EventPositionsExportFragment
    ]);
}

export function executePositionPlanningDocumentQuery(
    args: PositionPlanningDocumentQueryVariables,
    token: string | null | undefined
): Promise<PositionPlanningDocumentQuery> {
    return executeQuery<PositionPlanningDocumentQuery>(Queries.PositionPlanningDocument, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.DocumentPositionPlanningFragment,
            Fragments.EventPositionsExportFragment
        ]
    });
}

export function usePositionSheetDocumentQuery(
    args: PositionSheetDocumentQueryVariables
): IUseQueryReturns<PositionSheetDocumentQuery> {
    return useQuery(Queries.PositionSheetDocument, args, [
        Fragments.DocumentPositionSheetFragment,
        Fragments.EventPositionsExportFragment
    ]);
}

export function executePositionSheetDocumentQuery(
    args: PositionSheetDocumentQueryVariables,
    token: string | null | undefined
): Promise<PositionSheetDocumentQuery> {
    return executeQuery<PositionSheetDocumentQuery>(Queries.PositionSheetDocument, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.DocumentPositionSheetFragment, Fragments.EventPositionsExportFragment]
    });
}

export function usePlanningDocumentQuery(
    args: PlanningDocumentQueryVariables
): IUseQueryReturns<PlanningDocumentQuery> {
    return useQuery(Queries.PlanningDocument, args, [
        Fragments.DocumentPositionsPlanningFragment,
        Fragments.EventPositionsExportFragment
    ]);
}

export function executePlanningDocumentQuery(
    args: PlanningDocumentQueryVariables,
    token: string | null | undefined
): Promise<PlanningDocumentQuery> {
    return executeQuery<PlanningDocumentQuery>(Queries.PlanningDocument, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.DocumentPositionsPlanningFragment,
            Fragments.EventPositionsExportFragment
        ]
    });
}

export function usePositionsVolunteersPlanningDocumentQuery(
    args: PositionsVolunteersPlanningDocumentQueryVariables
): IUseQueryReturns<PositionsVolunteersPlanningDocumentQuery> {
    return useQuery(Queries.PositionsVolunteersPlanningDocument, args, [
        Fragments.DocumentPositionsVolunteersPlanningFragment,
        Fragments.EventPositionsExportFragment
    ]);
}

export function executePositionsVolunteersPlanningDocumentQuery(
    args: PositionsVolunteersPlanningDocumentQueryVariables,
    token: string | null | undefined
): Promise<PositionsVolunteersPlanningDocumentQuery> {
    return executeQuery<PositionsVolunteersPlanningDocumentQuery>(
        Queries.PositionsVolunteersPlanningDocument,
        {
            variables: args,
            token: token || undefined,
            fragments: [
                Fragments.DocumentPositionsVolunteersPlanningFragment,
                Fragments.EventPositionsExportFragment
            ]
        }
    );
}

export function useUserAssignmentsDocumentQuery(
    args: UserAssignmentsDocumentQueryVariables
): IUseQueryReturns<UserAssignmentsDocumentQuery> {
    return useQuery(Queries.UserAssignmentsDocument, args, [
        Fragments.DocumentUserAssignmentsFragment,
        Fragments.EventVolunteersExportFragment
    ]);
}

export function executeUserAssignmentsDocumentQuery(
    args: UserAssignmentsDocumentQueryVariables,
    token: string | null | undefined
): Promise<UserAssignmentsDocumentQuery> {
    return executeQuery<UserAssignmentsDocumentQuery>(Queries.UserAssignmentsDocument, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.DocumentUserAssignmentsFragment,
            Fragments.EventVolunteersExportFragment
        ]
    });
}

export function useUserBadgeDocumentQuery(
    args: UserBadgeDocumentQueryVariables
): IUseQueryReturns<UserBadgeDocumentQuery> {
    return useQuery(Queries.UserBadgeDocument, args, [
        Fragments.DocumentUserBadgeFragment,
        Fragments.EventVolunteersExportFragment
    ]);
}

export function executeUserBadgeDocumentQuery(
    args: UserBadgeDocumentQueryVariables,
    token: string | null | undefined
): Promise<UserBadgeDocumentQuery> {
    return executeQuery<UserBadgeDocumentQuery>(Queries.UserBadgeDocument, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.DocumentUserBadgeFragment, Fragments.EventVolunteersExportFragment]
    });
}

export function useUserCertificateDocumentQuery(
    args: UserCertificateDocumentQueryVariables
): IUseQueryReturns<UserCertificateDocumentQuery> {
    return useQuery(Queries.UserCertificateDocument, args, [
        Fragments.OrganizationCertificateDefaultFragment,
        Fragments.DocumentUserCertificateFragment,
        Fragments.EventVolunteersExportFragment
    ]);
}

export function executeUserCertificateDocumentQuery(
    args: UserCertificateDocumentQueryVariables,
    token: string | null | undefined
): Promise<UserCertificateDocumentQuery> {
    return executeQuery<UserCertificateDocumentQuery>(Queries.UserCertificateDocument, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.OrganizationCertificateDefaultFragment,
            Fragments.DocumentUserCertificateFragment,
            Fragments.EventVolunteersExportFragment
        ]
    });
}

export function useUserCustomBadgeDocumentQuery(
    args: UserCustomBadgeDocumentQueryVariables
): IUseQueryReturns<UserCustomBadgeDocumentQuery> {
    return useQuery(Queries.UserCustomBadgeDocument, args, [
        Fragments.DocumentUserCustomBadgeFragment,
        Fragments.EventVolunteersExportFragment
    ]);
}

export function executeUserCustomBadgeDocumentQuery(
    args: UserCustomBadgeDocumentQueryVariables,
    token: string | null | undefined
): Promise<UserCustomBadgeDocumentQuery> {
    return executeQuery<UserCustomBadgeDocumentQuery>(Queries.UserCustomBadgeDocument, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.DocumentUserCustomBadgeFragment,
            Fragments.EventVolunteersExportFragment
        ]
    });
}

export function useUserCustomDocumentExportQuery(
    args: UserCustomDocumentExportQueryVariables
): IUseQueryReturns<UserCustomDocumentExportQuery> {
    return useQuery(Queries.UserCustomDocumentExport, args, [
        Fragments.CustomFieldWithConditionFragment,
        Fragments.EventVolunteersExportFragment,
        Fragments.CustomBadgeVolunteerRegistrationFragment
    ]);
}

export function executeUserCustomDocumentExportQuery(
    args: UserCustomDocumentExportQueryVariables,
    token: string | null | undefined
): Promise<UserCustomDocumentExportQuery> {
    return executeQuery<UserCustomDocumentExportQuery>(Queries.UserCustomDocumentExport, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.CustomFieldWithConditionFragment,
            Fragments.EventVolunteersExportFragment,
            Fragments.CustomBadgeVolunteerRegistrationFragment
        ]
    });
}

export function useUserHoursDocumentQuery(
    args: UserHoursDocumentQueryVariables
): IUseQueryReturns<UserHoursDocumentQuery> {
    return useQuery(Queries.UserHoursDocument, args, [
        Fragments.DocumentUsersHoursFragment,
        Fragments.EventVolunteersExportFragment
    ]);
}

export function executeUserHoursDocumentQuery(
    args: UserHoursDocumentQueryVariables,
    token: string | null | undefined
): Promise<UserHoursDocumentQuery> {
    return executeQuery<UserHoursDocumentQuery>(Queries.UserHoursDocument, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.DocumentUsersHoursFragment, Fragments.EventVolunteersExportFragment]
    });
}

export function useUserPlanningDaysDocumentQuery(
    args: UserPlanningDaysDocumentQueryVariables
): IUseQueryReturns<UserPlanningDaysDocumentQuery> {
    return useQuery(Queries.UserPlanningDaysDocument, args, [
        Fragments.DocumentUserPlanningDaysFragment,
        Fragments.EventVolunteersExportFragment
    ]);
}

export function executeUserPlanningDaysDocumentQuery(
    args: UserPlanningDaysDocumentQueryVariables,
    token: string | null | undefined
): Promise<UserPlanningDaysDocumentQuery> {
    return executeQuery<UserPlanningDaysDocumentQuery>(Queries.UserPlanningDaysDocument, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.DocumentUserPlanningDaysFragment,
            Fragments.EventVolunteersExportFragment
        ]
    });
}

export function useUserPlanningDocumentQuery(
    args: UserPlanningDocumentQueryVariables
): IUseQueryReturns<UserPlanningDocumentQuery> {
    return useQuery(Queries.UserPlanningDocument, args, [
        Fragments.DocumentUserPlanningFragment,
        Fragments.EventVolunteersExportFragment
    ]);
}

export function executeUserPlanningDocumentQuery(
    args: UserPlanningDocumentQueryVariables,
    token: string | null | undefined
): Promise<UserPlanningDocumentQuery> {
    return executeQuery<UserPlanningDocumentQuery>(Queries.UserPlanningDocument, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.DocumentUserPlanningFragment, Fragments.EventVolunteersExportFragment]
    });
}

export function useUserPlanningListDocumentQuery(
    args: UserPlanningListDocumentQueryVariables
): IUseQueryReturns<UserPlanningListDocumentQuery> {
    return useQuery(Queries.UserPlanningListDocument, args, [
        Fragments.DocumentUserPlanningListFragment,
        Fragments.EventVolunteersExportFragment
    ]);
}

export function executeUserPlanningListDocumentQuery(
    args: UserPlanningListDocumentQueryVariables,
    token: string | null | undefined
): Promise<UserPlanningListDocumentQuery> {
    return executeQuery<UserPlanningListDocumentQuery>(Queries.UserPlanningListDocument, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.DocumentUserPlanningListFragment,
            Fragments.EventVolunteersExportFragment
        ]
    });
}

export function useUsersListingDocumentQuery(
    args: UsersListingDocumentQueryVariables
): IUseQueryReturns<UsersListingDocumentQuery> {
    return useQuery(Queries.UsersListingDocument, args, [
        Fragments.DocumentUsersListingFragment,
        Fragments.EventVolunteersExportFragment
    ]);
}

export function executeUsersListingDocumentQuery(
    args: UsersListingDocumentQueryVariables,
    token: string | null | undefined
): Promise<UsersListingDocumentQuery> {
    return executeQuery<UsersListingDocumentQuery>(Queries.UsersListingDocument, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.DocumentUsersListingFragment, Fragments.EventVolunteersExportFragment]
    });
}

export function useEmailTemplateQuery(
    args: EmailTemplateQueryVariables
): IUseQueryReturns<EmailTemplateQuery> {
    return useQuery(Queries.EmailTemplate, args, []);
}

export function executeEmailTemplateQuery(
    args: EmailTemplateQueryVariables,
    token: string | null | undefined
): Promise<EmailTemplateQuery> {
    return executeQuery<EmailTemplateQuery>(Queries.EmailTemplate, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useEmailTemplateUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EmailTemplateUpdateMutation, EmailTemplateUpdateMutationVariables> {
    return useMutation(Mutations.EmailTemplateUpdate, args);
}

export function useEmailsTemplatesQuery(
    args: EmailsTemplatesQueryVariables
): IUseQueryReturns<EmailsTemplatesQuery> {
    return useQuery(Queries.EmailsTemplates, args, []);
}

export function executeEmailsTemplatesQuery(
    args: EmailsTemplatesQueryVariables,
    token: string | null | undefined
): Promise<EmailsTemplatesQuery> {
    return executeQuery<EmailsTemplatesQuery>(Queries.EmailsTemplates, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useAllEventsQuery(args: AllEventsQueryVariables): IUseQueryReturns<AllEventsQuery> {
    return useQuery(Queries.AllEvents, args, []);
}

export function executeAllEventsQuery(
    args: AllEventsQueryVariables,
    token: string | null | undefined
): Promise<AllEventsQuery> {
    return executeQuery<AllEventsQuery>(Queries.AllEvents, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useCreateEventMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CreateEventMutation, CreateEventMutationVariables> {
    return useMutation(Mutations.CreateEvent, args);
}

export function useEventCreateInfosQuery(
    args: EventCreateInfosQueryVariables
): IUseQueryReturns<EventCreateInfosQuery> {
    return useQuery(Queries.EventCreateInfos, args, [Fragments.CreateUpdateEventInfosFragment]);
}

export function executeEventCreateInfosQuery(
    args: EventCreateInfosQueryVariables,
    token: string | null | undefined
): Promise<EventCreateInfosQuery> {
    return executeQuery<EventCreateInfosQuery>(Queries.EventCreateInfos, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CreateUpdateEventInfosFragment]
    });
}

export function useEventOrganizationCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EventOrganizationCreateMutation, EventOrganizationCreateMutationVariables> {
    return useMutation(Mutations.EventOrganizationCreate, args);
}

export function useEventUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EventUpdateMutation, EventUpdateMutationVariables> {
    return useMutation(Mutations.EventUpdate, args);
}

export function useEventUpdateInfosQuery(
    args: EventUpdateInfosQueryVariables
): IUseQueryReturns<EventUpdateInfosQuery> {
    return useQuery(Queries.EventUpdateInfos, args, [Fragments.CreateUpdateEventInfosFragment]);
}

export function executeEventUpdateInfosQuery(
    args: EventUpdateInfosQueryVariables,
    token: string | null | undefined
): Promise<EventUpdateInfosQuery> {
    return executeQuery<EventUpdateInfosQuery>(Queries.EventUpdateInfos, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CreateUpdateEventInfosFragment]
    });
}

export function useEventDuplicateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EventDuplicateMutation, EventDuplicateMutationVariables> {
    return useMutation(Mutations.EventDuplicate, args);
}

export function useEventsQuery(args: EventsQueryVariables): IUseQueryReturns<EventsQuery> {
    return useQuery(Queries.Events, args, [Fragments.EventsEventFragment]);
}

export function executeEventsQuery(
    args: EventsQueryVariables,
    token: string | null | undefined
): Promise<EventsQuery> {
    return executeQuery<EventsQuery>(Queries.Events, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.EventsEventFragment]
    });
}

export function useEventsMassArchiveMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EventsMassArchiveMutation, EventsMassArchiveMutationVariables> {
    return useMutation(Mutations.EventsMassArchive, args);
}

export function useEventsSegmentsQuery(
    args: EventsSegmentsQueryVariables
): IUseQueryReturns<EventsSegmentsQuery> {
    return useQuery(Queries.EventsSegments, args, [
        Fragments.SegmentCustomFieldFragment,
        Fragments.SegmentsFoldersSegmentsFragment
    ]);
}

export function executeEventsSegmentsQuery(
    args: EventsSegmentsQueryVariables,
    token: string | null | undefined
): Promise<EventsSegmentsQuery> {
    return executeQuery<EventsSegmentsQuery>(Queries.EventsSegments, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.SegmentCustomFieldFragment, Fragments.SegmentsFoldersSegmentsFragment]
    });
}

export function useEventsEventQuery(
    args: EventsEventQueryVariables
): IUseQueryReturns<EventsEventQuery> {
    return useQuery(Queries.EventsEvent, args, [Fragments.EventsEventFragment]);
}

export function executeEventsEventQuery(
    args: EventsEventQueryVariables,
    token: string | null | undefined
): Promise<EventsEventQuery> {
    return executeQuery<EventsEventQuery>(Queries.EventsEvent, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.EventsEventFragment]
    });
}

export function useEventsMobileQuery(
    args: EventsMobileQueryVariables
): IUseQueryReturns<EventsMobileQuery> {
    return useQuery(Queries.EventsMobile, args, []);
}

export function executeEventsMobileQuery(
    args: EventsMobileQueryVariables,
    token: string | null | undefined
): Promise<EventsMobileQuery> {
    return executeQuery<EventsMobileQuery>(Queries.EventsMobile, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useEventQuery(args: EventQueryVariables): IUseQueryReturns<EventQuery> {
    return useQuery(Queries.Event, args, []);
}

export function executeEventQuery(
    args: EventQueryVariables,
    token: string | null | undefined
): Promise<EventQuery> {
    return executeQuery<EventQuery>(Queries.Event, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useFilesImportMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<FilesImportMutation, FilesImportMutationVariables> {
    return useMutation(Mutations.FilesImport, args);
}

export function useFilesImportCustomFieldsQuery(
    args: FilesImportCustomFieldsQueryVariables
): IUseQueryReturns<FilesImportCustomFieldsQuery> {
    return useQuery(Queries.FilesImportCustomFields, args, []);
}

export function executeFilesImportCustomFieldsQuery(
    args: FilesImportCustomFieldsQueryVariables,
    token: string | null | undefined
): Promise<FilesImportCustomFieldsQuery> {
    return executeQuery<FilesImportCustomFieldsQuery>(Queries.FilesImportCustomFields, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useFormCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<FormCreateMutation, FormCreateMutationVariables> {
    return useMutation(Mutations.FormCreate, args);
}

export function useFormDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<FormDeleteMutation, FormDeleteMutationVariables> {
    return useMutation(Mutations.FormDelete, args);
}

export function useFormDuplicateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<FormDuplicateMutation, FormDuplicateMutationVariables> {
    return useMutation(Mutations.FormDuplicate, args);
}

export function useFormsQuery(args: FormsQueryVariables): IUseQueryReturns<FormsQuery> {
    return useQuery(Queries.Forms, args, [Fragments.FormListFragment]);
}

export function executeFormsQuery(
    args: FormsQueryVariables,
    token: string | null | undefined
): Promise<FormsQuery> {
    return executeQuery<FormsQuery>(Queries.Forms, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.FormListFragment]
    });
}

export function useFormQuery(args: FormQueryVariables): IUseQueryReturns<FormQuery> {
    return useQuery(Queries.Form, args, []);
}

export function executeFormQuery(
    args: FormQueryVariables,
    token: string | null | undefined
): Promise<FormQuery> {
    return executeQuery<FormQuery>(Queries.Form, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useFormElementsQuery(
    args: FormElementsQueryVariables
): IUseQueryReturns<FormElementsQuery> {
    return useQuery(Queries.FormElements, args, [
        Fragments.FormCustomFieldsFragment,
        Fragments.FormElementsElementFragment
    ]);
}

export function executeFormElementsQuery(
    args: FormElementsQueryVariables,
    token: string | null | undefined
): Promise<FormElementsQuery> {
    return executeQuery<FormElementsQuery>(Queries.FormElements, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.FormCustomFieldsFragment, Fragments.FormElementsElementFragment]
    });
}

export function useFormElementsUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<FormElementsUpdateMutation, FormElementsUpdateMutationVariables> {
    return useMutation(Mutations.FormElementsUpdate, args);
}

export function useFormParametersAccreditationsQuery(
    args: FormParametersAccreditationsQueryVariables
): IUseQueryReturns<FormParametersAccreditationsQuery> {
    return useQuery(Queries.FormParametersAccreditations, args, []);
}

export function executeFormParametersAccreditationsQuery(
    args: FormParametersAccreditationsQueryVariables,
    token: string | null | undefined
): Promise<FormParametersAccreditationsQuery> {
    return executeQuery<FormParametersAccreditationsQuery>(Queries.FormParametersAccreditations, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useFormParametersAccreditationsUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    FormParametersAccreditationsUpdateMutation,
    FormParametersAccreditationsUpdateMutationVariables
> {
    return useMutation(Mutations.FormParametersAccreditationsUpdate, args);
}

export function useFormParametersAccreditationsHiddenDisplayedQuery(
    args: FormParametersAccreditationsHiddenDisplayedQueryVariables
): IUseQueryReturns<FormParametersAccreditationsHiddenDisplayedQuery> {
    return useQuery(Queries.FormParametersAccreditationsHiddenDisplayed, args, []);
}

export function executeFormParametersAccreditationsHiddenDisplayedQuery(
    args: FormParametersAccreditationsHiddenDisplayedQueryVariables,
    token: string | null | undefined
): Promise<FormParametersAccreditationsHiddenDisplayedQuery> {
    return executeQuery<FormParametersAccreditationsHiddenDisplayedQuery>(
        Queries.FormParametersAccreditationsHiddenDisplayed,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useFormParametersAvailabilitiesQuery(
    args: FormParametersAvailabilitiesQueryVariables
): IUseQueryReturns<FormParametersAvailabilitiesQuery> {
    return useQuery(Queries.FormParametersAvailabilities, args, [
        Fragments.FormSlotsOptionsFragment,
        Fragments.FormRegisterCustomSlotPeriodFragment
    ]);
}

export function executeFormParametersAvailabilitiesQuery(
    args: FormParametersAvailabilitiesQueryVariables,
    token: string | null | undefined
): Promise<FormParametersAvailabilitiesQuery> {
    return executeQuery<FormParametersAvailabilitiesQuery>(Queries.FormParametersAvailabilities, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.FormSlotsOptionsFragment,
            Fragments.FormRegisterCustomSlotPeriodFragment
        ]
    });
}

export function useFormParametersAvailabilitiesUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    FormParametersAvailabilitiesUpdateMutation,
    FormParametersAvailabilitiesUpdateMutationVariables
> {
    return useMutation(Mutations.FormParametersAvailabilitiesUpdate, args);
}

export function useFormParametersBroadcastEventQuery(
    args: FormParametersBroadcastEventQueryVariables
): IUseQueryReturns<FormParametersBroadcastEventQuery> {
    return useQuery(Queries.FormParametersBroadcastEvent, args, []);
}

export function executeFormParametersBroadcastEventQuery(
    args: FormParametersBroadcastEventQueryVariables,
    token: string | null | undefined
): Promise<FormParametersBroadcastEventQuery> {
    return executeQuery<FormParametersBroadcastEventQuery>(Queries.FormParametersBroadcastEvent, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useFormParametersBroadcastOrganizationQuery(
    args: FormParametersBroadcastOrganizationQueryVariables
): IUseQueryReturns<FormParametersBroadcastOrganizationQuery> {
    return useQuery(Queries.FormParametersBroadcastOrganization, args, []);
}

export function executeFormParametersBroadcastOrganizationQuery(
    args: FormParametersBroadcastOrganizationQueryVariables,
    token: string | null | undefined
): Promise<FormParametersBroadcastOrganizationQuery> {
    return executeQuery<FormParametersBroadcastOrganizationQuery>(
        Queries.FormParametersBroadcastOrganization,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useFormParametersBroadcastUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    FormParametersBroadcastUpdateMutation,
    FormParametersBroadcastUpdateMutationVariables
> {
    return useMutation(Mutations.FormParametersBroadcastUpdate, args);
}

export function useFormParametersDesignQuery(
    args: FormParametersDesignQueryVariables
): IUseQueryReturns<FormParametersDesignQuery> {
    return useQuery(Queries.FormParametersDesign, args, []);
}

export function executeFormParametersDesignQuery(
    args: FormParametersDesignQueryVariables,
    token: string | null | undefined
): Promise<FormParametersDesignQuery> {
    return executeQuery<FormParametersDesignQuery>(Queries.FormParametersDesign, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useFormParametersDesignUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    FormParametersDesignUpdateMutation,
    FormParametersDesignUpdateMutationVariables
> {
    return useMutation(Mutations.FormParametersDesignUpdate, args);
}

export function useFormParametersGeneralQuery(
    args: FormParametersGeneralQueryVariables
): IUseQueryReturns<FormParametersGeneralQuery> {
    return useQuery(Queries.FormParametersGeneral, args, [Fragments.MassEditCustomFieldFragment]);
}

export function executeFormParametersGeneralQuery(
    args: FormParametersGeneralQueryVariables,
    token: string | null | undefined
): Promise<FormParametersGeneralQuery> {
    return executeQuery<FormParametersGeneralQuery>(Queries.FormParametersGeneral, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.MassEditCustomFieldFragment]
    });
}

export function useFormParametersGeneralUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    FormParametersGeneralUpdateMutation,
    FormParametersGeneralUpdateMutationVariables
> {
    return useMutation(Mutations.FormParametersGeneralUpdate, args);
}

export function useFormParametersMissionsQuery(
    args: FormParametersMissionsQueryVariables
): IUseQueryReturns<FormParametersMissionsQuery> {
    return useQuery(Queries.FormParametersMissions, args, []);
}

export function executeFormParametersMissionsQuery(
    args: FormParametersMissionsQueryVariables,
    token: string | null | undefined
): Promise<FormParametersMissionsQuery> {
    return executeQuery<FormParametersMissionsQuery>(Queries.FormParametersMissions, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useFormParametersMissionsUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    FormParametersMissionsUpdateMutation,
    FormParametersMissionsUpdateMutationVariables
> {
    return useMutation(Mutations.FormParametersMissionsUpdate, args);
}

export function useFormParametersMissionsHiddenDisplayedQuery(
    args: FormParametersMissionsHiddenDisplayedQueryVariables
): IUseQueryReturns<FormParametersMissionsHiddenDisplayedQuery> {
    return useQuery(Queries.FormParametersMissionsHiddenDisplayed, args, []);
}

export function executeFormParametersMissionsHiddenDisplayedQuery(
    args: FormParametersMissionsHiddenDisplayedQueryVariables,
    token: string | null | undefined
): Promise<FormParametersMissionsHiddenDisplayedQuery> {
    return executeQuery<FormParametersMissionsHiddenDisplayedQuery>(
        Queries.FormParametersMissionsHiddenDisplayed,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useFormParametersStateQuery(
    args: FormParametersStateQueryVariables
): IUseQueryReturns<FormParametersStateQuery> {
    return useQuery(Queries.FormParametersState, args, []);
}

export function executeFormParametersStateQuery(
    args: FormParametersStateQueryVariables,
    token: string | null | undefined
): Promise<FormParametersStateQuery> {
    return executeQuery<FormParametersStateQuery>(Queries.FormParametersState, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useFormParametersStateUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    FormParametersStateUpdateMutation,
    FormParametersStateUpdateMutationVariables
> {
    return useMutation(Mutations.FormParametersStateUpdate, args);
}

export function useHomeOrganizationsQuery(
    args: HomeOrganizationsQueryVariables
): IUseQueryReturns<HomeOrganizationsQuery> {
    return useQuery(Queries.HomeOrganizations, args, []);
}

export function executeHomeOrganizationsQuery(
    args: HomeOrganizationsQueryVariables,
    token: string | null | undefined
): Promise<HomeOrganizationsQuery> {
    return executeQuery<HomeOrganizationsQuery>(Queries.HomeOrganizations, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useCollaboratorsVolunteersQuery(
    args: CollaboratorsVolunteersQueryVariables
): IUseQueryReturns<CollaboratorsVolunteersQuery> {
    return useQuery(Queries.CollaboratorsVolunteers, args, [Fragments.LeaderUserInfoFragment]);
}

export function executeCollaboratorsVolunteersQuery(
    args: CollaboratorsVolunteersQueryVariables,
    token: string | null | undefined
): Promise<CollaboratorsVolunteersQuery> {
    return executeQuery<CollaboratorsVolunteersQuery>(Queries.CollaboratorsVolunteers, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.LeaderUserInfoFragment]
    });
}

export function useDelegationsImportResultMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<DelegationsImportResultMutation, DelegationsImportResultMutationVariables> {
    return useMutation(Mutations.DelegationsImportResult, args);
}

export function useEventDocumentsExportResultMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    EventDocumentsExportResultMutation,
    EventDocumentsExportResultMutationVariables
> {
    return useMutation(Mutations.EventDocumentsExportResult, args);
}

export function useExportResultMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<ExportResultMutation, ExportResultMutationVariables> {
    return useMutation(Mutations.ExportResult, args);
}

export function useFilesImportResultMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<FilesImportResultMutation, FilesImportResultMutationVariables> {
    return useMutation(Mutations.FilesImportResult, args);
}

export function usePositionsImportResultMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionsImportResultMutation, PositionsImportResultMutationVariables> {
    return useMutation(Mutations.PositionsImportResult, args);
}

export function useEventKeyQuery(args: EventKeyQueryVariables): IUseQueryReturns<EventKeyQuery> {
    return useQuery(Queries.EventKey, args, []);
}

export function executeEventKeyQuery(
    args: EventKeyQueryVariables,
    token: string | null | undefined
): Promise<EventKeyQuery> {
    return executeQuery<EventKeyQuery>(Queries.EventKey, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useWeezeventRulesQuery(
    args: WeezeventRulesQueryVariables
): IUseQueryReturns<WeezeventRulesQuery> {
    return useQuery(Queries.WeezeventRules, args, []);
}

export function executeWeezeventRulesQuery(
    args: WeezeventRulesQueryVariables,
    token: string | null | undefined
): Promise<WeezeventRulesQuery> {
    return executeQuery<WeezeventRulesQuery>(Queries.WeezeventRules, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useEventWeezeventUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EventWeezeventUpdateMutation, EventWeezeventUpdateMutationVariables> {
    return useMutation(Mutations.EventWeezeventUpdate, args);
}

export function useWeezeventV2InfosQuery(
    args: WeezeventV2InfosQueryVariables
): IUseQueryReturns<WeezeventV2InfosQuery> {
    return useQuery(Queries.WeezeventV2Infos, args, []);
}

export function executeWeezeventV2InfosQuery(
    args: WeezeventV2InfosQueryVariables,
    token: string | null | undefined
): Promise<WeezeventV2InfosQuery> {
    return executeQuery<WeezeventV2InfosQuery>(Queries.WeezeventV2Infos, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useOrganizationCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<OrganizationCreateMutation, OrganizationCreateMutationVariables> {
    return useMutation(Mutations.OrganizationCreate, args);
}

export function useOrganizationsQuery(
    args: OrganizationsQueryVariables
): IUseQueryReturns<OrganizationsQuery> {
    return useQuery(Queries.Organizations, args, []);
}

export function executeOrganizationsQuery(
    args: OrganizationsQueryVariables,
    token: string | null | undefined
): Promise<OrganizationsQuery> {
    return executeQuery<OrganizationsQuery>(Queries.Organizations, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useOrganizationQuery(
    args: OrganizationQueryVariables
): IUseQueryReturns<OrganizationQuery> {
    return useQuery(Queries.Organization, args, []);
}

export function executeOrganizationQuery(
    args: OrganizationQueryVariables,
    token: string | null | undefined
): Promise<OrganizationQuery> {
    return executeQuery<OrganizationQuery>(Queries.Organization, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useUserInfoQuery(args: UserInfoQueryVariables): IUseQueryReturns<UserInfoQuery> {
    return useQuery(Queries.UserInfo, args, []);
}

export function executeUserInfoQuery(
    args: UserInfoQueryVariables,
    token: string | null | undefined
): Promise<UserInfoQuery> {
    return executeQuery<UserInfoQuery>(Queries.UserInfo, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useUserInfoAndTermsUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UserInfoAndTermsUpdateMutation, UserInfoAndTermsUpdateMutationVariables> {
    return useMutation(Mutations.UserInfoAndTermsUpdate, args);
}

export function useActivitiesQuery(
    args: ActivitiesQueryVariables
): IUseQueryReturns<ActivitiesQuery> {
    return useQuery(Queries.Activities, args, []);
}

export function executeActivitiesQuery(
    args: ActivitiesQueryVariables,
    token: string | null | undefined
): Promise<ActivitiesQuery> {
    return executeQuery<ActivitiesQuery>(Queries.Activities, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useOrganizationCategoriesAccreditationsQuery(
    args: OrganizationCategoriesAccreditationsQueryVariables
): IUseQueryReturns<OrganizationCategoriesAccreditationsQuery> {
    return useQuery(Queries.OrganizationCategoriesAccreditations, args, []);
}

export function executeOrganizationCategoriesAccreditationsQuery(
    args: OrganizationCategoriesAccreditationsQueryVariables,
    token: string | null | undefined
): Promise<OrganizationCategoriesAccreditationsQuery> {
    return executeQuery<OrganizationCategoriesAccreditationsQuery>(
        Queries.OrganizationCategoriesAccreditations,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useOrganizationCategoriesCustomFieldsQuery(
    args: OrganizationCategoriesCustomFieldsQueryVariables
): IUseQueryReturns<OrganizationCategoriesCustomFieldsQuery> {
    return useQuery(Queries.OrganizationCategoriesCustomFields, args, []);
}

export function executeOrganizationCategoriesCustomFieldsQuery(
    args: OrganizationCategoriesCustomFieldsQueryVariables,
    token: string | null | undefined
): Promise<OrganizationCategoriesCustomFieldsQuery> {
    return executeQuery<OrganizationCategoriesCustomFieldsQuery>(
        Queries.OrganizationCategoriesCustomFields,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useOrganizationCategoriesDelegationsQuery(
    args: OrganizationCategoriesDelegationsQueryVariables
): IUseQueryReturns<OrganizationCategoriesDelegationsQuery> {
    return useQuery(Queries.OrganizationCategoriesDelegations, args, []);
}

export function executeOrganizationCategoriesDelegationsQuery(
    args: OrganizationCategoriesDelegationsQueryVariables,
    token: string | null | undefined
): Promise<OrganizationCategoriesDelegationsQuery> {
    return executeQuery<OrganizationCategoriesDelegationsQuery>(
        Queries.OrganizationCategoriesDelegations,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useOrganizationCategoriesPositionsQuery(
    args: OrganizationCategoriesPositionsQueryVariables
): IUseQueryReturns<OrganizationCategoriesPositionsQuery> {
    return useQuery(Queries.OrganizationCategoriesPositions, args, []);
}

export function executeOrganizationCategoriesPositionsQuery(
    args: OrganizationCategoriesPositionsQueryVariables,
    token: string | null | undefined
): Promise<OrganizationCategoriesPositionsQuery> {
    return executeQuery<OrganizationCategoriesPositionsQuery>(
        Queries.OrganizationCategoriesPositions,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useOrganizationDelegationSpaceSettingsQuery(
    args: OrganizationDelegationSpaceSettingsQueryVariables
): IUseQueryReturns<OrganizationDelegationSpaceSettingsQuery> {
    return useQuery(Queries.OrganizationDelegationSpaceSettings, args, []);
}

export function executeOrganizationDelegationSpaceSettingsQuery(
    args: OrganizationDelegationSpaceSettingsQueryVariables,
    token: string | null | undefined
): Promise<OrganizationDelegationSpaceSettingsQuery> {
    return executeQuery<OrganizationDelegationSpaceSettingsQuery>(
        Queries.OrganizationDelegationSpaceSettings,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useOrganizationDelegationSpaceSettingsUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    OrganizationDelegationSpaceSettingsUpdateMutation,
    OrganizationDelegationSpaceSettingsUpdateMutationVariables
> {
    return useMutation(Mutations.OrganizationDelegationSpaceSettingsUpdate, args);
}

export function useOrganizationDelegationsSpaceDesignQuery(
    args: OrganizationDelegationsSpaceDesignQueryVariables
): IUseQueryReturns<OrganizationDelegationsSpaceDesignQuery> {
    return useQuery(Queries.OrganizationDelegationsSpaceDesign, args, []);
}

export function executeOrganizationDelegationsSpaceDesignQuery(
    args: OrganizationDelegationsSpaceDesignQueryVariables,
    token: string | null | undefined
): Promise<OrganizationDelegationsSpaceDesignQuery> {
    return executeQuery<OrganizationDelegationsSpaceDesignQuery>(
        Queries.OrganizationDelegationsSpaceDesign,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useOrganizationDelegationsSpaceDesignUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    OrganizationDelegationsSpaceDesignUpdateMutation,
    OrganizationDelegationsSpaceDesignUpdateMutationVariables
> {
    return useMutation(Mutations.OrganizationDelegationsSpaceDesignUpdate, args);
}

export function useDomainDkimVerificationRetryMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    DomainDkimVerificationRetryMutation,
    DomainDkimVerificationRetryMutationVariables
> {
    return useMutation(Mutations.DomainDkimVerificationRetry, args);
}

export function useOrganizationDomainsQuery(
    args: OrganizationDomainsQueryVariables
): IUseQueryReturns<OrganizationDomainsQuery> {
    return useQuery(Queries.OrganizationDomains, args, []);
}

export function executeOrganizationDomainsQuery(
    args: OrganizationDomainsQueryVariables,
    token: string | null | undefined
): Promise<OrganizationDomainsQuery> {
    return executeQuery<OrganizationDomainsQuery>(Queries.OrganizationDomains, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useEmailSenderCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EmailSenderCreateMutation, EmailSenderCreateMutationVariables> {
    return useMutation(Mutations.EmailSenderCreate, args);
}

export function useEmailSenderToEditQuery(
    args: EmailSenderToEditQueryVariables
): IUseQueryReturns<EmailSenderToEditQuery> {
    return useQuery(Queries.EmailSenderToEdit, args, []);
}

export function executeEmailSenderToEditQuery(
    args: EmailSenderToEditQueryVariables,
    token: string | null | undefined
): Promise<EmailSenderToEditQuery> {
    return executeQuery<EmailSenderToEditQuery>(Queries.EmailSenderToEdit, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useEmailSenderUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EmailSenderUpdateMutation, EmailSenderUpdateMutationVariables> {
    return useMutation(Mutations.EmailSenderUpdate, args);
}

export function useEmailSenderDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EmailSenderDeleteMutation, EmailSenderDeleteMutationVariables> {
    return useMutation(Mutations.EmailSenderDelete, args);
}

export function useEmailSenderDuplicateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EmailSenderDuplicateMutation, EmailSenderDuplicateMutationVariables> {
    return useMutation(Mutations.EmailSenderDuplicate, args);
}

export function useEmailSenderVerificationResendMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    EmailSenderVerificationResendMutation,
    EmailSenderVerificationResendMutationVariables
> {
    return useMutation(Mutations.EmailSenderVerificationResend, args);
}

export function useEmailsSendersQuery(
    args: EmailsSendersQueryVariables
): IUseQueryReturns<EmailsSendersQuery> {
    return useQuery(Queries.EmailsSenders, args, []);
}

export function executeEmailsSendersQuery(
    args: EmailsSendersQueryVariables,
    token: string | null | undefined
): Promise<EmailsSendersQuery> {
    return executeQuery<EmailsSendersQuery>(Queries.EmailsSenders, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useEmailSenderPreviewQuery(
    args: EmailSenderPreviewQueryVariables
): IUseQueryReturns<EmailSenderPreviewQuery> {
    return useQuery(Queries.EmailSenderPreview, args, []);
}

export function executeEmailSenderPreviewQuery(
    args: EmailSenderPreviewQueryVariables,
    token: string | null | undefined
): Promise<EmailSenderPreviewQuery> {
    return executeQuery<EmailSenderPreviewQuery>(Queries.EmailSenderPreview, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useOrganizationParametersInfosQuery(
    args: OrganizationParametersInfosQueryVariables
): IUseQueryReturns<OrganizationParametersInfosQuery> {
    return useQuery(Queries.OrganizationParametersInfos, args, [
        Fragments.OrganizationAdminInfosFragment
    ]);
}

export function executeOrganizationParametersInfosQuery(
    args: OrganizationParametersInfosQueryVariables,
    token: string | null | undefined
): Promise<OrganizationParametersInfosQuery> {
    return executeQuery<OrganizationParametersInfosQuery>(Queries.OrganizationParametersInfos, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.OrganizationAdminInfosFragment]
    });
}

export function useOrganizationUpdateInfosMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<OrganizationUpdateInfosMutation, OrganizationUpdateInfosMutationVariables> {
    return useMutation(Mutations.OrganizationUpdateInfos, args);
}

export function useInvoicesQuery(args: InvoicesQueryVariables): IUseQueryReturns<InvoicesQuery> {
    return useQuery(Queries.Invoices, args, []);
}

export function executeInvoicesQuery(
    args: InvoicesQueryVariables,
    token: string | null | undefined
): Promise<InvoicesQuery> {
    return executeQuery<InvoicesQuery>(Queries.Invoices, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useOrganizationMembersSpaceDesignQuery(
    args: OrganizationMembersSpaceDesignQueryVariables
): IUseQueryReturns<OrganizationMembersSpaceDesignQuery> {
    return useQuery(Queries.OrganizationMembersSpaceDesign, args, []);
}

export function executeOrganizationMembersSpaceDesignQuery(
    args: OrganizationMembersSpaceDesignQueryVariables,
    token: string | null | undefined
): Promise<OrganizationMembersSpaceDesignQuery> {
    return executeQuery<OrganizationMembersSpaceDesignQuery>(
        Queries.OrganizationMembersSpaceDesign,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useOrganizationMembersSpaceDesignUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    OrganizationMembersSpaceDesignUpdateMutation,
    OrganizationMembersSpaceDesignUpdateMutationVariables
> {
    return useMutation(Mutations.OrganizationMembersSpaceDesignUpdate, args);
}

export function useOrganizationMembersSpaceSettingsQuery(
    args: OrganizationMembersSpaceSettingsQueryVariables
): IUseQueryReturns<OrganizationMembersSpaceSettingsQuery> {
    return useQuery(Queries.OrganizationMembersSpaceSettings, args, []);
}

export function executeOrganizationMembersSpaceSettingsQuery(
    args: OrganizationMembersSpaceSettingsQueryVariables,
    token: string | null | undefined
): Promise<OrganizationMembersSpaceSettingsQuery> {
    return executeQuery<OrganizationMembersSpaceSettingsQuery>(
        Queries.OrganizationMembersSpaceSettings,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useOrganizationMembersSpaceSettingsUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    OrganizationMembersSpaceSettingsUpdateMutation,
    OrganizationMembersSpaceSettingsUpdateMutationVariables
> {
    return useMutation(Mutations.OrganizationMembersSpaceSettingsUpdate, args);
}

export function useUserDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UserDeleteMutation, UserDeleteMutationVariables> {
    return useMutation(Mutations.UserDelete, args);
}

export function useRoleQuery(args: RoleQueryVariables): IUseQueryReturns<RoleQuery> {
    return useQuery(Queries.Role, args, []);
}

export function executeRoleQuery(
    args: RoleQueryVariables,
    token: string | null | undefined
): Promise<RoleQuery> {
    return executeQuery<RoleQuery>(Queries.Role, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useRoleCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<RoleCreateMutation, RoleCreateMutationVariables> {
    return useMutation(Mutations.RoleCreate, args);
}

export function useRoleUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<RoleUpdateMutation, RoleUpdateMutationVariables> {
    return useMutation(Mutations.RoleUpdate, args);
}

export function useRoleDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<RoleDeleteMutation, RoleDeleteMutationVariables> {
    return useMutation(Mutations.RoleDelete, args);
}

export function useRoleUsesQuery(args: RoleUsesQueryVariables): IUseQueryReturns<RoleUsesQuery> {
    return useQuery(Queries.RoleUses, args, []);
}

export function executeRoleUsesQuery(
    args: RoleUsesQueryVariables,
    token: string | null | undefined
): Promise<RoleUsesQuery> {
    return executeQuery<RoleUsesQuery>(Queries.RoleUses, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useRolesQuery(args: RolesQueryVariables): IUseQueryReturns<RolesQuery> {
    return useQuery(Queries.Roles, args, []);
}

export function executeRolesQuery(
    args: RolesQueryVariables,
    token: string | null | undefined
): Promise<RolesQuery> {
    return executeQuery<RolesQuery>(Queries.Roles, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useSkidataConnectionInfoSeaonEventAddMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    SkidataConnectionInfoSeaonEventAddMutation,
    SkidataConnectionInfoSeaonEventAddMutationVariables
> {
    return useMutation(Mutations.SkidataConnectionInfoSeaonEventAdd, args);
}

export function useSkidataConnectionInfoSeaonEventDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    SkidataConnectionInfoSeaonEventDeleteMutation,
    SkidataConnectionInfoSeaonEventDeleteMutationVariables
> {
    return useMutation(Mutations.SkidataConnectionInfoSeaonEventDelete, args);
}

export function useSkidataConnectionInfoSynchronizedEventAddMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    SkidataConnectionInfoSynchronizedEventAddMutation,
    SkidataConnectionInfoSynchronizedEventAddMutationVariables
> {
    return useMutation(Mutations.SkidataConnectionInfoSynchronizedEventAdd, args);
}

export function useSkidataConnectionInfoSynchronizedEventDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    SkidataConnectionInfoSynchronizedEventDeleteMutation,
    SkidataConnectionInfoSynchronizedEventDeleteMutationVariables
> {
    return useMutation(Mutations.SkidataConnectionInfoSynchronizedEventDelete, args);
}

export function useSkidataConnectionInfosQuery(
    args: SkidataConnectionInfosQueryVariables
): IUseQueryReturns<SkidataConnectionInfosQuery> {
    return useQuery(Queries.SkidataConnectionInfos, args, []);
}

export function executeSkidataConnectionInfosQuery(
    args: SkidataConnectionInfosQueryVariables,
    token: string | null | undefined
): Promise<SkidataConnectionInfosQuery> {
    return executeQuery<SkidataConnectionInfosQuery>(Queries.SkidataConnectionInfos, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useSkidataConnectionInfosDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    SkidataConnectionInfosDeleteMutation,
    SkidataConnectionInfosDeleteMutationVariables
> {
    return useMutation(Mutations.SkidataConnectionInfosDelete, args);
}

export function useSkidataConnectionInfosUpsertMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    SkidataConnectionInfosUpsertMutation,
    SkidataConnectionInfosUpsertMutationVariables
> {
    return useMutation(Mutations.SkidataConnectionInfosUpsert, args);
}

export function useSkidataSynchronizeMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<SkidataSynchronizeMutation, SkidataSynchronizeMutationVariables> {
    return useMutation(Mutations.SkidataSynchronize, args);
}

export function useOrganizationTagsQuery(
    args: OrganizationTagsQueryVariables
): IUseQueryReturns<OrganizationTagsQuery> {
    return useQuery(Queries.OrganizationTags, args, []);
}

export function executeOrganizationTagsQuery(
    args: OrganizationTagsQueryVariables,
    token: string | null | undefined
): Promise<OrganizationTagsQuery> {
    return executeQuery<OrganizationTagsQuery>(Queries.OrganizationTags, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useTagCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<TagCreateMutation, TagCreateMutationVariables> {
    return useMutation(Mutations.TagCreate, args);
}

export function useTagDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<TagDeleteMutation, TagDeleteMutationVariables> {
    return useMutation(Mutations.TagDelete, args);
}

export function useTagUpdateNameMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<TagUpdateNameMutation, TagUpdateNameMutationVariables> {
    return useMutation(Mutations.TagUpdateName, args);
}

export function useEventAdminsLeadersQuery(
    args: EventAdminsLeadersQueryVariables
): IUseQueryReturns<EventAdminsLeadersQuery> {
    return useQuery(Queries.EventAdminsLeaders, args, []);
}

export function executeEventAdminsLeadersQuery(
    args: EventAdminsLeadersQueryVariables,
    token: string | null | undefined
): Promise<EventAdminsLeadersQuery> {
    return executeQuery<EventAdminsLeadersQuery>(Queries.EventAdminsLeaders, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useEventInviteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EventInviteMutation, EventInviteMutationVariables> {
    return useMutation(Mutations.EventInvite, args);
}

export function useOrganizationInviteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<OrganizationInviteMutation, OrganizationInviteMutationVariables> {
    return useMutation(Mutations.OrganizationInvite, args);
}

export function useTeamQuery(args: TeamQueryVariables): IUseQueryReturns<TeamQuery> {
    return useQuery(Queries.Team, args, []);
}

export function executeTeamQuery(
    args: TeamQueryVariables,
    token: string | null | undefined
): Promise<TeamQuery> {
    return executeQuery<TeamQuery>(Queries.Team, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useUserEventDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UserEventDeleteMutation, UserEventDeleteMutationVariables> {
    return useMutation(Mutations.UserEventDelete, args);
}

export function useUserEventUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UserEventUpdateMutation, UserEventUpdateMutationVariables> {
    return useMutation(Mutations.UserEventUpdate, args);
}

export function useUserLeaderDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UserLeaderDeleteMutation, UserLeaderDeleteMutationVariables> {
    return useMutation(Mutations.UserLeaderDelete, args);
}

export function useUserOrganizationDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UserOrganizationDeleteMutation, UserOrganizationDeleteMutationVariables> {
    return useMutation(Mutations.UserOrganizationDelete, args);
}

export function useUserOrganizationUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UserOrganizationUpdateMutation, UserOrganizationUpdateMutationVariables> {
    return useMutation(Mutations.UserOrganizationUpdate, args);
}

export function useUserPositionCategoryUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    UserPositionCategoryUpdateMutation,
    UserPositionCategoryUpdateMutationVariables
> {
    return useMutation(Mutations.UserPositionCategoryUpdate, args);
}

export function useUserPositionUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UserPositionUpdateMutation, UserPositionUpdateMutationVariables> {
    return useMutation(Mutations.UserPositionUpdate, args);
}

export function useOrganizationTranslationsQuery(
    args: OrganizationTranslationsQueryVariables
): IUseQueryReturns<OrganizationTranslationsQuery> {
    return useQuery(Queries.OrganizationTranslations, args, [Fragments.TranslationFragment]);
}

export function executeOrganizationTranslationsQuery(
    args: OrganizationTranslationsQueryVariables,
    token: string | null | undefined
): Promise<OrganizationTranslationsQuery> {
    return executeQuery<OrganizationTranslationsQuery>(Queries.OrganizationTranslations, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.TranslationFragment]
    });
}

export function useOrganizationTranslationsStatsQuery(
    args: OrganizationTranslationsStatsQueryVariables
): IUseQueryReturns<OrganizationTranslationsStatsQuery> {
    return useQuery(Queries.OrganizationTranslationsStats, args, []);
}

export function executeOrganizationTranslationsStatsQuery(
    args: OrganizationTranslationsStatsQueryVariables,
    token: string | null | undefined
): Promise<OrganizationTranslationsStatsQuery> {
    return executeQuery<OrganizationTranslationsStatsQuery>(Queries.OrganizationTranslationsStats, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useTranslationUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<TranslationUpdateMutation, TranslationUpdateMutationVariables> {
    return useMutation(Mutations.TranslationUpdate, args);
}

export function usePositionCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionCreateMutation, PositionCreateMutationVariables> {
    return useMutation(Mutations.PositionCreate, args);
}

export function usePositionEventInfosQuery(
    args: PositionEventInfosQueryVariables
): IUseQueryReturns<PositionEventInfosQuery> {
    return useQuery(Queries.PositionEventInfos, args, [
        Fragments.ConditionsCustomFieldsFragment,
        Fragments.CreatePositionTagsFragment,
        Fragments.AttachCustomFieldFragment,
        Fragments.CreatePositionEventFragment
    ]);
}

export function executePositionEventInfosQuery(
    args: PositionEventInfosQueryVariables,
    token: string | null | undefined
): Promise<PositionEventInfosQuery> {
    return executeQuery<PositionEventInfosQuery>(Queries.PositionEventInfos, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.ConditionsCustomFieldsFragment,
            Fragments.CreatePositionTagsFragment,
            Fragments.AttachCustomFieldFragment,
            Fragments.CreatePositionEventFragment
        ]
    });
}

export function usePositionToEditQuery(
    args: PositionToEditQueryVariables
): IUseQueryReturns<PositionToEditQuery> {
    return useQuery(Queries.PositionToEdit, args, [
        Fragments.ConditionsCustomFieldsFragment,
        Fragments.CreatePositionTagsFragment,
        Fragments.AttachCustomFieldFragment,
        Fragments.CreatePositionEventFragment
    ]);
}

export function executePositionToEditQuery(
    args: PositionToEditQueryVariables,
    token: string | null | undefined
): Promise<PositionToEditQuery> {
    return executeQuery<PositionToEditQuery>(Queries.PositionToEdit, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.ConditionsCustomFieldsFragment,
            Fragments.CreatePositionTagsFragment,
            Fragments.AttachCustomFieldFragment,
            Fragments.CreatePositionEventFragment
        ]
    });
}

export function usePositionUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionUpdateMutation, PositionUpdateMutationVariables> {
    return useMutation(Mutations.PositionUpdate, args);
}

export function usePositionsImportMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionsImportMutation, PositionsImportMutationVariables> {
    return useMutation(Mutations.PositionsImport, args);
}

export function useKmlEventInfosQuery(
    args: KmlEventInfosQueryVariables
): IUseQueryReturns<KmlEventInfosQuery> {
    return useQuery(Queries.KmlEventInfos, args, []);
}

export function executeKmlEventInfosQuery(
    args: KmlEventInfosQueryVariables,
    token: string | null | undefined
): Promise<KmlEventInfosQuery> {
    return executeQuery<KmlEventInfosQuery>(Queries.KmlEventInfos, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function usePositionsCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionsCreateMutation, PositionsCreateMutationVariables> {
    return useMutation(Mutations.PositionsCreate, args);
}

export function usePositionsCategoriesQuery(
    args: PositionsCategoriesQueryVariables
): IUseQueryReturns<PositionsCategoriesQuery> {
    return useQuery(Queries.PositionsCategories, args, []);
}

export function executePositionsCategoriesQuery(
    args: PositionsCategoriesQueryVariables,
    token: string | null | undefined
): Promise<PositionsCategoriesQuery> {
    return executeQuery<PositionsCategoriesQuery>(Queries.PositionsCategories, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function usePositionsMassDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionsMassDeleteMutation, PositionsMassDeleteMutationVariables> {
    return useMutation(Mutations.PositionsMassDelete, args);
}

export function usePositionsPositionQuery(
    args: PositionsPositionQueryVariables
): IUseQueryReturns<PositionsPositionQuery> {
    return useQuery(Queries.PositionsPosition, args, [Fragments.PositionsPositionFragment]);
}

export function executePositionsPositionQuery(
    args: PositionsPositionQueryVariables,
    token: string | null | undefined
): Promise<PositionsPositionQuery> {
    return executeQuery<PositionsPositionQuery>(Queries.PositionsPosition, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.PositionsPositionFragment]
    });
}

export function useEventLayerUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<EventLayerUpdateMutation, EventLayerUpdateMutationVariables> {
    return useMutation(Mutations.EventLayerUpdate, args);
}

export function useTraceCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<TraceCreateMutation, TraceCreateMutationVariables> {
    return useMutation(Mutations.TraceCreate, args);
}

export function useTraceDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<TraceDeleteMutation, TraceDeleteMutationVariables> {
    return useMutation(Mutations.TraceDelete, args);
}

export function useTraceUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<TraceUpdateMutation, TraceUpdateMutationVariables> {
    return useMutation(Mutations.TraceUpdate, args);
}

export function useTracesQuery(args: TracesQueryVariables): IUseQueryReturns<TracesQuery> {
    return useQuery(Queries.Traces, args, []);
}

export function executeTracesQuery(
    args: TracesQueryVariables,
    token: string | null | undefined
): Promise<TracesQuery> {
    return executeQuery<TracesQuery>(Queries.Traces, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function usePositionSlotCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionSlotCreateMutation, PositionSlotCreateMutationVariables> {
    return useMutation(Mutations.PositionSlotCreate, args);
}

export function usePositionsPlanningQuery(
    args: PositionsPlanningQueryVariables
): IUseQueryReturns<PositionsPlanningQuery> {
    return useQuery(Queries.PositionsPlanning, args, [Fragments.PositionPlanningFragment]);
}

export function executePositionsPlanningQuery(
    args: PositionsPlanningQueryVariables,
    token: string | null | undefined
): Promise<PositionsPlanningQuery> {
    return executeQuery<PositionsPlanningQuery>(Queries.PositionsPlanning, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.PositionPlanningFragment]
    });
}

export function usePositionsPlanningPositionQuery(
    args: PositionsPlanningPositionQueryVariables
): IUseQueryReturns<PositionsPlanningPositionQuery> {
    return useQuery(Queries.PositionsPlanningPosition, args, [Fragments.PositionPlanningFragment]);
}

export function executePositionsPlanningPositionQuery(
    args: PositionsPlanningPositionQueryVariables,
    token: string | null | undefined
): Promise<PositionsPlanningPositionQuery> {
    return executeQuery<PositionsPlanningPositionQuery>(Queries.PositionsPlanningPosition, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.PositionPlanningFragment]
    });
}

export function usePositionCategoryLeaderDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    PositionCategoryLeaderDeleteMutation,
    PositionCategoryLeaderDeleteMutationVariables
> {
    return useMutation(Mutations.PositionCategoryLeaderDelete, args);
}

export function usePositionsQuery(args: PositionsQueryVariables): IUseQueryReturns<PositionsQuery> {
    return useQuery(Queries.Positions, args, [
        Fragments.PositionsPositionFragment,
        Fragments.TraceFragment
    ]);
}

export function executePositionsQuery(
    args: PositionsQueryVariables,
    token: string | null | undefined
): Promise<PositionsQuery> {
    return executeQuery<PositionsQuery>(Queries.Positions, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.PositionsPositionFragment, Fragments.TraceFragment]
    });
}

export function usePositionsHeaderQuery(
    args: PositionsHeaderQueryVariables
): IUseQueryReturns<PositionsHeaderQuery> {
    return useQuery(Queries.PositionsHeader, args, []);
}

export function executePositionsHeaderQuery(
    args: PositionsHeaderQueryVariables,
    token: string | null | undefined
): Promise<PositionsHeaderQuery> {
    return executeQuery<PositionsHeaderQuery>(Queries.PositionsHeader, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function usePositionsSegmentsQuery(
    args: PositionsSegmentsQueryVariables
): IUseQueryReturns<PositionsSegmentsQuery> {
    return useQuery(Queries.PositionsSegments, args, [
        Fragments.SegmentCustomFieldFragment,
        Fragments.LeaderInfosFragment,
        Fragments.SegmentsFoldersSegmentsFragment
    ]);
}

export function executePositionsSegmentsQuery(
    args: PositionsSegmentsQueryVariables,
    token: string | null | undefined
): Promise<PositionsSegmentsQuery> {
    return executeQuery<PositionsSegmentsQuery>(Queries.PositionsSegments, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.SegmentCustomFieldFragment,
            Fragments.LeaderInfosFragment,
            Fragments.SegmentsFoldersSegmentsFragment
        ]
    });
}

export function usePositionMapQuery(
    args: PositionMapQueryVariables
): IUseQueryReturns<PositionMapQuery> {
    return useQuery(Queries.PositionMap, args, [Fragments.TraceFragment]);
}

export function executePositionMapQuery(
    args: PositionMapQueryVariables,
    token: string | null | undefined
): Promise<PositionMapQuery> {
    return executeQuery<PositionMapQuery>(Queries.PositionMap, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.TraceFragment]
    });
}

export function useMassConditionsCustomFieldsQuery(
    args: MassConditionsCustomFieldsQueryVariables
): IUseQueryReturns<MassConditionsCustomFieldsQuery> {
    return useQuery(Queries.MassConditionsCustomFields, args, [
        Fragments.ConditionsCustomFieldsFragment
    ]);
}

export function executeMassConditionsCustomFieldsQuery(
    args: MassConditionsCustomFieldsQueryVariables,
    token: string | null | undefined
): Promise<MassConditionsCustomFieldsQuery> {
    return executeQuery<MassConditionsCustomFieldsQuery>(Queries.MassConditionsCustomFields, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.ConditionsCustomFieldsFragment]
    });
}

export function usePositionsMassConditionsMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionsMassConditionsMutation, PositionsMassConditionsMutationVariables> {
    return useMutation(Mutations.PositionsMassConditions, args);
}

export function usePositionsMobileQuery(
    args: PositionsMobileQueryVariables
): IUseQueryReturns<PositionsMobileQuery> {
    return useQuery(Queries.PositionsMobile, args, [
        Fragments.LeaderInfosFragment,
        Fragments.FullPageInfoFragment
    ]);
}

export function executePositionsMobileQuery(
    args: PositionsMobileQueryVariables,
    token: string | null | undefined
): Promise<PositionsMobileQuery> {
    return executeQuery<PositionsMobileQuery>(Queries.PositionsMobile, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.LeaderInfosFragment, Fragments.FullPageInfoFragment]
    });
}

export function usePositionsSegmentsMobileQuery(
    args: PositionsSegmentsMobileQueryVariables
): IUseQueryReturns<PositionsSegmentsMobileQuery> {
    return useQuery(Queries.PositionsSegmentsMobile, args, [
        Fragments.SegmentsFoldersSegmentsFragment
    ]);
}

export function executePositionsSegmentsMobileQuery(
    args: PositionsSegmentsMobileQueryVariables,
    token: string | null | undefined
): Promise<PositionsSegmentsMobileQuery> {
    return executeQuery<PositionsSegmentsMobileQuery>(Queries.PositionsSegmentsMobile, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.SegmentsFoldersSegmentsFragment]
    });
}

export function useRecentPositionsSearchesMobileQuery(
    args: RecentPositionsSearchesMobileQueryVariables
): IUseQueryReturns<RecentPositionsSearchesMobileQuery> {
    return useQuery(Queries.RecentPositionsSearchesMobile, args, []);
}

export function executeRecentPositionsSearchesMobileQuery(
    args: RecentPositionsSearchesMobileQueryVariables,
    token: string | null | undefined
): Promise<RecentPositionsSearchesMobileQuery> {
    return executeQuery<RecentPositionsSearchesMobileQuery>(Queries.RecentPositionsSearchesMobile, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function usePositionSlotMembersMobileQuery(
    args: PositionSlotMembersMobileQueryVariables
): IUseQueryReturns<PositionSlotMembersMobileQuery> {
    return useQuery(Queries.PositionSlotMembersMobile, args, [Fragments.FullPageInfoFragment]);
}

export function executePositionSlotMembersMobileQuery(
    args: PositionSlotMembersMobileQueryVariables,
    token: string | null | undefined
): Promise<PositionSlotMembersMobileQuery> {
    return executeQuery<PositionSlotMembersMobileQuery>(Queries.PositionSlotMembersMobile, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.FullPageInfoFragment]
    });
}

export function usePositionSlotsMobileQuery(
    args: PositionSlotsMobileQueryVariables
): IUseQueryReturns<PositionSlotsMobileQuery> {
    return useQuery(Queries.PositionSlotsMobile, args, [
        Fragments.PositionPositionSlotFragment,
        Fragments.FullPageInfoFragment
    ]);
}

export function executePositionSlotsMobileQuery(
    args: PositionSlotsMobileQueryVariables,
    token: string | null | undefined
): Promise<PositionSlotsMobileQuery> {
    return executeQuery<PositionSlotsMobileQuery>(Queries.PositionSlotsMobile, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.PositionPositionSlotFragment, Fragments.FullPageInfoFragment]
    });
}

export function usePositionDashboardQuery(
    args: PositionDashboardQueryVariables
): IUseQueryReturns<PositionDashboardQuery> {
    return useQuery(Queries.PositionDashboard, args, [
        Fragments.CustomFieldWithConditionFragment,
        Fragments.TraceFragment,
        Fragments.LeaderInfosFragment
    ]);
}

export function executePositionDashboardQuery(
    args: PositionDashboardQueryVariables,
    token: string | null | undefined
): Promise<PositionDashboardQuery> {
    return executeQuery<PositionDashboardQuery>(Queries.PositionDashboard, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.CustomFieldWithConditionFragment,
            Fragments.TraceFragment,
            Fragments.LeaderInfosFragment
        ]
    });
}

export function usePositionQuery(args: PositionQueryVariables): IUseQueryReturns<PositionQuery> {
    return useQuery(Queries.Position, args, []);
}

export function executePositionQuery(
    args: PositionQueryVariables,
    token: string | null | undefined
): Promise<PositionQuery> {
    return executeQuery<PositionQuery>(Queries.Position, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function usePositionLeaderDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionLeaderDeleteMutation, PositionLeaderDeleteMutationVariables> {
    return useMutation(Mutations.PositionLeaderDelete, args);
}

export function usePositionLeadersAsignMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionLeadersAsignMutation, PositionLeadersAsignMutationVariables> {
    return useMutation(Mutations.PositionLeadersAsign, args);
}

export function usePositionSlotDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionSlotDeleteMutation, PositionSlotDeleteMutationVariables> {
    return useMutation(Mutations.PositionSlotDelete, args);
}

export function usePositionSlotUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionSlotUpdateMutation, PositionSlotUpdateMutationVariables> {
    return useMutation(Mutations.PositionSlotUpdate, args);
}

export function usePositionSlotVolunteersQuery(
    args: PositionSlotVolunteersQueryVariables
): IUseQueryReturns<PositionSlotVolunteersQuery> {
    return useQuery(Queries.PositionSlotVolunteers, args, []);
}

export function executePositionSlotVolunteersQuery(
    args: PositionSlotVolunteersQueryVariables,
    token: string | null | undefined
): Promise<PositionSlotVolunteersQuery> {
    return executeQuery<PositionSlotVolunteersQuery>(Queries.PositionSlotVolunteers, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function usePositionSlotsQuery(
    args: PositionSlotsQueryVariables
): IUseQueryReturns<PositionSlotsQuery> {
    return useQuery(Queries.PositionSlots, args, [Fragments.PositionPositionSlotFragment]);
}

export function executePositionSlotsQuery(
    args: PositionSlotsQueryVariables,
    token: string | null | undefined
): Promise<PositionSlotsQuery> {
    return executeQuery<PositionSlotsQuery>(Queries.PositionSlots, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.PositionPositionSlotFragment]
    });
}

export function usePositionCategoryCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionCategoryCreateMutation, PositionCategoryCreateMutationVariables> {
    return useMutation(Mutations.PositionCategoryCreate, args);
}

export function usePositionCategoryUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionCategoryUpdateMutation, PositionCategoryUpdateMutationVariables> {
    return useMutation(Mutations.PositionCategoryUpdate, args);
}

export function usePositionCategoryDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<PositionCategoryDeleteMutation, PositionCategoryDeleteMutationVariables> {
    return useMutation(Mutations.PositionCategoryDelete, args);
}

export function usePositionCategoryQuery(
    args: PositionCategoryQueryVariables
): IUseQueryReturns<PositionCategoryQuery> {
    return useQuery(Queries.PositionCategory, args, [Fragments.LeaderInfosFragment]);
}

export function executePositionCategoryQuery(
    args: PositionCategoryQueryVariables,
    token: string | null | undefined
): Promise<PositionCategoryQuery> {
    return executeQuery<PositionCategoryQuery>(Queries.PositionCategory, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.LeaderInfosFragment]
    });
}

export function usePositionCategoryDescriptionUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    PositionCategoryDescriptionUpdateMutation,
    PositionCategoryDescriptionUpdateMutationVariables
> {
    return useMutation(Mutations.PositionCategoryDescriptionUpdate, args);
}

export function usePositionCategoryDuplicateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    PositionCategoryDuplicateMutation,
    PositionCategoryDuplicateMutationVariables
> {
    return useMutation(Mutations.PositionCategoryDuplicate, args);
}

export function usePositionCategoryPositionsQuery(
    args: PositionCategoryPositionsQueryVariables
): IUseQueryReturns<PositionCategoryPositionsQuery> {
    return useQuery(Queries.PositionCategoryPositions, args, [
        Fragments.PositionCategoryPositionFragment
    ]);
}

export function executePositionCategoryPositionsQuery(
    args: PositionCategoryPositionsQueryVariables,
    token: string | null | undefined
): Promise<PositionCategoryPositionsQuery> {
    return executeQuery<PositionCategoryPositionsQuery>(Queries.PositionCategoryPositions, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.PositionCategoryPositionFragment]
    });
}

export function usePositionsCategoryLeadersAssignMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    PositionsCategoryLeadersAssignMutation,
    PositionsCategoryLeadersAssignMutationVariables
> {
    return useMutation(Mutations.PositionsCategoryLeadersAssign, args);
}

export function useAvailableVolunteersRegistrationsQuery(
    args: AvailableVolunteersRegistrationsQueryVariables
): IUseQueryReturns<AvailableVolunteersRegistrationsQuery> {
    return useQuery(Queries.AvailableVolunteersRegistrations, args, []);
}

export function executeAvailableVolunteersRegistrationsQuery(
    args: AvailableVolunteersRegistrationsQueryVariables,
    token: string | null | undefined
): Promise<AvailableVolunteersRegistrationsQuery> {
    return executeQuery<AvailableVolunteersRegistrationsQuery>(
        Queries.AvailableVolunteersRegistrations,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function usePositionsPositionSlotQuery(
    args: PositionsPositionSlotQueryVariables
): IUseQueryReturns<PositionsPositionSlotQuery> {
    return useQuery(Queries.PositionsPositionSlot, args, [Fragments.PositionsPositionSlotFragment]);
}

export function executePositionsPositionSlotQuery(
    args: PositionsPositionSlotQueryVariables,
    token: string | null | undefined
): Promise<PositionsPositionSlotQuery> {
    return executeQuery<PositionsPositionSlotQuery>(Queries.PositionsPositionSlot, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.PositionsPositionSlotFragment]
    });
}

export function usePositionsSlotsQuery(
    args: PositionsSlotsQueryVariables
): IUseQueryReturns<PositionsSlotsQuery> {
    return useQuery(Queries.PositionsSlots, args, [Fragments.PositionsPositionSlotFragment]);
}

export function executePositionsSlotsQuery(
    args: PositionsSlotsQueryVariables,
    token: string | null | undefined
): Promise<PositionsSlotsQuery> {
    return executeQuery<PositionsSlotsQuery>(Queries.PositionsSlots, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.PositionsPositionSlotFragment]
    });
}

export function useUserFieldUpdateQuery(
    args: UserFieldUpdateQueryVariables
): IUseQueryReturns<UserFieldUpdateQuery> {
    return useQuery(Queries.UserFieldUpdate, args, []);
}

export function executeUserFieldUpdateQuery(
    args: UserFieldUpdateQueryVariables,
    token: string | null | undefined
): Promise<UserFieldUpdateQuery> {
    return executeQuery<UserFieldUpdateQuery>(Queries.UserFieldUpdate, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useUserInfoMobileQuery(
    args: UserInfoMobileQueryVariables
): IUseQueryReturns<UserInfoMobileQuery> {
    return useQuery(Queries.UserInfoMobile, args, [
        Fragments.CustomFieldWithConditionFragment,
        Fragments.UserInfoOverlayFragment,
        Fragments.UserPositionSlotUserInfoFragment
    ]);
}

export function executeUserInfoMobileQuery(
    args: UserInfoMobileQueryVariables,
    token: string | null | undefined
): Promise<UserInfoMobileQuery> {
    return executeQuery<UserInfoMobileQuery>(Queries.UserInfoMobile, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.CustomFieldWithConditionFragment,
            Fragments.UserInfoOverlayFragment,
            Fragments.UserPositionSlotUserInfoFragment
        ]
    });
}

export function useUserProfileAccreditationsQuery(
    args: UserProfileAccreditationsQueryVariables
): IUseQueryReturns<UserProfileAccreditationsQuery> {
    return useQuery(Queries.UserProfileAccreditations, args, [
        Fragments.UserPanelAccreditationSlotUserInfoFragment
    ]);
}

export function executeUserProfileAccreditationsQuery(
    args: UserProfileAccreditationsQueryVariables,
    token: string | null | undefined
): Promise<UserProfileAccreditationsQuery> {
    return executeQuery<UserProfileAccreditationsQuery>(Queries.UserProfileAccreditations, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.UserPanelAccreditationSlotUserInfoFragment]
    });
}

export function useUserInfoAdminDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UserInfoAdminDeleteMutation, UserInfoAdminDeleteMutationVariables> {
    return useMutation(Mutations.UserInfoAdminDelete, args);
}

export function useUserOverlayActionsEventQuery(
    args: UserOverlayActionsEventQueryVariables
): IUseQueryReturns<UserOverlayActionsEventQuery> {
    return useQuery(Queries.UserOverlayActionsEvent, args, [
        Fragments.CustomDocumentPopulationFragment,
        Fragments.UserInfoOverlayFragment
    ]);
}

export function executeUserOverlayActionsEventQuery(
    args: UserOverlayActionsEventQueryVariables,
    token: string | null | undefined
): Promise<UserOverlayActionsEventQuery> {
    return executeQuery<UserOverlayActionsEventQuery>(Queries.UserOverlayActionsEvent, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CustomDocumentPopulationFragment, Fragments.UserInfoOverlayFragment]
    });
}

export function useUserOverlayActionsOrganizationQuery(
    args: UserOverlayActionsOrganizationQueryVariables
): IUseQueryReturns<UserOverlayActionsOrganizationQuery> {
    return useQuery(Queries.UserOverlayActionsOrganization, args, [
        Fragments.UserInfoOverlayFragment
    ]);
}

export function executeUserOverlayActionsOrganizationQuery(
    args: UserOverlayActionsOrganizationQueryVariables,
    token: string | null | undefined
): Promise<UserOverlayActionsOrganizationQuery> {
    return executeQuery<UserOverlayActionsOrganizationQuery>(
        Queries.UserOverlayActionsOrganization,
        {
            variables: args,
            token: token || undefined,
            fragments: [Fragments.UserInfoOverlayFragment]
        }
    );
}

export function useUserHistoryCampaignsQuery(
    args: UserHistoryCampaignsQueryVariables
): IUseQueryReturns<UserHistoryCampaignsQuery> {
    return useQuery(Queries.UserHistoryCampaigns, args, []);
}

export function executeUserHistoryCampaignsQuery(
    args: UserHistoryCampaignsQueryVariables,
    token: string | null | undefined
): Promise<UserHistoryCampaignsQuery> {
    return executeQuery<UserHistoryCampaignsQuery>(Queries.UserHistoryCampaigns, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useUserHistoryEventsQuery(
    args: UserHistoryEventsQueryVariables
): IUseQueryReturns<UserHistoryEventsQuery> {
    return useQuery(Queries.UserHistoryEvents, args, []);
}

export function executeUserHistoryEventsQuery(
    args: UserHistoryEventsQueryVariables,
    token: string | null | undefined
): Promise<UserHistoryEventsQuery> {
    return executeQuery<UserHistoryEventsQuery>(Queries.UserHistoryEvents, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useUserHistoryFormsQuery(
    args: UserHistoryFormsQueryVariables
): IUseQueryReturns<UserHistoryFormsQuery> {
    return useQuery(Queries.UserHistoryForms, args, []);
}

export function executeUserHistoryFormsQuery(
    args: UserHistoryFormsQueryVariables,
    token: string | null | undefined
): Promise<UserHistoryFormsQuery> {
    return executeQuery<UserHistoryFormsQuery>(Queries.UserHistoryForms, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useEventProfilePrivateFieldsUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    EventProfilePrivateFieldsUpdateMutation,
    EventProfilePrivateFieldsUpdateMutationVariables
> {
    return useMutation(Mutations.EventProfilePrivateFieldsUpdate, args);
}

export function useOrganizationProfilePrivateFieldsUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    OrganizationProfilePrivateFieldsUpdateMutation,
    OrganizationProfilePrivateFieldsUpdateMutationVariables
> {
    return useMutation(Mutations.OrganizationProfilePrivateFieldsUpdate, args);
}

export function useUserInformationsEventQuery(
    args: UserInformationsEventQueryVariables
): IUseQueryReturns<UserInformationsEventQuery> {
    return useQuery(Queries.UserInformationsEvent, args, [
        Fragments.CustomFieldWithConditionFragment,
        Fragments.UserInfoOverlayFragment,
        Fragments.FormUserInfoUserProfileFragment,
        Fragments.FormUserOverlayFragment,
        Fragments.DelegationUserProfileFragment
    ]);
}

export function executeUserInformationsEventQuery(
    args: UserInformationsEventQueryVariables,
    token: string | null | undefined
): Promise<UserInformationsEventQuery> {
    return executeQuery<UserInformationsEventQuery>(Queries.UserInformationsEvent, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.CustomFieldWithConditionFragment,
            Fragments.UserInfoOverlayFragment,
            Fragments.FormUserInfoUserProfileFragment,
            Fragments.FormUserOverlayFragment,
            Fragments.DelegationUserProfileFragment
        ]
    });
}

export function useUserInformationsOrganizationQuery(
    args: UserInformationsOrganizationQueryVariables
): IUseQueryReturns<UserInformationsOrganizationQuery> {
    return useQuery(Queries.UserInformationsOrganization, args, [
        Fragments.CustomFieldWithConditionFragment,
        Fragments.FormUserOverlayFragment,
        Fragments.UserInfoOverlayFragment,
        Fragments.DelegationUserProfileFragment,
        Fragments.FormUserInfoUserProfileFragment
    ]);
}

export function executeUserInformationsOrganizationQuery(
    args: UserInformationsOrganizationQueryVariables,
    token: string | null | undefined
): Promise<UserInformationsOrganizationQuery> {
    return executeQuery<UserInformationsOrganizationQuery>(Queries.UserInformationsOrganization, {
        variables: args,
        token: token || undefined,
        fragments: [
            Fragments.CustomFieldWithConditionFragment,
            Fragments.FormUserOverlayFragment,
            Fragments.UserInfoOverlayFragment,
            Fragments.DelegationUserProfileFragment,
            Fragments.FormUserInfoUserProfileFragment
        ]
    });
}

export function useVolunteerRegistrationTicketIdRegenerateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    VolunteerRegistrationTicketIdRegenerateMutation,
    VolunteerRegistrationTicketIdRegenerateMutationVariables
> {
    return useMutation(Mutations.VolunteerRegistrationTicketIdRegenerate, args);
}

export function useUserPositionsAvailablePositionsSlotsQuery(
    args: UserPositionsAvailablePositionsSlotsQueryVariables
): IUseQueryReturns<UserPositionsAvailablePositionsSlotsQuery> {
    return useQuery(Queries.UserPositionsAvailablePositionsSlots, args, []);
}

export function executeUserPositionsAvailablePositionsSlotsQuery(
    args: UserPositionsAvailablePositionsSlotsQueryVariables,
    token: string | null | undefined
): Promise<UserPositionsAvailablePositionsSlotsQuery> {
    return executeQuery<UserPositionsAvailablePositionsSlotsQuery>(
        Queries.UserPositionsAvailablePositionsSlots,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useUserOverlayQuery(
    args: UserOverlayQueryVariables
): IUseQueryReturns<UserOverlayQuery> {
    return useQuery(Queries.UserOverlay, args, [Fragments.UserInfoOverlayFragment]);
}

export function executeUserOverlayQuery(
    args: UserOverlayQueryVariables,
    token: string | null | undefined
): Promise<UserOverlayQuery> {
    return executeQuery<UserOverlayQuery>(Queries.UserOverlay, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.UserInfoOverlayFragment]
    });
}

export function useCommentCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CommentCreateMutation, CommentCreateMutationVariables> {
    return useMutation(Mutations.CommentCreate, args);
}

export function useCommentDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<CommentDeleteMutation, CommentDeleteMutationVariables> {
    return useMutation(Mutations.CommentDelete, args);
}

export function useCommentsQuery(args: CommentsQueryVariables): IUseQueryReturns<CommentsQuery> {
    return useQuery(Queries.Comments, args, [Fragments.CommentFragment]);
}

export function executeCommentsQuery(
    args: CommentsQueryVariables,
    token: string | null | undefined
): Promise<CommentsQuery> {
    return executeQuery<CommentsQuery>(Queries.Comments, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CommentFragment]
    });
}

export function useUpdateUserInfosEventQuery(
    args: UpdateUserInfosEventQueryVariables
): IUseQueryReturns<UpdateUserInfosEventQuery> {
    return useQuery(Queries.UpdateUserInfosEvent, args, [
        Fragments.CustomFieldWithConditionFragment,
        Fragments.UpdateUserFormFragment
    ]);
}

export function executeUpdateUserInfosEventQuery(
    args: UpdateUserInfosEventQueryVariables,
    token: string | null | undefined
): Promise<UpdateUserInfosEventQuery> {
    return executeQuery<UpdateUserInfosEventQuery>(Queries.UpdateUserInfosEvent, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CustomFieldWithConditionFragment, Fragments.UpdateUserFormFragment]
    });
}

export function useUpdateUserInfosOrganizationQuery(
    args: UpdateUserInfosOrganizationQueryVariables
): IUseQueryReturns<UpdateUserInfosOrganizationQuery> {
    return useQuery(Queries.UpdateUserInfosOrganization, args, [
        Fragments.CustomFieldWithConditionFragment,
        Fragments.UpdateUserFormFragment
    ]);
}

export function executeUpdateUserInfosOrganizationQuery(
    args: UpdateUserInfosOrganizationQueryVariables,
    token: string | null | undefined
): Promise<UpdateUserInfosOrganizationQuery> {
    return executeQuery<UpdateUserInfosOrganizationQuery>(Queries.UpdateUserInfosOrganization, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CustomFieldWithConditionFragment, Fragments.UpdateUserFormFragment]
    });
}

export function useOrganizationUsersInfosQuery(
    args: OrganizationUsersInfosQueryVariables
): IUseQueryReturns<OrganizationUsersInfosQuery> {
    return useQuery(Queries.OrganizationUsersInfos, args, [Fragments.ExistingVolunteerFragment]);
}

export function executeOrganizationUsersInfosQuery(
    args: OrganizationUsersInfosQueryVariables,
    token: string | null | undefined
): Promise<OrganizationUsersInfosQuery> {
    return executeQuery<OrganizationUsersInfosQuery>(Queries.OrganizationUsersInfos, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.ExistingVolunteerFragment]
    });
}

export function useUserInfoAdminCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UserInfoAdminCreateMutation, UserInfoAdminCreateMutationVariables> {
    return useMutation(Mutations.UserInfoAdminCreate, args);
}

export function useVolunteersRegistrationsAdminAddMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    VolunteersRegistrationsAdminAddMutation,
    VolunteersRegistrationsAdminAddMutationVariables
> {
    return useMutation(Mutations.VolunteersRegistrationsAdminAdd, args);
}

export function useUsersInfosExportMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UsersInfosExportMutation, UsersInfosExportMutationVariables> {
    return useMutation(Mutations.UsersInfosExport, args);
}

export function useVolunteersExportMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<VolunteersExportMutation, VolunteersExportMutationVariables> {
    return useMutation(Mutations.VolunteersExport, args);
}

export function useEventVolunteersImportInfosQuery(
    args: EventVolunteersImportInfosQueryVariables
): IUseQueryReturns<EventVolunteersImportInfosQuery> {
    return useQuery(Queries.EventVolunteersImportInfos, args, [
        Fragments.CustomFieldImportFragment,
        Fragments.AccreditationImportFragment
    ]);
}

export function executeEventVolunteersImportInfosQuery(
    args: EventVolunteersImportInfosQueryVariables,
    token: string | null | undefined
): Promise<EventVolunteersImportInfosQuery> {
    return executeQuery<EventVolunteersImportInfosQuery>(Queries.EventVolunteersImportInfos, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CustomFieldImportFragment, Fragments.AccreditationImportFragment]
    });
}

export function useOrganizationImportInfosQuery(
    args: OrganizationImportInfosQueryVariables
): IUseQueryReturns<OrganizationImportInfosQuery> {
    return useQuery(Queries.OrganizationImportInfos, args, [Fragments.CustomFieldImportFragment]);
}

export function executeOrganizationImportInfosQuery(
    args: OrganizationImportInfosQueryVariables,
    token: string | null | undefined
): Promise<OrganizationImportInfosQuery> {
    return executeQuery<OrganizationImportInfosQuery>(Queries.OrganizationImportInfos, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.CustomFieldImportFragment]
    });
}

export function useVolunteersAccreditationsMatrixQuery(
    args: VolunteersAccreditationsMatrixQueryVariables
): IUseQueryReturns<VolunteersAccreditationsMatrixQuery> {
    return useQuery(Queries.VolunteersAccreditationsMatrix, args, []);
}

export function executeVolunteersAccreditationsMatrixQuery(
    args: VolunteersAccreditationsMatrixQueryVariables,
    token: string | null | undefined
): Promise<VolunteersAccreditationsMatrixQuery> {
    return executeQuery<VolunteersAccreditationsMatrixQuery>(
        Queries.VolunteersAccreditationsMatrix,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useVolunteersPlanningQuery(
    args: VolunteersPlanningQueryVariables
): IUseQueryReturns<VolunteersPlanningQuery> {
    return useQuery(Queries.VolunteersPlanning, args, [Fragments.DocumentUsersPlanningFragment]);
}

export function executeVolunteersPlanningQuery(
    args: VolunteersPlanningQueryVariables,
    token: string | null | undefined
): Promise<VolunteersPlanningQuery> {
    return executeQuery<VolunteersPlanningQuery>(Queries.VolunteersPlanning, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.DocumentUsersPlanningFragment]
    });
}

export function useVolunteerActionsQuery(
    args: VolunteerActionsQueryVariables
): IUseQueryReturns<VolunteerActionsQuery> {
    return useQuery(Queries.VolunteerActions, args, []);
}

export function executeVolunteerActionsQuery(
    args: VolunteerActionsQueryVariables,
    token: string | null | undefined
): Promise<VolunteerActionsQuery> {
    return executeQuery<VolunteerActionsQuery>(Queries.VolunteerActions, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useVolunteersHeaderQuery(
    args: VolunteersHeaderQueryVariables
): IUseQueryReturns<VolunteersHeaderQuery> {
    return useQuery(Queries.VolunteersHeader, args, []);
}

export function executeVolunteersHeaderQuery(
    args: VolunteersHeaderQueryVariables,
    token: string | null | undefined
): Promise<VolunteersHeaderQuery> {
    return executeQuery<VolunteersHeaderQuery>(Queries.VolunteersHeader, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useMassAssignSlotsQuery(
    args: MassAssignSlotsQueryVariables
): IUseQueryReturns<MassAssignSlotsQuery> {
    return useQuery(Queries.MassAssignSlots, args, []);
}

export function executeMassAssignSlotsQuery(
    args: MassAssignSlotsQueryVariables,
    token: string | null | undefined
): Promise<MassAssignSlotsQuery> {
    return executeQuery<MassAssignSlotsQuery>(Queries.MassAssignSlots, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useVolunteersRegistrationsMassPreAssignMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    VolunteersRegistrationsMassPreAssignMutation,
    VolunteersRegistrationsMassPreAssignMutationVariables
> {
    return useMutation(Mutations.VolunteersRegistrationsMassPreAssign, args);
}

export function useMassDelegationAddOrganizationDelegationsQuery(
    args: MassDelegationAddOrganizationDelegationsQueryVariables
): IUseQueryReturns<MassDelegationAddOrganizationDelegationsQuery> {
    return useQuery(Queries.MassDelegationAddOrganizationDelegations, args, []);
}

export function executeMassDelegationAddOrganizationDelegationsQuery(
    args: MassDelegationAddOrganizationDelegationsQueryVariables,
    token: string | null | undefined
): Promise<MassDelegationAddOrganizationDelegationsQuery> {
    return executeQuery<MassDelegationAddOrganizationDelegationsQuery>(
        Queries.MassDelegationAddOrganizationDelegations,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useUsersInfosMassDelegationAddMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    UsersInfosMassDelegationAddMutation,
    UsersInfosMassDelegationAddMutationVariables
> {
    return useMutation(Mutations.UsersInfosMassDelegationAdd, args);
}

export function useUsersInfosMassFormAddMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<UsersInfosMassFormAddMutation, UsersInfosMassFormAddMutationVariables> {
    return useMutation(Mutations.UsersInfosMassFormAdd, args);
}

export function useVolunteersRegistrationsMassFormAddMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    VolunteersRegistrationsMassFormAddMutation,
    VolunteersRegistrationsMassFormAddMutationVariables
> {
    return useMutation(Mutations.VolunteersRegistrationsMassFormAdd, args);
}

export function useUsersInfosMassFormRemoveMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    UsersInfosMassFormRemoveMutation,
    UsersInfosMassFormRemoveMutationVariables
> {
    return useMutation(Mutations.UsersInfosMassFormRemove, args);
}

export function useVolunteersRegistrationsMassFormRemoveMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<
    VolunteersRegistrationsMassFormRemoveMutation,
    VolunteersRegistrationsMassFormRemoveMutationVariables
> {
    return useMutation(Mutations.VolunteersRegistrationsMassFormRemove, args);
}

export function useMassPreAssignCategoriesQuery(
    args: MassPreAssignCategoriesQueryVariables
): IUseQueryReturns<MassPreAssignCategoriesQuery> {
    return useQuery(Queries.MassPreAssignCategories, args, []);
}

export function executeMassPreAssignCategoriesQuery(
    args: MassPreAssignCategoriesQueryVariables,
    token: string | null | undefined
): Promise<MassPreAssignCategoriesQuery> {
    return executeQuery<MassPreAssignCategoriesQuery>(Queries.MassPreAssignCategories, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useMassPreAssignPositionsQuery(
    args: MassPreAssignPositionsQueryVariables
): IUseQueryReturns<MassPreAssignPositionsQuery> {
    return useQuery(Queries.MassPreAssignPositions, args, []);
}

export function executeMassPreAssignPositionsQuery(
    args: MassPreAssignPositionsQueryVariables,
    token: string | null | undefined
): Promise<MassPreAssignPositionsQuery> {
    return executeQuery<MassPreAssignPositionsQuery>(Queries.MassPreAssignPositions, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useVolunteersMobileQuery(
    args: VolunteersMobileQueryVariables
): IUseQueryReturns<VolunteersMobileQuery> {
    return useQuery(Queries.VolunteersMobile, args, [Fragments.FullPageInfoFragment]);
}

export function executeVolunteersMobileQuery(
    args: VolunteersMobileQueryVariables,
    token: string | null | undefined
): Promise<VolunteersMobileQuery> {
    return executeQuery<VolunteersMobileQuery>(Queries.VolunteersMobile, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.FullPageInfoFragment]
    });
}

export function useVolunteersSegmentsMobileQuery(
    args: VolunteersSegmentsMobileQueryVariables
): IUseQueryReturns<VolunteersSegmentsMobileQuery> {
    return useQuery(Queries.VolunteersSegmentsMobile, args, [
        Fragments.SegmentsFoldersSegmentsFragment
    ]);
}

export function executeVolunteersSegmentsMobileQuery(
    args: VolunteersSegmentsMobileQueryVariables,
    token: string | null | undefined
): Promise<VolunteersSegmentsMobileQuery> {
    return executeQuery<VolunteersSegmentsMobileQuery>(Queries.VolunteersSegmentsMobile, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.SegmentsFoldersSegmentsFragment]
    });
}

export function useRecentVolunteersSearchesMobileQuery(
    args: RecentVolunteersSearchesMobileQueryVariables
): IUseQueryReturns<RecentVolunteersSearchesMobileQuery> {
    return useQuery(Queries.RecentVolunteersSearchesMobile, args, []);
}

export function executeRecentVolunteersSearchesMobileQuery(
    args: RecentVolunteersSearchesMobileQueryVariables,
    token: string | null | undefined
): Promise<RecentVolunteersSearchesMobileQuery> {
    return executeQuery<RecentVolunteersSearchesMobileQuery>(
        Queries.RecentVolunteersSearchesMobile,
        {
            variables: args,
            token: token || undefined,
            fragments: []
        }
    );
}

export function useWorkflowAccreditationsQuery(
    args: WorkflowAccreditationsQueryVariables
): IUseQueryReturns<WorkflowAccreditationsQuery> {
    return useQuery(Queries.WorkflowAccreditations, args, []);
}

export function executeWorkflowAccreditationsQuery(
    args: WorkflowAccreditationsQueryVariables,
    token: string | null | undefined
): Promise<WorkflowAccreditationsQuery> {
    return executeQuery<WorkflowAccreditationsQuery>(Queries.WorkflowAccreditations, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useWorkflowCampaignsQuery(
    args: WorkflowCampaignsQueryVariables
): IUseQueryReturns<WorkflowCampaignsQuery> {
    return useQuery(Queries.WorkflowCampaigns, args, []);
}

export function executeWorkflowCampaignsQuery(
    args: WorkflowCampaignsQueryVariables,
    token: string | null | undefined
): Promise<WorkflowCampaignsQuery> {
    return executeQuery<WorkflowCampaignsQuery>(Queries.WorkflowCampaigns, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useWorkflowCustomFieldsQuery(
    args: WorkflowCustomFieldsQueryVariables
): IUseQueryReturns<WorkflowCustomFieldsQuery> {
    return useQuery(Queries.WorkflowCustomFields, args, [Fragments.MassEditCustomFieldFragment]);
}

export function executeWorkflowCustomFieldsQuery(
    args: WorkflowCustomFieldsQueryVariables,
    token: string | null | undefined
): Promise<WorkflowCustomFieldsQuery> {
    return executeQuery<WorkflowCustomFieldsQuery>(Queries.WorkflowCustomFields, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.MassEditCustomFieldFragment]
    });
}

export function useWorkflowPositionsQuery(
    args: WorkflowPositionsQueryVariables
): IUseQueryReturns<WorkflowPositionsQuery> {
    return useQuery(Queries.WorkflowPositions, args, []);
}

export function executeWorkflowPositionsQuery(
    args: WorkflowPositionsQueryVariables,
    token: string | null | undefined
): Promise<WorkflowPositionsQuery> {
    return executeQuery<WorkflowPositionsQuery>(Queries.WorkflowPositions, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useWorkflowVolunteersSegmentsQuery(
    args: WorkflowVolunteersSegmentsQueryVariables
): IUseQueryReturns<WorkflowVolunteersSegmentsQuery> {
    return useQuery(Queries.WorkflowVolunteersSegments, args, []);
}

export function executeWorkflowVolunteersSegmentsQuery(
    args: WorkflowVolunteersSegmentsQueryVariables,
    token: string | null | undefined
): Promise<WorkflowVolunteersSegmentsQuery> {
    return executeQuery<WorkflowVolunteersSegmentsQuery>(Queries.WorkflowVolunteersSegments, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useWorkflowQuery(args: WorkflowQueryVariables): IUseQueryReturns<WorkflowQuery> {
    return useQuery(Queries.Workflow, args, []);
}

export function executeWorkflowQuery(
    args: WorkflowQueryVariables,
    token: string | null | undefined
): Promise<WorkflowQuery> {
    return executeQuery<WorkflowQuery>(Queries.Workflow, {
        variables: args,
        token: token || undefined,
        fragments: []
    });
}

export function useWorkflowCreateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<WorkflowCreateMutation, WorkflowCreateMutationVariables> {
    return useMutation(Mutations.WorkflowCreate, args);
}

export function useWorkflowUpdateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<WorkflowUpdateMutation, WorkflowUpdateMutationVariables> {
    return useMutation(Mutations.WorkflowUpdate, args);
}

export function useWorkflowssMassDeleteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<WorkflowssMassDeleteMutation, WorkflowssMassDeleteMutationVariables> {
    return useMutation(Mutations.WorkflowssMassDelete, args);
}

export function useWorkflowDuplicateMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<WorkflowDuplicateMutation, WorkflowDuplicateMutationVariables> {
    return useMutation(Mutations.WorkflowDuplicate, args);
}

export function useWorkflowExecuteMutation(
    args: IUseMutationOptions = {}
): IUseMutationReturns<WorkflowExecuteMutation, WorkflowExecuteMutationVariables> {
    return useMutation(Mutations.WorkflowExecute, args);
}

export function useWorkflowsQuery(args: WorkflowsQueryVariables): IUseQueryReturns<WorkflowsQuery> {
    return useQuery(Queries.Workflows, args, [Fragments.WorkflowsWorkflowFragment]);
}

export function executeWorkflowsQuery(
    args: WorkflowsQueryVariables,
    token: string | null | undefined
): Promise<WorkflowsQuery> {
    return executeQuery<WorkflowsQuery>(Queries.Workflows, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.WorkflowsWorkflowFragment]
    });
}

export function useWorkflowsWorkflowQuery(
    args: WorkflowsWorkflowQueryVariables
): IUseQueryReturns<WorkflowsWorkflowQuery> {
    return useQuery(Queries.WorkflowsWorkflow, args, [Fragments.WorkflowsWorkflowFragment]);
}

export function executeWorkflowsWorkflowQuery(
    args: WorkflowsWorkflowQueryVariables,
    token: string | null | undefined
): Promise<WorkflowsWorkflowQuery> {
    return executeQuery<WorkflowsWorkflowQuery>(Queries.WorkflowsWorkflow, {
        variables: args,
        token: token || undefined,
        fragments: [Fragments.WorkflowsWorkflowFragment]
    });
}
